// AUTO-GENERATED by scripts/compute-puppy-anchors.py — do not hand edit.
// Per-frame normalised pivot (nose tip) for each atlas key. Look up
// by `PUPPY_ANCHORS[atlasKey]?.[frameName]`; set sprite origin to
// (x, y) and position to the canvas spot where the nose should land.
// PUPPY_MAX_DIM gives the per-puppy reference dimension (in source
// pixels) used to pick a uniform setScale value so frames keep their
// natural aspect ratio — no squashing.

export interface NormalisedAnchor { x: number; y: number; }

export const PUPPY_ANCHORS: Record<string, Record<string, NormalisedAnchor>> = {
  "puppieslg": {
    "puppy0@2x.png": {
      "x": 0.5049,
      "y": 0.5571
    },
    "puppy10@2x.png": {
      "x": 0.4837,
      "y": 0.5424
    },
    "puppy1@2x.png": {
      "x": 0.5434,
      "y": 0.5682
    },
    "puppy2@2x.png": {
      "x": 0.4917,
      "y": 0.5187
    },
    "puppy3@2x.png": {
      "x": 0.501,
      "y": 0.4802
    },
    "puppy4@2x.png": {
      "x": 0.4722,
      "y": 0.5197
    },
    "puppy5@2x.png": {
      "x": 0.5018,
      "y": 0.4613
    },
    "puppy6@2x.png": {
      "x": 0.5317,
      "y": 0.465
    },
    "puppy7@2x.png": {
      "x": 0.5045,
      "y": 0.5227
    },
    "puppy8@2x.png": {
      "x": 0.4313,
      "y": 0.5175
    },
    "puppy9@2x.png": {
      "x": 0.5326,
      "y": 0.5427
    }
  },
  "p10a1": {
    "frame1": {
      "x": 0.4829,
      "y": 0.5074
    },
    "frame43": {
      "x": 0.4829,
      "y": 0.5074
    },
    "frame10": {
      "x": 0.4831,
      "y": 0.508
    },
    "frame11": {
      "x": 0.4831,
      "y": 0.508
    },
    "frame9": {
      "x": 0.4831,
      "y": 0.508
    },
    "frame12": {
      "x": 0.4833,
      "y": 0.5058
    },
    "frame13": {
      "x": 0.4831,
      "y": 0.5057
    },
    "frame14": {
      "x": 0.4836,
      "y": 0.5065
    },
    "frame15": {
      "x": 0.4835,
      "y": 0.5064
    },
    "frame16": {
      "x": 0.4834,
      "y": 0.507
    },
    "frame17": {
      "x": 0.4834,
      "y": 0.507
    },
    "frame18": {
      "x": 0.4834,
      "y": 0.507
    },
    "frame19": {
      "x": 0.4834,
      "y": 0.507
    },
    "frame20": {
      "x": 0.4834,
      "y": 0.507
    },
    "frame21": {
      "x": 0.4834,
      "y": 0.507
    },
    "frame2": {
      "x": 0.4831,
      "y": 0.5054
    },
    "frame22": {
      "x": 0.4834,
      "y": 0.507
    },
    "frame23": {
      "x": 0.4833,
      "y": 0.5066
    },
    "frame24": {
      "x": 0.4833,
      "y": 0.5079
    },
    "frame25": {
      "x": 0.483,
      "y": 0.5076
    },
    "frame26": {
      "x": 0.483,
      "y": 0.5079
    },
    "frame27": {
      "x": 0.4831,
      "y": 0.508
    },
    "frame28": {
      "x": 0.483,
      "y": 0.5056
    },
    "frame29": {
      "x": 0.4832,
      "y": 0.5059
    },
    "frame3": {
      "x": 0.4831,
      "y": 0.5055
    },
    "frame30": {
      "x": 0.4837,
      "y": 0.5065
    },
    "frame31": {
      "x": 0.4833,
      "y": 0.506
    },
    "frame32": {
      "x": 0.4835,
      "y": 0.5062
    },
    "frame33": {
      "x": 0.4834,
      "y": 0.507
    },
    "frame34": {
      "x": 0.4831,
      "y": 0.5062
    },
    "frame35": {
      "x": 0.4834,
      "y": 0.5071
    },
    "frame36": {
      "x": 0.4829,
      "y": 0.5088
    },
    "frame37": {
      "x": 0.4826,
      "y": 0.5084
    },
    "frame38": {
      "x": 0.4832,
      "y": 0.5068
    },
    "frame39": {
      "x": 0.4831,
      "y": 0.505
    },
    "frame4": {
      "x": 0.4829,
      "y": 0.5056
    },
    "frame40": {
      "x": 0.483,
      "y": 0.5073
    },
    "frame41": {
      "x": 0.483,
      "y": 0.5074
    },
    "frame42": {
      "x": 0.483,
      "y": 0.5072
    },
    "frame5": {
      "x": 0.4827,
      "y": 0.5057
    },
    "frame6": {
      "x": 0.4825,
      "y": 0.5081
    },
    "frame7": {
      "x": 0.483,
      "y": 0.5077
    },
    "frame8": {
      "x": 0.4831,
      "y": 0.5082
    }
  },
  "p10a2": {
    "frame1": {
      "x": 0.4836,
      "y": 0.508
    },
    "frame67": {
      "x": 0.4836,
      "y": 0.508
    },
    "frame10": {
      "x": 0.4864,
      "y": 0.503
    },
    "frame11": {
      "x": 0.4817,
      "y": 0.5021
    },
    "frame12": {
      "x": 0.4843,
      "y": 0.4998
    },
    "frame13": {
      "x": 0.4828,
      "y": 0.4982
    },
    "frame14": {
      "x": 0.4836,
      "y": 0.495
    },
    "frame15": {
      "x": 0.4836,
      "y": 0.4949
    },
    "frame16": {
      "x": 0.4804,
      "y": 0.4939
    },
    "frame17": {
      "x": 0.4826,
      "y": 0.4945
    },
    "frame18": {
      "x": 0.4824,
      "y": 0.4941
    },
    "frame19": {
      "x": 0.4828,
      "y": 0.4943
    },
    "frame2": {
      "x": 0.4836,
      "y": 0.5084
    },
    "frame20": {
      "x": 0.482,
      "y": 0.4948
    },
    "frame21": {
      "x": 0.4818,
      "y": 0.4945
    },
    "frame22": {
      "x": 0.4817,
      "y": 0.4938
    },
    "frame23": {
      "x": 0.4825,
      "y": 0.4944
    },
    "frame24": {
      "x": 0.4787,
      "y": 0.4946
    },
    "frame25": {
      "x": 0.4787,
      "y": 0.4949
    },
    "frame26": {
      "x": 0.482,
      "y": 0.4935
    },
    "frame27": {
      "x": 0.4822,
      "y": 0.4947
    },
    "frame28": {
      "x": 0.4823,
      "y": 0.4971
    },
    "frame29": {
      "x": 0.4818,
      "y": 0.4983
    },
    "frame3": {
      "x": 0.4836,
      "y": 0.5083
    },
    "frame30": {
      "x": 0.4813,
      "y": 0.5016
    },
    "frame31": {
      "x": 0.4827,
      "y": 0.4985
    },
    "frame32": {
      "x": 0.4798,
      "y": 0.4987
    },
    "frame33": {
      "x": 0.481,
      "y": 0.4987
    },
    "frame34": {
      "x": 0.48,
      "y": 0.4982
    },
    "frame35": {
      "x": 0.481,
      "y": 0.4996
    },
    "frame36": {
      "x": 0.4827,
      "y": 0.4998
    },
    "frame37": {
      "x": 0.4822,
      "y": 0.4993
    },
    "frame38": {
      "x": 0.4825,
      "y": 0.4985
    },
    "frame39": {
      "x": 0.4781,
      "y": 0.4999
    },
    "frame4": {
      "x": 0.484,
      "y": 0.508
    },
    "frame40": {
      "x": 0.4788,
      "y": 0.4994
    },
    "frame41": {
      "x": 0.4785,
      "y": 0.4981
    },
    "frame49": {
      "x": 0.4816,
      "y": 0.4976
    },
    "frame5": {
      "x": 0.4839,
      "y": 0.5088
    },
    "frame50": {
      "x": 0.4792,
      "y": 0.4987
    },
    "frame51": {
      "x": 0.4837,
      "y": 0.5032
    },
    "frame52": {
      "x": 0.4812,
      "y": 0.5047
    },
    "frame53": {
      "x": 0.48,
      "y": 0.503
    },
    "frame6": {
      "x": 0.4821,
      "y": 0.5086
    },
    "frame61": {
      "x": 0.4844,
      "y": 0.5017
    },
    "frame62": {
      "x": 0.484,
      "y": 0.5057
    },
    "frame63": {
      "x": 0.4837,
      "y": 0.5068
    },
    "frame64": {
      "x": 0.4839,
      "y": 0.5072
    },
    "frame65": {
      "x": 0.4838,
      "y": 0.508
    },
    "frame66": {
      "x": 0.4836,
      "y": 0.5078
    },
    "frame7": {
      "x": 0.4836,
      "y": 0.5088
    },
    "frame8": {
      "x": 0.4832,
      "y": 0.5072
    },
    "frame9": {
      "x": 0.4805,
      "y": 0.5058
    },
    "frame42": {
      "x": 0.4817,
      "y": 0.4971
    },
    "frame43": {
      "x": 0.4828,
      "y": 0.4962
    },
    "frame44": {
      "x": 0.4842,
      "y": 0.4958
    },
    "frame45": {
      "x": 0.4845,
      "y": 0.4962
    },
    "frame46": {
      "x": 0.4824,
      "y": 0.4962
    },
    "frame47": {
      "x": 0.4823,
      "y": 0.4963
    },
    "frame48": {
      "x": 0.485,
      "y": 0.4981
    },
    "frame54": {
      "x": 0.4807,
      "y": 0.5034
    },
    "frame55": {
      "x": 0.4817,
      "y": 0.5033
    },
    "frame56": {
      "x": 0.4831,
      "y": 0.5012
    },
    "frame57": {
      "x": 0.4826,
      "y": 0.5008
    },
    "frame58": {
      "x": 0.4815,
      "y": 0.5007
    },
    "frame59": {
      "x": 0.4847,
      "y": 0.5032
    },
    "frame60": {
      "x": 0.4856,
      "y": 0.5035
    }
  },
  "p10a3": {
    "frame6": {
      "x": 0.481,
      "y": 0.513
    },
    "frame7": {
      "x": 0.4793,
      "y": 0.5133
    },
    "frame54": {
      "x": 0.4817,
      "y": 0.5076
    },
    "frame55": {
      "x": 0.4817,
      "y": 0.5071
    },
    "frame56": {
      "x": 0.4812,
      "y": 0.5066
    },
    "frame57": {
      "x": 0.4813,
      "y": 0.5044
    },
    "frame58": {
      "x": 0.4831,
      "y": 0.5054
    },
    "frame59": {
      "x": 0.4835,
      "y": 0.5057
    },
    "frame60": {
      "x": 0.4834,
      "y": 0.5052
    },
    "frame2": {
      "x": 0.4829,
      "y": 0.5086
    },
    "frame3": {
      "x": 0.4821,
      "y": 0.5099
    },
    "frame4": {
      "x": 0.4775,
      "y": 0.5118
    },
    "frame5": {
      "x": 0.4768,
      "y": 0.5146
    },
    "frame53": {
      "x": 0.4854,
      "y": 0.5064
    },
    "frame61": {
      "x": 0.4866,
      "y": 0.5068
    },
    "frame62": {
      "x": 0.487,
      "y": 0.5074
    },
    "frame8": {
      "x": 0.4812,
      "y": 0.5131
    },
    "frame9": {
      "x": 0.4798,
      "y": 0.5111
    },
    "frame1": {
      "x": 0.4836,
      "y": 0.508
    },
    "frame63": {
      "x": 0.4836,
      "y": 0.508
    },
    "frame10": {
      "x": 0.4813,
      "y": 0.5091
    },
    "frame52": {
      "x": 0.4805,
      "y": 0.5108
    },
    "frame11": {
      "x": 0.4783,
      "y": 0.5062
    },
    "frame12": {
      "x": 0.4797,
      "y": 0.5062
    },
    "frame51": {
      "x": 0.4792,
      "y": 0.5108
    },
    "frame13": {
      "x": 0.4804,
      "y": 0.5076
    },
    "frame50": {
      "x": 0.4816,
      "y": 0.5111
    },
    "frame14": {
      "x": 0.4806,
      "y": 0.5078
    },
    "frame49": {
      "x": 0.4858,
      "y": 0.5082
    },
    "frame15": {
      "x": 0.4846,
      "y": 0.5091
    },
    "frame48": {
      "x": 0.483,
      "y": 0.5075
    },
    "frame16": {
      "x": 0.4831,
      "y": 0.5092
    },
    "frame17": {
      "x": 0.4809,
      "y": 0.5098
    },
    "frame18": {
      "x": 0.4857,
      "y": 0.5088
    },
    "frame19": {
      "x": 0.4855,
      "y": 0.5087
    },
    "frame20": {
      "x": 0.4858,
      "y": 0.5101
    },
    "frame47": {
      "x": 0.4874,
      "y": 0.5047
    },
    "frame21": {
      "x": 0.4837,
      "y": 0.5105
    },
    "frame22": {
      "x": 0.483,
      "y": 0.5117
    },
    "frame23": {
      "x": 0.483,
      "y": 0.5114
    },
    "frame24": {
      "x": 0.4835,
      "y": 0.5112
    },
    "frame25": {
      "x": 0.4841,
      "y": 0.5112
    },
    "frame26": {
      "x": 0.4848,
      "y": 0.5099
    },
    "frame27": {
      "x": 0.4852,
      "y": 0.5091
    },
    "frame28": {
      "x": 0.4858,
      "y": 0.5081
    },
    "frame38": {
      "x": 0.4801,
      "y": 0.5046
    },
    "frame39": {
      "x": 0.4787,
      "y": 0.5083
    },
    "frame46": {
      "x": 0.4819,
      "y": 0.5015
    },
    "frame29": {
      "x": 0.4825,
      "y": 0.5079
    },
    "frame30": {
      "x": 0.4801,
      "y": 0.5102
    },
    "frame31": {
      "x": 0.4813,
      "y": 0.5095
    },
    "frame32": {
      "x": 0.4827,
      "y": 0.5101
    },
    "frame33": {
      "x": 0.4826,
      "y": 0.5093
    },
    "frame34": {
      "x": 0.4832,
      "y": 0.509
    },
    "frame35": {
      "x": 0.4833,
      "y": 0.5071
    },
    "frame36": {
      "x": 0.4841,
      "y": 0.5071
    },
    "frame37": {
      "x": 0.4831,
      "y": 0.5071
    },
    "frame40": {
      "x": 0.4806,
      "y": 0.5085
    },
    "frame41": {
      "x": 0.4792,
      "y": 0.5034
    },
    "frame42": {
      "x": 0.4812,
      "y": 0.4956
    },
    "frame43": {
      "x": 0.4821,
      "y": 0.4963
    },
    "frame44": {
      "x": 0.4825,
      "y": 0.4976
    },
    "frame45": {
      "x": 0.483,
      "y": 0.4993
    }
  },
  "p10a4": {
    "frame23": {
      "x": 0.4807,
      "y": 0.5281
    },
    "frame24": {
      "x": 0.4806,
      "y": 0.5289
    },
    "frame25": {
      "x": 0.4787,
      "y": 0.5276
    },
    "frame26": {
      "x": 0.4779,
      "y": 0.5253
    },
    "frame27": {
      "x": 0.4791,
      "y": 0.5256
    },
    "frame51": {
      "x": 0.4858,
      "y": 0.5145
    },
    "frame28": {
      "x": 0.4789,
      "y": 0.5268
    },
    "frame29": {
      "x": 0.481,
      "y": 0.5241
    },
    "frame30": {
      "x": 0.4816,
      "y": 0.5189
    },
    "frame31": {
      "x": 0.4823,
      "y": 0.5148
    },
    "frame32": {
      "x": 0.4825,
      "y": 0.5076
    },
    "frame52": {
      "x": 0.4854,
      "y": 0.5162
    },
    "frame33": {
      "x": 0.484,
      "y": 0.509
    },
    "frame34": {
      "x": 0.4838,
      "y": 0.5088
    },
    "frame1": {
      "x": 0.4836,
      "y": 0.508
    },
    "frame70": {
      "x": 0.4836,
      "y": 0.508
    },
    "frame10": {
      "x": 0.4835,
      "y": 0.5113
    },
    "frame11": {
      "x": 0.4838,
      "y": 0.5124
    },
    "frame35": {
      "x": 0.4847,
      "y": 0.5089
    },
    "frame12": {
      "x": 0.4831,
      "y": 0.513
    },
    "frame13": {
      "x": 0.482,
      "y": 0.5151
    },
    "frame14": {
      "x": 0.4811,
      "y": 0.5143
    },
    "frame15": {
      "x": 0.4799,
      "y": 0.5157
    },
    "frame47": {
      "x": 0.4832,
      "y": 0.5035
    },
    "frame36": {
      "x": 0.486,
      "y": 0.508
    },
    "frame16": {
      "x": 0.4791,
      "y": 0.5181
    },
    "frame17": {
      "x": 0.4804,
      "y": 0.5185
    },
    "frame18": {
      "x": 0.4802,
      "y": 0.5212
    },
    "frame19": {
      "x": 0.4791,
      "y": 0.5246
    },
    "frame2": {
      "x": 0.4836,
      "y": 0.508
    },
    "frame48": {
      "x": 0.4842,
      "y": 0.5068
    },
    "frame20": {
      "x": 0.4793,
      "y": 0.5266
    },
    "frame21": {
      "x": 0.4793,
      "y": 0.5294
    },
    "frame22": {
      "x": 0.4795,
      "y": 0.5281
    },
    "frame3": {
      "x": 0.4835,
      "y": 0.5085
    },
    "frame4": {
      "x": 0.4836,
      "y": 0.5061
    },
    "frame49": {
      "x": 0.4848,
      "y": 0.5092
    },
    "frame5": {
      "x": 0.4838,
      "y": 0.5063
    },
    "frame53": {
      "x": 0.483,
      "y": 0.5106
    },
    "frame54": {
      "x": 0.4876,
      "y": 0.5084
    },
    "frame55": {
      "x": 0.481,
      "y": 0.5044
    },
    "frame56": {
      "x": 0.4839,
      "y": 0.5027
    },
    "frame50": {
      "x": 0.4875,
      "y": 0.5141
    },
    "frame57": {
      "x": 0.4845,
      "y": 0.5056
    },
    "frame6": {
      "x": 0.4837,
      "y": 0.5073
    },
    "frame62": {
      "x": 0.4841,
      "y": 0.5087
    },
    "frame63": {
      "x": 0.4836,
      "y": 0.5103
    },
    "frame64": {
      "x": 0.4836,
      "y": 0.5101
    },
    "frame65": {
      "x": 0.4837,
      "y": 0.5104
    },
    "frame66": {
      "x": 0.4837,
      "y": 0.5099
    },
    "frame67": {
      "x": 0.4848,
      "y": 0.5083
    },
    "frame68": {
      "x": 0.484,
      "y": 0.5082
    },
    "frame69": {
      "x": 0.4835,
      "y": 0.5078
    },
    "frame7": {
      "x": 0.4837,
      "y": 0.5082
    },
    "frame8": {
      "x": 0.4835,
      "y": 0.5122
    },
    "frame9": {
      "x": 0.4832,
      "y": 0.5134
    },
    "frame37": {
      "x": 0.4836,
      "y": 0.5147
    },
    "frame58": {
      "x": 0.4843,
      "y": 0.5066
    },
    "frame46": {
      "x": 0.4821,
      "y": 0.5033
    },
    "frame59": {
      "x": 0.4844,
      "y": 0.5078
    },
    "frame60": {
      "x": 0.484,
      "y": 0.5085
    },
    "frame61": {
      "x": 0.4841,
      "y": 0.5091
    },
    "frame38": {
      "x": 0.4814,
      "y": 0.5214
    },
    "frame39": {
      "x": 0.482,
      "y": 0.5182
    },
    "frame44": {
      "x": 0.4773,
      "y": 0.5021
    },
    "frame40": {
      "x": 0.4773,
      "y": 0.5196
    },
    "frame45": {
      "x": 0.4781,
      "y": 0.5023
    },
    "frame41": {
      "x": 0.4768,
      "y": 0.5117
    },
    "frame42": {
      "x": 0.4821,
      "y": 0.5068
    },
    "frame43": {
      "x": 0.4808,
      "y": 0.5065
    }
  },
  "p10a5": {
    "frame44": {
      "x": 0.4955,
      "y": 0.4804
    },
    "frame45": {
      "x": 0.4959,
      "y": 0.5071
    },
    "frame46": {
      "x": 0.4935,
      "y": 0.513
    },
    "frame43": {
      "x": 0.4899,
      "y": 0.5027
    },
    "frame47": {
      "x": 0.4854,
      "y": 0.5152
    },
    "frame42": {
      "x": 0.4851,
      "y": 0.5159
    },
    "frame1": {
      "x": 0.4827,
      "y": 0.5116
    },
    "frame2": {
      "x": 0.4826,
      "y": 0.5096
    },
    "frame24": {
      "x": 0.4915,
      "y": 0.518
    },
    "frame25": {
      "x": 0.4827,
      "y": 0.5195
    },
    "frame3": {
      "x": 0.4825,
      "y": 0.5106
    },
    "frame31": {
      "x": 0.4781,
      "y": 0.52
    },
    "frame36": {
      "x": 0.4819,
      "y": 0.5187
    },
    "frame4": {
      "x": 0.4822,
      "y": 0.5125
    },
    "frame5": {
      "x": 0.4828,
      "y": 0.5125
    },
    "frame54": {
      "x": 0.483,
      "y": 0.5108
    },
    "frame55": {
      "x": 0.4821,
      "y": 0.5115
    },
    "frame22": {
      "x": 0.4981,
      "y": 0.5182
    },
    "frame23": {
      "x": 0.4912,
      "y": 0.5187
    },
    "frame26": {
      "x": 0.4808,
      "y": 0.5151
    },
    "frame30": {
      "x": 0.4839,
      "y": 0.5198
    },
    "frame32": {
      "x": 0.48,
      "y": 0.5167
    },
    "frame37": {
      "x": 0.4815,
      "y": 0.516
    },
    "frame38": {
      "x": 0.4786,
      "y": 0.5159
    },
    "frame41": {
      "x": 0.4806,
      "y": 0.5174
    },
    "frame48": {
      "x": 0.4854,
      "y": 0.5092
    },
    "frame52": {
      "x": 0.484,
      "y": 0.5079
    },
    "frame53": {
      "x": 0.4828,
      "y": 0.5085
    },
    "frame19": {
      "x": 0.509,
      "y": 0.5169
    },
    "frame20": {
      "x": 0.5154,
      "y": 0.5192
    },
    "frame21": {
      "x": 0.5064,
      "y": 0.5183
    },
    "frame27": {
      "x": 0.4824,
      "y": 0.5163
    },
    "frame33": {
      "x": 0.4848,
      "y": 0.5165
    },
    "frame35": {
      "x": 0.4847,
      "y": 0.5185
    },
    "frame39": {
      "x": 0.4783,
      "y": 0.514
    },
    "frame40": {
      "x": 0.4766,
      "y": 0.5142
    },
    "frame17": {
      "x": 0.4503,
      "y": 0.5354
    },
    "frame51": {
      "x": 0.484,
      "y": 0.5064
    },
    "frame6": {
      "x": 0.4824,
      "y": 0.5044
    },
    "frame7": {
      "x": 0.4766,
      "y": 0.4993
    },
    "frame10": {
      "x": 0.4771,
      "y": 0.4973
    },
    "frame11": {
      "x": 0.6002,
      "y": 0.4946
    },
    "frame12": {
      "x": 0.6004,
      "y": 0.4954
    },
    "frame18": {
      "x": 0.4846,
      "y": 0.5161
    },
    "frame28": {
      "x": 0.4844,
      "y": 0.5153
    },
    "frame29": {
      "x": 0.487,
      "y": 0.5169
    },
    "frame49": {
      "x": 0.4871,
      "y": 0.5031
    },
    "frame50": {
      "x": 0.4853,
      "y": 0.5068
    },
    "frame9": {
      "x": 0.4756,
      "y": 0.4978
    },
    "frame34": {
      "x": 0.489,
      "y": 0.5201
    },
    "frame8": {
      "x": 0.4749,
      "y": 0.5016
    },
    "frame13": {
      "x": 0.559,
      "y": 0.5045
    },
    "frame16": {
      "x": 0.462,
      "y": 0.5147
    },
    "frame15": {
      "x": 0.4763,
      "y": 0.5135
    },
    "frame14": {
      "x": 0.509,
      "y": 0.5061
    }
  },
  "p1a1": {
    "frame1": {
      "x": 0.5517,
      "y": 0.5468
    },
    "frame27": {
      "x": 0.5517,
      "y": 0.5468
    },
    "frame10": {
      "x": 0.5481,
      "y": 0.55
    },
    "frame11": {
      "x": 0.5482,
      "y": 0.5493
    },
    "frame12": {
      "x": 0.5493,
      "y": 0.5451
    },
    "frame2": {
      "x": 0.5521,
      "y": 0.5453
    },
    "frame13": {
      "x": 0.549,
      "y": 0.5456
    },
    "frame14": {
      "x": 0.5488,
      "y": 0.5447
    },
    "frame15": {
      "x": 0.5488,
      "y": 0.5445
    },
    "frame26": {
      "x": 0.5519,
      "y": 0.5467
    },
    "frame16": {
      "x": 0.549,
      "y": 0.544
    },
    "frame17": {
      "x": 0.5491,
      "y": 0.5437
    },
    "frame18": {
      "x": 0.5488,
      "y": 0.5456
    },
    "frame19": {
      "x": 0.5491,
      "y": 0.5449
    },
    "frame20": {
      "x": 0.5488,
      "y": 0.5481
    },
    "frame21": {
      "x": 0.5487,
      "y": 0.5485
    },
    "frame22": {
      "x": 0.5496,
      "y": 0.5441
    },
    "frame23": {
      "x": 0.5492,
      "y": 0.5437
    },
    "frame24": {
      "x": 0.5489,
      "y": 0.5459
    },
    "frame25": {
      "x": 0.5492,
      "y": 0.5458
    },
    "frame3": {
      "x": 0.5491,
      "y": 0.5451
    },
    "frame4": {
      "x": 0.5486,
      "y": 0.5482
    },
    "frame5": {
      "x": 0.5485,
      "y": 0.5483
    },
    "frame6": {
      "x": 0.548,
      "y": 0.5493
    },
    "frame7": {
      "x": 0.5479,
      "y": 0.5499
    },
    "frame8": {
      "x": 0.5482,
      "y": 0.5496
    },
    "frame9": {
      "x": 0.5481,
      "y": 0.5496
    }
  },
  "p1a2": {
    "frame21": {
      "x": 0.5592,
      "y": 0.5349
    },
    "frame22": {
      "x": 0.5582,
      "y": 0.535
    },
    "frame23": {
      "x": 0.5572,
      "y": 0.5341
    },
    "frame24": {
      "x": 0.5552,
      "y": 0.5345
    },
    "frame25": {
      "x": 0.5562,
      "y": 0.5349
    },
    "frame26": {
      "x": 0.5572,
      "y": 0.5359
    },
    "frame19": {
      "x": 0.557,
      "y": 0.5347
    },
    "frame20": {
      "x": 0.5575,
      "y": 0.5325
    },
    "frame16": {
      "x": 0.5525,
      "y": 0.5359
    },
    "frame17": {
      "x": 0.5541,
      "y": 0.5347
    },
    "frame18": {
      "x": 0.5542,
      "y": 0.5345
    },
    "frame54": {
      "x": 0.557,
      "y": 0.5299
    },
    "frame55": {
      "x": 0.5549,
      "y": 0.5314
    },
    "frame27": {
      "x": 0.5541,
      "y": 0.5374
    },
    "frame52": {
      "x": 0.5551,
      "y": 0.5333
    },
    "frame53": {
      "x": 0.5544,
      "y": 0.5307
    },
    "frame12": {
      "x": 0.5553,
      "y": 0.5363
    },
    "frame13": {
      "x": 0.5565,
      "y": 0.5406
    },
    "frame14": {
      "x": 0.5538,
      "y": 0.5371
    },
    "frame15": {
      "x": 0.553,
      "y": 0.5363
    },
    "frame28": {
      "x": 0.5519,
      "y": 0.5398
    },
    "frame56": {
      "x": 0.5545,
      "y": 0.5319
    },
    "frame57": {
      "x": 0.558,
      "y": 0.5348
    },
    "frame58": {
      "x": 0.5568,
      "y": 0.5383
    },
    "frame48": {
      "x": 0.5492,
      "y": 0.5377
    },
    "frame49": {
      "x": 0.5483,
      "y": 0.5343
    },
    "frame50": {
      "x": 0.5505,
      "y": 0.5351
    },
    "frame51": {
      "x": 0.5516,
      "y": 0.5329
    },
    "frame10": {
      "x": 0.5535,
      "y": 0.5392
    },
    "frame11": {
      "x": 0.5573,
      "y": 0.5359
    },
    "frame9": {
      "x": 0.5527,
      "y": 0.5381
    },
    "frame59": {
      "x": 0.5564,
      "y": 0.541
    },
    "frame47": {
      "x": 0.5485,
      "y": 0.5385
    },
    "frame1": {
      "x": 0.5521,
      "y": 0.5468
    },
    "frame29": {
      "x": 0.5547,
      "y": 0.5441
    },
    "frame8": {
      "x": 0.5553,
      "y": 0.5411
    },
    "frame2": {
      "x": 0.5485,
      "y": 0.5463
    },
    "frame3": {
      "x": 0.5496,
      "y": 0.5462
    },
    "frame4": {
      "x": 0.5509,
      "y": 0.5457
    },
    "frame5": {
      "x": 0.5498,
      "y": 0.5431
    },
    "frame6": {
      "x": 0.5505,
      "y": 0.5438
    },
    "frame60": {
      "x": 0.5579,
      "y": 0.5422
    },
    "frame61": {
      "x": 0.5523,
      "y": 0.5429
    },
    "frame7": {
      "x": 0.5507,
      "y": 0.5419
    },
    "frame62": {
      "x": 0.5503,
      "y": 0.5413
    },
    "frame63": {
      "x": 0.5508,
      "y": 0.5428
    },
    "frame64": {
      "x": 0.551,
      "y": 0.5438
    },
    "frame65": {
      "x": 0.5517,
      "y": 0.5454
    },
    "frame66": {
      "x": 0.552,
      "y": 0.5464
    },
    "frame67": {
      "x": 0.5519,
      "y": 0.5466
    },
    "frame68": {
      "x": 0.5519,
      "y": 0.5468
    },
    "frame46": {
      "x": 0.5435,
      "y": 0.5477
    },
    "frame30": {
      "x": 0.5516,
      "y": 0.5462
    },
    "frame45": {
      "x": 0.5383,
      "y": 0.5487
    },
    "frame31": {
      "x": 0.5511,
      "y": 0.5531
    },
    "frame44": {
      "x": 0.5332,
      "y": 0.5529
    },
    "frame32": {
      "x": 0.551,
      "y": 0.5554
    },
    "frame43": {
      "x": 0.5308,
      "y": 0.5552
    },
    "frame33": {
      "x": 0.5474,
      "y": 0.5585
    },
    "frame42": {
      "x": 0.5283,
      "y": 0.5563
    },
    "frame35": {
      "x": 0.5389,
      "y": 0.5608
    },
    "frame34": {
      "x": 0.5421,
      "y": 0.5604
    },
    "frame39": {
      "x": 0.5256,
      "y": 0.5542
    },
    "frame40": {
      "x": 0.5249,
      "y": 0.5571
    },
    "frame41": {
      "x": 0.5248,
      "y": 0.553
    },
    "frame36": {
      "x": 0.5378,
      "y": 0.5591
    },
    "frame37": {
      "x": 0.5317,
      "y": 0.5585
    },
    "frame38": {
      "x": 0.5301,
      "y": 0.554
    }
  },
  "p1a3": {
    "frame22": {
      "x": 0.5529,
      "y": 0.5275
    },
    "frame23": {
      "x": 0.5519,
      "y": 0.5262
    },
    "frame24": {
      "x": 0.5493,
      "y": 0.5269
    },
    "frame25": {
      "x": 0.5458,
      "y": 0.5281
    },
    "frame26": {
      "x": 0.5517,
      "y": 0.5255
    },
    "frame31": {
      "x": 0.5524,
      "y": 0.5295
    },
    "frame32": {
      "x": 0.5551,
      "y": 0.534
    },
    "frame33": {
      "x": 0.5548,
      "y": 0.5349
    },
    "frame34": {
      "x": 0.5545,
      "y": 0.5356
    },
    "frame35": {
      "x": 0.5536,
      "y": 0.5376
    },
    "frame38": {
      "x": 0.551,
      "y": 0.5489
    },
    "frame10": {
      "x": 0.5541,
      "y": 0.5382
    },
    "frame11": {
      "x": 0.5543,
      "y": 0.5378
    },
    "frame12": {
      "x": 0.5537,
      "y": 0.5371
    },
    "frame13": {
      "x": 0.5548,
      "y": 0.5378
    },
    "frame14": {
      "x": 0.5553,
      "y": 0.5377
    },
    "frame15": {
      "x": 0.5547,
      "y": 0.5373
    },
    "frame16": {
      "x": 0.5547,
      "y": 0.5369
    },
    "frame17": {
      "x": 0.5549,
      "y": 0.5368
    },
    "frame18": {
      "x": 0.5551,
      "y": 0.537
    },
    "frame19": {
      "x": 0.5498,
      "y": 0.5336
    },
    "frame2": {
      "x": 0.5484,
      "y": 0.5451
    },
    "frame20": {
      "x": 0.5505,
      "y": 0.5331
    },
    "frame21": {
      "x": 0.5494,
      "y": 0.5319
    },
    "frame27": {
      "x": 0.5536,
      "y": 0.5255
    },
    "frame28": {
      "x": 0.5551,
      "y": 0.5257
    },
    "frame29": {
      "x": 0.5533,
      "y": 0.5275
    },
    "frame3": {
      "x": 0.5495,
      "y": 0.544
    },
    "frame30": {
      "x": 0.5545,
      "y": 0.5275
    },
    "frame36": {
      "x": 0.5506,
      "y": 0.5412
    },
    "frame37": {
      "x": 0.5497,
      "y": 0.546
    },
    "frame39": {
      "x": 0.5505,
      "y": 0.5482
    },
    "frame4": {
      "x": 0.5497,
      "y": 0.5418
    },
    "frame5": {
      "x": 0.551,
      "y": 0.5398
    },
    "frame6": {
      "x": 0.5509,
      "y": 0.5369
    },
    "frame7": {
      "x": 0.5511,
      "y": 0.537
    },
    "frame8": {
      "x": 0.5516,
      "y": 0.5365
    },
    "frame9": {
      "x": 0.5531,
      "y": 0.538
    },
    "frame1": {
      "x": 0.5517,
      "y": 0.5468
    },
    "frame40": {
      "x": 0.5522,
      "y": 0.5474
    },
    "frame41": {
      "x": 0.5515,
      "y": 0.5463
    },
    "frame42": {
      "x": 0.5523,
      "y": 0.5465
    },
    "frame43": {
      "x": 0.5515,
      "y": 0.5466
    }
  },
  "p1a4": {
    "frame3": {
      "x": 0.5497,
      "y": 0.5471
    },
    "frame43": {
      "x": 0.5567,
      "y": 0.5448
    },
    "frame44": {
      "x": 0.5533,
      "y": 0.5437
    },
    "frame45": {
      "x": 0.5544,
      "y": 0.5457
    },
    "frame46": {
      "x": 0.5551,
      "y": 0.5478
    },
    "frame47": {
      "x": 0.5547,
      "y": 0.5482
    },
    "frame1": {
      "x": 0.5517,
      "y": 0.5468
    },
    "frame50": {
      "x": 0.5517,
      "y": 0.5468
    },
    "frame2": {
      "x": 0.5526,
      "y": 0.5466
    },
    "frame28": {
      "x": 0.5523,
      "y": 0.5419
    },
    "frame29": {
      "x": 0.5531,
      "y": 0.5419
    },
    "frame30": {
      "x": 0.5535,
      "y": 0.5418
    },
    "frame31": {
      "x": 0.5552,
      "y": 0.5382
    },
    "frame32": {
      "x": 0.5542,
      "y": 0.5391
    },
    "frame33": {
      "x": 0.5527,
      "y": 0.5399
    },
    "frame34": {
      "x": 0.5514,
      "y": 0.5402
    },
    "frame35": {
      "x": 0.5535,
      "y": 0.5434
    },
    "frame36": {
      "x": 0.5516,
      "y": 0.543
    },
    "frame37": {
      "x": 0.5529,
      "y": 0.5443
    },
    "frame38": {
      "x": 0.5542,
      "y": 0.5413
    },
    "frame39": {
      "x": 0.5545,
      "y": 0.5416
    },
    "frame4": {
      "x": 0.551,
      "y": 0.5466
    },
    "frame40": {
      "x": 0.5536,
      "y": 0.5417
    },
    "frame41": {
      "x": 0.5539,
      "y": 0.5422
    },
    "frame42": {
      "x": 0.5541,
      "y": 0.5429
    },
    "frame48": {
      "x": 0.5523,
      "y": 0.5464
    },
    "frame49": {
      "x": 0.5522,
      "y": 0.5469
    },
    "frame5": {
      "x": 0.5514,
      "y": 0.5469
    },
    "frame6": {
      "x": 0.5532,
      "y": 0.5469
    },
    "frame7": {
      "x": 0.5515,
      "y": 0.5462
    },
    "frame10": {
      "x": 0.5517,
      "y": 0.5439
    },
    "frame11": {
      "x": 0.5515,
      "y": 0.5429
    },
    "frame12": {
      "x": 0.5506,
      "y": 0.5421
    },
    "frame13": {
      "x": 0.5505,
      "y": 0.5427
    },
    "frame14": {
      "x": 0.5493,
      "y": 0.5421
    },
    "frame15": {
      "x": 0.5492,
      "y": 0.5449
    },
    "frame16": {
      "x": 0.5479,
      "y": 0.5427
    },
    "frame17": {
      "x": 0.5498,
      "y": 0.5445
    },
    "frame18": {
      "x": 0.5486,
      "y": 0.5425
    },
    "frame19": {
      "x": 0.5495,
      "y": 0.5423
    },
    "frame20": {
      "x": 0.5502,
      "y": 0.5417
    },
    "frame21": {
      "x": 0.5506,
      "y": 0.5414
    },
    "frame22": {
      "x": 0.5495,
      "y": 0.5412
    },
    "frame23": {
      "x": 0.5477,
      "y": 0.5422
    },
    "frame24": {
      "x": 0.5475,
      "y": 0.5428
    },
    "frame25": {
      "x": 0.5477,
      "y": 0.5433
    },
    "frame26": {
      "x": 0.5479,
      "y": 0.5435
    },
    "frame27": {
      "x": 0.5493,
      "y": 0.544
    },
    "frame8": {
      "x": 0.5505,
      "y": 0.5436
    },
    "frame9": {
      "x": 0.5518,
      "y": 0.5412
    }
  },
  "p1a5": {
    "frame49": {
      "x": 0.5098,
      "y": 0.6466
    },
    "frame50": {
      "x": 0.5359,
      "y": 0.6486
    },
    "frame48": {
      "x": 0.5438,
      "y": 0.6472
    },
    "frame55": {
      "x": 0.5624,
      "y": 0.6642
    },
    "frame56": {
      "x": 0.5616,
      "y": 0.6527
    },
    "frame51": {
      "x": 0.5495,
      "y": 0.648
    },
    "frame57": {
      "x": 0.5601,
      "y": 0.6443
    },
    "frame54": {
      "x": 0.5533,
      "y": 0.6636
    },
    "frame58": {
      "x": 0.5619,
      "y": 0.6316
    },
    "frame53": {
      "x": 0.5505,
      "y": 0.6458
    },
    "frame52": {
      "x": 0.5387,
      "y": 0.6203
    },
    "frame59": {
      "x": 0.5755,
      "y": 0.5914
    },
    "frame40": {
      "x": 0.5629,
      "y": 0.5442
    },
    "frame41": {
      "x": 0.5568,
      "y": 0.5442
    },
    "frame42": {
      "x": 0.5558,
      "y": 0.5441
    },
    "frame39": {
      "x": 0.5608,
      "y": 0.5467
    },
    "frame43": {
      "x": 0.5528,
      "y": 0.5426
    },
    "frame44": {
      "x": 0.5519,
      "y": 0.5422
    },
    "frame45": {
      "x": 0.552,
      "y": 0.5423
    },
    "frame46": {
      "x": 0.5513,
      "y": 0.5437
    },
    "frame47": {
      "x": 0.5506,
      "y": 0.544
    },
    "frame60": {
      "x": 0.5734,
      "y": 0.5649
    },
    "frame61": {
      "x": 0.5776,
      "y": 0.5522
    },
    "frame62": {
      "x": 0.5812,
      "y": 0.5357
    },
    "frame63": {
      "x": 0.5761,
      "y": 0.5228
    },
    "frame64": {
      "x": 0.5627,
      "y": 0.5406
    },
    "frame68": {
      "x": 0.5536,
      "y": 0.5438
    },
    "frame65": {
      "x": 0.5619,
      "y": 0.5421
    },
    "frame66": {
      "x": 0.5618,
      "y": 0.54
    },
    "frame67": {
      "x": 0.5564,
      "y": 0.5443
    },
    "frame71": {
      "x": 0.5533,
      "y": 0.5461
    },
    "frame69": {
      "x": 0.5555,
      "y": 0.5439
    },
    "frame70": {
      "x": 0.5544,
      "y": 0.5461
    },
    "frame38": {
      "x": 0.556,
      "y": 0.5437
    },
    "frame73": {
      "x": 0.5509,
      "y": 0.551
    },
    "frame72": {
      "x": 0.5539,
      "y": 0.5473
    },
    "frame74": {
      "x": 0.5484,
      "y": 0.5513
    },
    "frame75": {
      "x": 0.5495,
      "y": 0.5485
    },
    "frame1": {
      "x": 0.5517,
      "y": 0.5501
    },
    "frame2": {
      "x": 0.5517,
      "y": 0.5501
    },
    "frame3": {
      "x": 0.5517,
      "y": 0.5501
    },
    "frame92": {
      "x": 0.5517,
      "y": 0.5501
    },
    "frame76": {
      "x": 0.5497,
      "y": 0.5464
    },
    "frame77": {
      "x": 0.549,
      "y": 0.5494
    },
    "frame78": {
      "x": 0.5525,
      "y": 0.5489
    },
    "frame79": {
      "x": 0.5533,
      "y": 0.5488
    },
    "frame80": {
      "x": 0.5525,
      "y": 0.5486
    },
    "frame81": {
      "x": 0.5521,
      "y": 0.55
    },
    "frame82": {
      "x": 0.5512,
      "y": 0.5501
    },
    "frame83": {
      "x": 0.5504,
      "y": 0.55
    },
    "frame84": {
      "x": 0.5508,
      "y": 0.5496
    },
    "frame85": {
      "x": 0.5514,
      "y": 0.5504
    },
    "frame86": {
      "x": 0.5508,
      "y": 0.5496
    },
    "frame87": {
      "x": 0.5514,
      "y": 0.5499
    },
    "frame88": {
      "x": 0.551,
      "y": 0.5495
    },
    "frame89": {
      "x": 0.5518,
      "y": 0.5499
    },
    "frame90": {
      "x": 0.5515,
      "y": 0.55
    },
    "frame91": {
      "x": 0.5515,
      "y": 0.5501
    },
    "frame4": {
      "x": 0.5476,
      "y": 0.5507
    },
    "frame37": {
      "x": 0.5505,
      "y": 0.5443
    },
    "frame5": {
      "x": 0.5466,
      "y": 0.5517
    },
    "frame6": {
      "x": 0.5371,
      "y": 0.552
    },
    "frame36": {
      "x": 0.5327,
      "y": 0.5483
    },
    "frame7": {
      "x": 0.5317,
      "y": 0.5522
    },
    "frame10": {
      "x": 0.5246,
      "y": 0.5452
    },
    "frame11": {
      "x": 0.5254,
      "y": 0.5458
    },
    "frame12": {
      "x": 0.5262,
      "y": 0.5466
    },
    "frame13": {
      "x": 0.5263,
      "y": 0.5465
    },
    "frame14": {
      "x": 0.5259,
      "y": 0.547
    },
    "frame15": {
      "x": 0.5244,
      "y": 0.5472
    },
    "frame16": {
      "x": 0.5231,
      "y": 0.548
    },
    "frame17": {
      "x": 0.5242,
      "y": 0.5466
    },
    "frame18": {
      "x": 0.5229,
      "y": 0.5446
    },
    "frame19": {
      "x": 0.5239,
      "y": 0.5484
    },
    "frame20": {
      "x": 0.5234,
      "y": 0.5476
    },
    "frame35": {
      "x": 0.5246,
      "y": 0.5471
    },
    "frame8": {
      "x": 0.5244,
      "y": 0.5501
    },
    "frame9": {
      "x": 0.525,
      "y": 0.5465
    },
    "frame21": {
      "x": 0.5204,
      "y": 0.5493
    },
    "frame22": {
      "x": 0.5123,
      "y": 0.5548
    },
    "frame34": {
      "x": 0.5194,
      "y": 0.5479
    },
    "frame32": {
      "x": 0.5111,
      "y": 0.552
    },
    "frame33": {
      "x": 0.5149,
      "y": 0.5526
    },
    "frame23": {
      "x": 0.5153,
      "y": 0.5545
    },
    "frame24": {
      "x": 0.5128,
      "y": 0.5541
    },
    "frame25": {
      "x": 0.5108,
      "y": 0.5525
    },
    "frame26": {
      "x": 0.5093,
      "y": 0.5545
    },
    "frame27": {
      "x": 0.5088,
      "y": 0.5548
    },
    "frame28": {
      "x": 0.5071,
      "y": 0.5514
    },
    "frame29": {
      "x": 0.5078,
      "y": 0.552
    },
    "frame30": {
      "x": 0.5086,
      "y": 0.5518
    },
    "frame31": {
      "x": 0.5095,
      "y": 0.5529
    }
  },
  "p2a1": {
    "frame10": {
      "x": 0.4931,
      "y": 0.5453
    },
    "frame11": {
      "x": 0.4936,
      "y": 0.5453
    },
    "frame12": {
      "x": 0.4945,
      "y": 0.5461
    },
    "frame13": {
      "x": 0.4944,
      "y": 0.5461
    },
    "frame14": {
      "x": 0.4941,
      "y": 0.5459
    },
    "frame1": {
      "x": 0.4943,
      "y": 0.547
    },
    "frame2": {
      "x": 0.4943,
      "y": 0.547
    },
    "frame3": {
      "x": 0.4943,
      "y": 0.547
    },
    "frame4": {
      "x": 0.4943,
      "y": 0.547
    },
    "frame5": {
      "x": 0.4943,
      "y": 0.547
    },
    "frame6": {
      "x": 0.4943,
      "y": 0.547
    },
    "frame15": {
      "x": 0.4943,
      "y": 0.5459
    },
    "frame16": {
      "x": 0.4938,
      "y": 0.5454
    },
    "frame17": {
      "x": 0.494,
      "y": 0.5457
    },
    "frame18": {
      "x": 0.4942,
      "y": 0.5458
    },
    "frame32": {
      "x": 0.4938,
      "y": 0.5464
    },
    "frame19": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame20": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame21": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame22": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame23": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame24": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame25": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame26": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame27": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame28": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame29": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame30": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame46": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame47": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame48": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame49": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame50": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame51": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame52": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame53": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame64": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame65": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame66": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame67": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame68": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame69": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame70": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame71": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame72": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame33": {
      "x": 0.4936,
      "y": 0.5458
    },
    "frame34": {
      "x": 0.4936,
      "y": 0.5458
    },
    "frame35": {
      "x": 0.4934,
      "y": 0.5455
    },
    "frame36": {
      "x": 0.4939,
      "y": 0.546
    },
    "frame37": {
      "x": 0.4943,
      "y": 0.5461
    },
    "frame38": {
      "x": 0.4937,
      "y": 0.5455
    },
    "frame39": {
      "x": 0.494,
      "y": 0.5455
    },
    "frame40": {
      "x": 0.4941,
      "y": 0.5461
    },
    "frame42": {
      "x": 0.4937,
      "y": 0.546
    },
    "frame31": {
      "x": 0.4942,
      "y": 0.5472
    },
    "frame43": {
      "x": 0.4942,
      "y": 0.5463
    },
    "frame44": {
      "x": 0.494,
      "y": 0.5453
    },
    "frame45": {
      "x": 0.4942,
      "y": 0.5452
    },
    "frame55": {
      "x": 0.4937,
      "y": 0.5458
    },
    "frame56": {
      "x": 0.4934,
      "y": 0.5453
    },
    "frame57": {
      "x": 0.4935,
      "y": 0.5456
    },
    "frame58": {
      "x": 0.4935,
      "y": 0.5452
    },
    "frame41": {
      "x": 0.4939,
      "y": 0.5472
    },
    "frame59": {
      "x": 0.4942,
      "y": 0.5458
    },
    "frame60": {
      "x": 0.4943,
      "y": 0.5459
    },
    "frame61": {
      "x": 0.4944,
      "y": 0.5452
    },
    "frame62": {
      "x": 0.4935,
      "y": 0.5454
    },
    "frame63": {
      "x": 0.4941,
      "y": 0.5454
    },
    "frame54": {
      "x": 0.4943,
      "y": 0.5472
    },
    "frame8": {
      "x": 0.4939,
      "y": 0.546
    },
    "frame9": {
      "x": 0.4935,
      "y": 0.5457
    },
    "frame7": {
      "x": 0.4942,
      "y": 0.547
    }
  },
  "p2a2": {
    "frame10": {
      "x": 0.4886,
      "y": 0.5389
    },
    "frame11": {
      "x": 0.4895,
      "y": 0.5388
    },
    "frame12": {
      "x": 0.4895,
      "y": 0.5388
    },
    "frame13": {
      "x": 0.4889,
      "y": 0.541
    },
    "frame14": {
      "x": 0.4894,
      "y": 0.5398
    },
    "frame15": {
      "x": 0.4891,
      "y": 0.5391
    },
    "frame16": {
      "x": 0.4893,
      "y": 0.5383
    },
    "frame17": {
      "x": 0.4901,
      "y": 0.5371
    },
    "frame18": {
      "x": 0.4899,
      "y": 0.5375
    },
    "frame19": {
      "x": 0.4898,
      "y": 0.537
    },
    "frame20": {
      "x": 0.4896,
      "y": 0.5377
    },
    "frame21": {
      "x": 0.4896,
      "y": 0.5376
    },
    "frame22": {
      "x": 0.4897,
      "y": 0.5372
    },
    "frame23": {
      "x": 0.4892,
      "y": 0.5389
    },
    "frame24": {
      "x": 0.4895,
      "y": 0.5389
    },
    "frame25": {
      "x": 0.4889,
      "y": 0.5395
    },
    "frame26": {
      "x": 0.4883,
      "y": 0.5406
    },
    "frame27": {
      "x": 0.488,
      "y": 0.5407
    },
    "frame28": {
      "x": 0.4886,
      "y": 0.5396
    },
    "frame29": {
      "x": 0.4894,
      "y": 0.5398
    },
    "frame30": {
      "x": 0.4892,
      "y": 0.5403
    },
    "frame31": {
      "x": 0.4898,
      "y": 0.5389
    },
    "frame32": {
      "x": 0.4901,
      "y": 0.5374
    },
    "frame33": {
      "x": 0.49,
      "y": 0.5381
    },
    "frame34": {
      "x": 0.4901,
      "y": 0.5378
    },
    "frame35": {
      "x": 0.4899,
      "y": 0.5382
    },
    "frame36": {
      "x": 0.4898,
      "y": 0.5381
    },
    "frame37": {
      "x": 0.4895,
      "y": 0.5387
    },
    "frame38": {
      "x": 0.4894,
      "y": 0.5389
    },
    "frame39": {
      "x": 0.4895,
      "y": 0.5382
    },
    "frame40": {
      "x": 0.4897,
      "y": 0.5378
    },
    "frame41": {
      "x": 0.4898,
      "y": 0.5376
    },
    "frame42": {
      "x": 0.4893,
      "y": 0.5372
    },
    "frame43": {
      "x": 0.4893,
      "y": 0.5372
    },
    "frame44": {
      "x": 0.4897,
      "y": 0.5372
    },
    "frame45": {
      "x": 0.4897,
      "y": 0.5372
    },
    "frame46": {
      "x": 0.4897,
      "y": 0.5372
    },
    "frame47": {
      "x": 0.4897,
      "y": 0.5372
    },
    "frame48": {
      "x": 0.4897,
      "y": 0.5372
    },
    "frame49": {
      "x": 0.4897,
      "y": 0.5372
    },
    "frame50": {
      "x": 0.4897,
      "y": 0.5372
    },
    "frame51": {
      "x": 0.4897,
      "y": 0.5372
    },
    "frame52": {
      "x": 0.4897,
      "y": 0.5372
    },
    "frame79": {
      "x": 0.4897,
      "y": 0.5372
    },
    "frame80": {
      "x": 0.4897,
      "y": 0.5372
    },
    "frame81": {
      "x": 0.4897,
      "y": 0.5372
    },
    "frame82": {
      "x": 0.4897,
      "y": 0.5372
    },
    "frame83": {
      "x": 0.4897,
      "y": 0.5372
    },
    "frame53": {
      "x": 0.4892,
      "y": 0.5372
    },
    "frame54": {
      "x": 0.4889,
      "y": 0.5382
    },
    "frame55": {
      "x": 0.4887,
      "y": 0.5376
    },
    "frame56": {
      "x": 0.4877,
      "y": 0.5416
    },
    "frame57": {
      "x": 0.4886,
      "y": 0.5426
    },
    "frame58": {
      "x": 0.4891,
      "y": 0.5403
    },
    "frame59": {
      "x": 0.4913,
      "y": 0.5304
    },
    "frame60": {
      "x": 0.4923,
      "y": 0.5279
    },
    "frame61": {
      "x": 0.4929,
      "y": 0.5272
    },
    "frame62": {
      "x": 0.493,
      "y": 0.5268
    },
    "frame63": {
      "x": 0.493,
      "y": 0.5265
    },
    "frame64": {
      "x": 0.4937,
      "y": 0.5246
    },
    "frame65": {
      "x": 0.4942,
      "y": 0.5237
    },
    "frame66": {
      "x": 0.4927,
      "y": 0.5265
    },
    "frame67": {
      "x": 0.491,
      "y": 0.5307
    },
    "frame68": {
      "x": 0.4909,
      "y": 0.5321
    },
    "frame69": {
      "x": 0.4898,
      "y": 0.5374
    },
    "frame70": {
      "x": 0.4895,
      "y": 0.5386
    },
    "frame71": {
      "x": 0.4891,
      "y": 0.5406
    },
    "frame72": {
      "x": 0.4897,
      "y": 0.5367
    },
    "frame73": {
      "x": 0.4893,
      "y": 0.5391
    },
    "frame74": {
      "x": 0.4897,
      "y": 0.5388
    },
    "frame75": {
      "x": 0.4901,
      "y": 0.5369
    },
    "frame76": {
      "x": 0.4899,
      "y": 0.5372
    },
    "frame77": {
      "x": 0.4894,
      "y": 0.5384
    },
    "frame78": {
      "x": 0.4895,
      "y": 0.538
    },
    "frame8": {
      "x": 0.4921,
      "y": 0.541
    },
    "frame84": {
      "x": 0.4897,
      "y": 0.5373
    },
    "frame85": {
      "x": 0.4894,
      "y": 0.5382
    },
    "frame86": {
      "x": 0.4891,
      "y": 0.5392
    },
    "frame87": {
      "x": 0.4888,
      "y": 0.5403
    },
    "frame88": {
      "x": 0.4899,
      "y": 0.5403
    },
    "frame89": {
      "x": 0.485,
      "y": 0.5398
    },
    "frame9": {
      "x": 0.4885,
      "y": 0.5394
    },
    "frame90": {
      "x": 0.4898,
      "y": 0.5422
    },
    "frame91": {
      "x": 0.4906,
      "y": 0.542
    },
    "frame92": {
      "x": 0.4952,
      "y": 0.5438
    },
    "frame1": {
      "x": 0.4939,
      "y": 0.5505
    },
    "frame2": {
      "x": 0.4955,
      "y": 0.5495
    },
    "frame3": {
      "x": 0.497,
      "y": 0.5483
    },
    "frame4": {
      "x": 0.4987,
      "y": 0.5472
    },
    "frame5": {
      "x": 0.495,
      "y": 0.5459
    },
    "frame6": {
      "x": 0.4959,
      "y": 0.5462
    },
    "frame7": {
      "x": 0.4929,
      "y": 0.5447
    },
    "frame93": {
      "x": 0.4948,
      "y": 0.5484
    },
    "frame94": {
      "x": 0.4953,
      "y": 0.5509
    },
    "frame95": {
      "x": 0.4927,
      "y": 0.5509
    },
    "frame96": {
      "x": 0.4939,
      "y": 0.5507
    }
  },
  "p2a3": {
    "frame2": {
      "x": 0.4926,
      "y": 0.5499
    },
    "frame3": {
      "x": 0.4944,
      "y": 0.5509
    },
    "frame4": {
      "x": 0.4951,
      "y": 0.5511
    },
    "frame5": {
      "x": 0.4931,
      "y": 0.5488
    },
    "frame6": {
      "x": 0.4914,
      "y": 0.5464
    },
    "frame1": {
      "x": 0.4939,
      "y": 0.5505
    },
    "frame46": {
      "x": 0.4948,
      "y": 0.5454
    },
    "frame47": {
      "x": 0.4949,
      "y": 0.5468
    },
    "frame48": {
      "x": 0.4963,
      "y": 0.5501
    },
    "frame49": {
      "x": 0.4935,
      "y": 0.552
    },
    "frame50": {
      "x": 0.4931,
      "y": 0.5534
    },
    "frame51": {
      "x": 0.4926,
      "y": 0.5545
    },
    "frame52": {
      "x": 0.4925,
      "y": 0.555
    },
    "frame53": {
      "x": 0.4929,
      "y": 0.5516
    },
    "frame54": {
      "x": 0.4932,
      "y": 0.5504
    },
    "frame55": {
      "x": 0.4942,
      "y": 0.5502
    },
    "frame56": {
      "x": 0.4946,
      "y": 0.5486
    },
    "frame57": {
      "x": 0.4936,
      "y": 0.55
    },
    "frame58": {
      "x": 0.4934,
      "y": 0.5504
    },
    "frame59": {
      "x": 0.4939,
      "y": 0.5508
    },
    "frame60": {
      "x": 0.4936,
      "y": 0.5519
    },
    "frame61": {
      "x": 0.4933,
      "y": 0.5525
    },
    "frame62": {
      "x": 0.4935,
      "y": 0.5521
    },
    "frame63": {
      "x": 0.4937,
      "y": 0.5513
    },
    "frame64": {
      "x": 0.4939,
      "y": 0.5507
    },
    "frame65": {
      "x": 0.494,
      "y": 0.5504
    },
    "frame66": {
      "x": 0.4939,
      "y": 0.5505
    },
    "frame67": {
      "x": 0.4939,
      "y": 0.5507
    },
    "frame68": {
      "x": 0.4939,
      "y": 0.5507
    },
    "frame69": {
      "x": 0.4939,
      "y": 0.5507
    },
    "frame70": {
      "x": 0.4939,
      "y": 0.5507
    },
    "frame71": {
      "x": 0.4939,
      "y": 0.5507
    },
    "frame72": {
      "x": 0.4939,
      "y": 0.5507
    },
    "frame11": {
      "x": 0.4916,
      "y": 0.5389
    },
    "frame12": {
      "x": 0.4914,
      "y": 0.5436
    },
    "frame13": {
      "x": 0.4921,
      "y": 0.542
    },
    "frame14": {
      "x": 0.492,
      "y": 0.5436
    },
    "frame15": {
      "x": 0.4917,
      "y": 0.5428
    },
    "frame16": {
      "x": 0.4919,
      "y": 0.5414
    },
    "frame17": {
      "x": 0.4918,
      "y": 0.5422
    },
    "frame18": {
      "x": 0.4918,
      "y": 0.5426
    },
    "frame10": {
      "x": 0.4934,
      "y": 0.5382
    },
    "frame19": {
      "x": 0.4918,
      "y": 0.5415
    },
    "frame20": {
      "x": 0.4915,
      "y": 0.5423
    },
    "frame21": {
      "x": 0.4921,
      "y": 0.5422
    },
    "frame22": {
      "x": 0.4923,
      "y": 0.541
    },
    "frame23": {
      "x": 0.4925,
      "y": 0.5424
    },
    "frame24": {
      "x": 0.4924,
      "y": 0.542
    },
    "frame42": {
      "x": 0.4935,
      "y": 0.5362
    },
    "frame25": {
      "x": 0.4926,
      "y": 0.5416
    },
    "frame26": {
      "x": 0.4925,
      "y": 0.5423
    },
    "frame27": {
      "x": 0.4925,
      "y": 0.5425
    },
    "frame28": {
      "x": 0.4927,
      "y": 0.5413
    },
    "frame29": {
      "x": 0.4924,
      "y": 0.5426
    },
    "frame30": {
      "x": 0.4925,
      "y": 0.5425
    },
    "frame31": {
      "x": 0.492,
      "y": 0.5417
    },
    "frame32": {
      "x": 0.4921,
      "y": 0.5423
    },
    "frame33": {
      "x": 0.4917,
      "y": 0.5425
    },
    "frame34": {
      "x": 0.492,
      "y": 0.5411
    },
    "frame35": {
      "x": 0.492,
      "y": 0.5426
    },
    "frame36": {
      "x": 0.4919,
      "y": 0.542
    },
    "frame37": {
      "x": 0.492,
      "y": 0.5415
    },
    "frame7": {
      "x": 0.4974,
      "y": 0.539
    },
    "frame38": {
      "x": 0.4921,
      "y": 0.5415
    },
    "frame39": {
      "x": 0.4921,
      "y": 0.5415
    },
    "frame40": {
      "x": 0.4918,
      "y": 0.5416
    },
    "frame41": {
      "x": 0.4925,
      "y": 0.5374
    },
    "frame43": {
      "x": 0.4944,
      "y": 0.542
    },
    "frame44": {
      "x": 0.4941,
      "y": 0.5383
    },
    "frame45": {
      "x": 0.4939,
      "y": 0.538
    },
    "frame8": {
      "x": 0.4954,
      "y": 0.5374
    },
    "frame9": {
      "x": 0.4965,
      "y": 0.5442
    }
  },
  "p2a4": {
    "frame64": {
      "x": 0.4964,
      "y": 0.5464
    },
    "frame65": {
      "x": 0.4959,
      "y": 0.5534
    },
    "frame1": {
      "x": 0.4939,
      "y": 0.5505
    },
    "frame10": {
      "x": 0.4939,
      "y": 0.5506
    },
    "frame11": {
      "x": 0.4933,
      "y": 0.5529
    },
    "frame12": {
      "x": 0.4935,
      "y": 0.5517
    },
    "frame13": {
      "x": 0.4939,
      "y": 0.5509
    },
    "frame14": {
      "x": 0.4948,
      "y": 0.5478
    },
    "frame15": {
      "x": 0.4945,
      "y": 0.5482
    },
    "frame16": {
      "x": 0.4943,
      "y": 0.5492
    },
    "frame17": {
      "x": 0.494,
      "y": 0.5472
    },
    "frame18": {
      "x": 0.4947,
      "y": 0.5451
    },
    "frame19": {
      "x": 0.4954,
      "y": 0.545
    },
    "frame2": {
      "x": 0.4942,
      "y": 0.5497
    },
    "frame20": {
      "x": 0.4956,
      "y": 0.5447
    },
    "frame21": {
      "x": 0.4949,
      "y": 0.5454
    },
    "frame22": {
      "x": 0.4946,
      "y": 0.5463
    },
    "frame23": {
      "x": 0.4954,
      "y": 0.5463
    },
    "frame24": {
      "x": 0.4943,
      "y": 0.5503
    },
    "frame25": {
      "x": 0.4937,
      "y": 0.5519
    },
    "frame26": {
      "x": 0.4938,
      "y": 0.5519
    },
    "frame27": {
      "x": 0.4931,
      "y": 0.5537
    },
    "frame28": {
      "x": 0.4929,
      "y": 0.5544
    },
    "frame29": {
      "x": 0.4921,
      "y": 0.5567
    },
    "frame3": {
      "x": 0.4945,
      "y": 0.5484
    },
    "frame30": {
      "x": 0.4921,
      "y": 0.5562
    },
    "frame31": {
      "x": 0.4919,
      "y": 0.5568
    },
    "frame32": {
      "x": 0.492,
      "y": 0.5517
    },
    "frame33": {
      "x": 0.4937,
      "y": 0.5521
    },
    "frame34": {
      "x": 0.4947,
      "y": 0.5528
    },
    "frame35": {
      "x": 0.497,
      "y": 0.5515
    },
    "frame36": {
      "x": 0.4965,
      "y": 0.5514
    },
    "frame37": {
      "x": 0.4951,
      "y": 0.5497
    },
    "frame38": {
      "x": 0.4943,
      "y": 0.5469
    },
    "frame39": {
      "x": 0.4979,
      "y": 0.5476
    },
    "frame4": {
      "x": 0.4948,
      "y": 0.5475
    },
    "frame40": {
      "x": 0.4997,
      "y": 0.5456
    },
    "frame41": {
      "x": 0.499,
      "y": 0.5422
    },
    "frame5": {
      "x": 0.495,
      "y": 0.5469
    },
    "frame6": {
      "x": 0.4952,
      "y": 0.5464
    },
    "frame63": {
      "x": 0.4957,
      "y": 0.5328
    },
    "frame66": {
      "x": 0.4949,
      "y": 0.5532
    },
    "frame67": {
      "x": 0.4947,
      "y": 0.5512
    },
    "frame68": {
      "x": 0.4939,
      "y": 0.552
    },
    "frame7": {
      "x": 0.4952,
      "y": 0.5464
    },
    "frame72": {
      "x": 0.495,
      "y": 0.5469
    },
    "frame69": {
      "x": 0.4942,
      "y": 0.5502
    },
    "frame70": {
      "x": 0.495,
      "y": 0.5498
    },
    "frame71": {
      "x": 0.4955,
      "y": 0.55
    },
    "frame73": {
      "x": 0.4951,
      "y": 0.5468
    },
    "frame74": {
      "x": 0.495,
      "y": 0.5469
    },
    "frame75": {
      "x": 0.4948,
      "y": 0.5477
    },
    "frame76": {
      "x": 0.4943,
      "y": 0.5493
    },
    "frame77": {
      "x": 0.4939,
      "y": 0.5507
    },
    "frame8": {
      "x": 0.4951,
      "y": 0.5465
    },
    "frame9": {
      "x": 0.4947,
      "y": 0.5482
    },
    "frame42": {
      "x": 0.498,
      "y": 0.5396
    },
    "frame43": {
      "x": 0.4973,
      "y": 0.539
    },
    "frame44": {
      "x": 0.4968,
      "y": 0.5349
    },
    "frame62": {
      "x": 0.4983,
      "y": 0.5183
    },
    "frame45": {
      "x": 0.4975,
      "y": 0.5309
    },
    "frame47": {
      "x": 0.4937,
      "y": 0.5261
    },
    "frame48": {
      "x": 0.4951,
      "y": 0.5278
    },
    "frame46": {
      "x": 0.496,
      "y": 0.5276
    },
    "frame49": {
      "x": 0.4994,
      "y": 0.5237
    },
    "frame50": {
      "x": 0.4974,
      "y": 0.5215
    },
    "frame51": {
      "x": 0.4963,
      "y": 0.516
    },
    "frame53": {
      "x": 0.4981,
      "y": 0.5071
    },
    "frame61": {
      "x": 0.498,
      "y": 0.5093
    },
    "frame52": {
      "x": 0.4964,
      "y": 0.5116
    },
    "frame54": {
      "x": 0.4956,
      "y": 0.503
    },
    "frame55": {
      "x": 0.4951,
      "y": 0.5084
    },
    "frame60": {
      "x": 0.4977,
      "y": 0.4995
    },
    "frame56": {
      "x": 0.4951,
      "y": 0.5052
    },
    "frame57": {
      "x": 0.4972,
      "y": 0.5053
    },
    "frame58": {
      "x": 0.4957,
      "y": 0.5021
    },
    "frame59": {
      "x": 0.4966,
      "y": 0.5019
    }
  },
  "p2a5": {
    "frame23": {
      "x": 0.5535,
      "y": 0.4423
    },
    "frame24": {
      "x": 0.564,
      "y": 0.4477
    },
    "frame25": {
      "x": 0.5697,
      "y": 0.453
    },
    "frame22": {
      "x": 0.5317,
      "y": 0.4345
    },
    "frame33": {
      "x": 0.5633,
      "y": 0.4562
    },
    "frame43": {
      "x": 0.5567,
      "y": 0.4613
    },
    "frame44": {
      "x": 0.5628,
      "y": 0.4635
    },
    "frame32": {
      "x": 0.5549,
      "y": 0.451
    },
    "frame61": {
      "x": 0.5593,
      "y": 0.4749
    },
    "frame60": {
      "x": 0.5626,
      "y": 0.4771
    },
    "frame42": {
      "x": 0.5359,
      "y": 0.4589
    },
    "frame30": {
      "x": 0.5004,
      "y": 0.4359
    },
    "frame62": {
      "x": 0.5469,
      "y": 0.4709
    },
    "frame18": {
      "x": 0.4967,
      "y": 0.4196
    },
    "frame63": {
      "x": 0.5357,
      "y": 0.4628
    },
    "frame39": {
      "x": 0.495,
      "y": 0.4421
    },
    "frame28": {
      "x": 0.4833,
      "y": 0.4448
    },
    "frame16": {
      "x": 0.5015,
      "y": 0.4238
    },
    "frame19": {
      "x": 0.4967,
      "y": 0.4193
    },
    "frame49": {
      "x": 0.5605,
      "y": 0.4615
    },
    "frame15": {
      "x": 0.497,
      "y": 0.4265
    },
    "frame17": {
      "x": 0.5009,
      "y": 0.4219
    },
    "frame20": {
      "x": 0.4968,
      "y": 0.4188
    },
    "frame21": {
      "x": 0.4958,
      "y": 0.4197
    },
    "frame26": {
      "x": 0.4934,
      "y": 0.4315
    },
    "frame34": {
      "x": 0.4985,
      "y": 0.4355
    },
    "frame29": {
      "x": 0.4804,
      "y": 0.457
    },
    "frame36": {
      "x": 0.485,
      "y": 0.4481
    },
    "frame37": {
      "x": 0.4821,
      "y": 0.4583
    },
    "frame27": {
      "x": 0.4806,
      "y": 0.4254
    },
    "frame38": {
      "x": 0.4854,
      "y": 0.458
    },
    "frame46": {
      "x": 0.4886,
      "y": 0.4476
    },
    "frame47": {
      "x": 0.4789,
      "y": 0.4651
    },
    "frame54": {
      "x": 0.5577,
      "y": 0.464
    },
    "frame59": {
      "x": 0.5578,
      "y": 0.4708
    },
    "frame14": {
      "x": 0.4961,
      "y": 0.4308
    },
    "frame50": {
      "x": 0.5014,
      "y": 0.4522
    },
    "frame5": {
      "x": 0.4983,
      "y": 0.5076
    },
    "frame4": {
      "x": 0.4993,
      "y": 0.5066
    },
    "frame35": {
      "x": 0.4818,
      "y": 0.428
    },
    "frame40": {
      "x": 0.4884,
      "y": 0.4047
    },
    "frame48": {
      "x": 0.5057,
      "y": 0.4623
    },
    "frame13": {
      "x": 0.4981,
      "y": 0.4421
    },
    "frame55": {
      "x": 0.5015,
      "y": 0.4504
    },
    "frame52": {
      "x": 0.4801,
      "y": 0.4679
    },
    "frame73": {
      "x": 0.498,
      "y": 0.5417
    },
    "frame8": {
      "x": 0.5175,
      "y": 0.5015
    },
    "frame53": {
      "x": 0.5036,
      "y": 0.4634
    },
    "frame66": {
      "x": 0.5001,
      "y": 0.4284
    },
    "frame31": {
      "x": 0.4974,
      "y": 0.4577
    },
    "frame74": {
      "x": 0.4961,
      "y": 0.5461
    },
    "frame58": {
      "x": 0.5034,
      "y": 0.4647
    },
    "frame41": {
      "x": 0.5011,
      "y": 0.4541
    },
    "frame57": {
      "x": 0.4784,
      "y": 0.4746
    },
    "frame51": {
      "x": 0.4864,
      "y": 0.4515
    },
    "frame68": {
      "x": 0.4936,
      "y": 0.4449
    },
    "frame71": {
      "x": 0.4992,
      "y": 0.5386
    },
    "frame64": {
      "x": 0.5148,
      "y": 0.4531
    },
    "frame69": {
      "x": 0.4948,
      "y": 0.5023
    },
    "frame1": {
      "x": 0.4939,
      "y": 0.5505
    },
    "frame70": {
      "x": 0.4945,
      "y": 0.537
    },
    "frame67": {
      "x": 0.491,
      "y": 0.4248
    },
    "frame65": {
      "x": 0.4983,
      "y": 0.4416
    },
    "frame7": {
      "x": 0.4927,
      "y": 0.523
    },
    "frame45": {
      "x": 0.4764,
      "y": 0.4091
    },
    "frame12": {
      "x": 0.4945,
      "y": 0.4669
    },
    "frame9": {
      "x": 0.4909,
      "y": 0.5133
    },
    "frame11": {
      "x": 0.4888,
      "y": 0.4995
    },
    "frame72": {
      "x": 0.4952,
      "y": 0.5429
    },
    "frame10": {
      "x": 0.486,
      "y": 0.4896
    },
    "frame6": {
      "x": 0.4999,
      "y": 0.529
    },
    "frame2": {
      "x": 0.4953,
      "y": 0.5383
    },
    "frame56": {
      "x": 0.4831,
      "y": 0.4551
    },
    "frame3": {
      "x": 0.4949,
      "y": 0.5177
    },
    "frame75": {
      "x": 0.4939,
      "y": 0.5507
    },
    "frame76": {
      "x": 0.4939,
      "y": 0.5507
    }
  },
  "p3a1": {
    "frame1": {
      "x": 0.5068,
      "y": 0.5191
    },
    "frame14": {
      "x": 0.5068,
      "y": 0.5191
    },
    "frame10": {
      "x": 0.5097,
      "y": 0.518
    },
    "frame5": {
      "x": 0.5097,
      "y": 0.518
    },
    "frame11": {
      "x": 0.5067,
      "y": 0.5196
    },
    "frame12": {
      "x": 0.5072,
      "y": 0.5196
    },
    "frame13": {
      "x": 0.5079,
      "y": 0.5193
    },
    "frame2": {
      "x": 0.5061,
      "y": 0.5195
    },
    "frame3": {
      "x": 0.5081,
      "y": 0.5187
    },
    "frame4": {
      "x": 0.5086,
      "y": 0.518
    },
    "frame6": {
      "x": 0.5069,
      "y": 0.5196
    },
    "frame7": {
      "x": 0.5068,
      "y": 0.5197
    },
    "frame8": {
      "x": 0.5071,
      "y": 0.5194
    },
    "frame9": {
      "x": 0.509,
      "y": 0.5179
    }
  },
  "p3a2": {
    "frame1": {
      "x": 0.5068,
      "y": 0.5191
    },
    "frame10": {
      "x": 0.5122,
      "y": 0.5067
    },
    "frame11": {
      "x": 0.5124,
      "y": 0.5068
    },
    "frame12": {
      "x": 0.5125,
      "y": 0.5064
    },
    "frame13": {
      "x": 0.5125,
      "y": 0.5073
    },
    "frame14": {
      "x": 0.5125,
      "y": 0.5075
    },
    "frame15": {
      "x": 0.5125,
      "y": 0.5076
    },
    "frame16": {
      "x": 0.512,
      "y": 0.5085
    },
    "frame17": {
      "x": 0.5121,
      "y": 0.5088
    },
    "frame18": {
      "x": 0.5105,
      "y": 0.511
    },
    "frame19": {
      "x": 0.5083,
      "y": 0.516
    },
    "frame2": {
      "x": 0.5068,
      "y": 0.5191
    },
    "frame20": {
      "x": 0.5073,
      "y": 0.5191
    },
    "frame21": {
      "x": 0.5072,
      "y": 0.5186
    },
    "frame22": {
      "x": 0.507,
      "y": 0.519
    },
    "frame23": {
      "x": 0.507,
      "y": 0.5193
    },
    "frame24": {
      "x": 0.5092,
      "y": 0.5145
    },
    "frame25": {
      "x": 0.5126,
      "y": 0.5079
    },
    "frame26": {
      "x": 0.5145,
      "y": 0.5059
    },
    "frame27": {
      "x": 0.5138,
      "y": 0.5063
    },
    "frame28": {
      "x": 0.5132,
      "y": 0.5068
    },
    "frame29": {
      "x": 0.5131,
      "y": 0.5072
    },
    "frame3": {
      "x": 0.5069,
      "y": 0.5189
    },
    "frame30": {
      "x": 0.5133,
      "y": 0.5069
    },
    "frame31": {
      "x": 0.5119,
      "y": 0.5091
    },
    "frame32": {
      "x": 0.5091,
      "y": 0.5147
    },
    "frame33": {
      "x": 0.506,
      "y": 0.5212
    },
    "frame34": {
      "x": 0.5068,
      "y": 0.5192
    },
    "frame35": {
      "x": 0.5075,
      "y": 0.5191
    },
    "frame36": {
      "x": 0.5081,
      "y": 0.518
    },
    "frame37": {
      "x": 0.5084,
      "y": 0.518
    },
    "frame38": {
      "x": 0.5091,
      "y": 0.517
    },
    "frame39": {
      "x": 0.5088,
      "y": 0.5169
    },
    "frame4": {
      "x": 0.5069,
      "y": 0.519
    },
    "frame40": {
      "x": 0.5103,
      "y": 0.5129
    },
    "frame41": {
      "x": 0.5101,
      "y": 0.5139
    },
    "frame42": {
      "x": 0.5079,
      "y": 0.5162
    },
    "frame43": {
      "x": 0.5083,
      "y": 0.5161
    },
    "frame44": {
      "x": 0.5082,
      "y": 0.5153
    },
    "frame45": {
      "x": 0.5082,
      "y": 0.5152
    },
    "frame46": {
      "x": 0.5081,
      "y": 0.5156
    },
    "frame47": {
      "x": 0.5068,
      "y": 0.5192
    },
    "frame5": {
      "x": 0.5086,
      "y": 0.5148
    },
    "frame6": {
      "x": 0.5098,
      "y": 0.5123
    },
    "frame7": {
      "x": 0.5111,
      "y": 0.5094
    },
    "frame8": {
      "x": 0.5115,
      "y": 0.5077
    },
    "frame9": {
      "x": 0.512,
      "y": 0.5076
    }
  },
  "p3a3": {
    "frame1": {
      "x": 0.5064,
      "y": 0.5227
    },
    "frame45": {
      "x": 0.5064,
      "y": 0.5227
    },
    "frame2": {
      "x": 0.5067,
      "y": 0.5224
    },
    "frame34": {
      "x": 0.5077,
      "y": 0.5211
    },
    "frame35": {
      "x": 0.5064,
      "y": 0.5227
    },
    "frame12": {
      "x": 0.5118,
      "y": 0.5135
    },
    "frame36": {
      "x": 0.5063,
      "y": 0.5233
    },
    "frame37": {
      "x": 0.5062,
      "y": 0.5236
    },
    "frame38": {
      "x": 0.5062,
      "y": 0.524
    },
    "frame16": {
      "x": 0.5093,
      "y": 0.5174
    },
    "frame20": {
      "x": 0.5122,
      "y": 0.5206
    },
    "frame39": {
      "x": 0.5068,
      "y": 0.5228
    },
    "frame40": {
      "x": 0.5069,
      "y": 0.5221
    },
    "frame41": {
      "x": 0.5068,
      "y": 0.5226
    },
    "frame28": {
      "x": 0.5066,
      "y": 0.5189
    },
    "frame42": {
      "x": 0.507,
      "y": 0.5218
    },
    "frame43": {
      "x": 0.5064,
      "y": 0.5233
    },
    "frame44": {
      "x": 0.5066,
      "y": 0.5226
    },
    "frame3": {
      "x": 0.5066,
      "y": 0.524
    },
    "frame33": {
      "x": 0.5039,
      "y": 0.5234
    },
    "frame4": {
      "x": 0.5055,
      "y": 0.5209
    },
    "frame5": {
      "x": 0.5073,
      "y": 0.5215
    },
    "frame32": {
      "x": 0.5053,
      "y": 0.5195
    },
    "frame31": {
      "x": 0.5086,
      "y": 0.5174
    },
    "frame6": {
      "x": 0.5077,
      "y": 0.5202
    },
    "frame7": {
      "x": 0.5103,
      "y": 0.5235
    },
    "frame29": {
      "x": 0.5121,
      "y": 0.5126
    },
    "frame30": {
      "x": 0.5109,
      "y": 0.514
    },
    "frame8": {
      "x": 0.5075,
      "y": 0.5222
    },
    "frame18": {
      "x": 0.513,
      "y": 0.5179
    },
    "frame9": {
      "x": 0.5065,
      "y": 0.5235
    },
    "frame10": {
      "x": 0.5101,
      "y": 0.5204
    },
    "frame11": {
      "x": 0.5119,
      "y": 0.5152
    },
    "frame13": {
      "x": 0.5092,
      "y": 0.521
    },
    "frame14": {
      "x": 0.5101,
      "y": 0.5219
    },
    "frame15": {
      "x": 0.5122,
      "y": 0.5222
    },
    "frame17": {
      "x": 0.5096,
      "y": 0.5169
    },
    "frame19": {
      "x": 0.5116,
      "y": 0.5229
    },
    "frame21": {
      "x": 0.507,
      "y": 0.5236
    },
    "frame22": {
      "x": 0.5069,
      "y": 0.523
    },
    "frame23": {
      "x": 0.5073,
      "y": 0.5164
    },
    "frame24": {
      "x": 0.5078,
      "y": 0.5185
    },
    "frame25": {
      "x": 0.506,
      "y": 0.5233
    },
    "frame26": {
      "x": 0.506,
      "y": 0.5239
    },
    "frame27": {
      "x": 0.5056,
      "y": 0.524
    }
  },
  "p3a4": {
    "frame28": {
      "x": 0.5306,
      "y": 0.4745
    },
    "frame27": {
      "x": 0.5287,
      "y": 0.4752
    },
    "frame26": {
      "x": 0.5232,
      "y": 0.4728
    },
    "frame25": {
      "x": 0.5197,
      "y": 0.4779
    },
    "frame24": {
      "x": 0.5212,
      "y": 0.4783
    },
    "frame29": {
      "x": 0.5356,
      "y": 0.4993
    },
    "frame23": {
      "x": 0.5185,
      "y": 0.4811
    },
    "frame22": {
      "x": 0.5177,
      "y": 0.4835
    },
    "frame21": {
      "x": 0.5155,
      "y": 0.486
    },
    "frame20": {
      "x": 0.5116,
      "y": 0.4932
    },
    "frame19": {
      "x": 0.5136,
      "y": 0.4978
    },
    "frame30": {
      "x": 0.5329,
      "y": 0.523
    },
    "frame18": {
      "x": 0.511,
      "y": 0.504
    },
    "frame16": {
      "x": 0.5088,
      "y": 0.5154
    },
    "frame17": {
      "x": 0.5103,
      "y": 0.5137
    },
    "frame31": {
      "x": 0.5224,
      "y": 0.538
    },
    "frame32": {
      "x": 0.5127,
      "y": 0.5376
    },
    "frame1": {
      "x": 0.5068,
      "y": 0.5194
    },
    "frame10": {
      "x": 0.51,
      "y": 0.5157
    },
    "frame11": {
      "x": 0.5101,
      "y": 0.5152
    },
    "frame12": {
      "x": 0.5103,
      "y": 0.5147
    },
    "frame13": {
      "x": 0.5104,
      "y": 0.5148
    },
    "frame14": {
      "x": 0.5105,
      "y": 0.5145
    },
    "frame15": {
      "x": 0.5105,
      "y": 0.5146
    },
    "frame2": {
      "x": 0.5066,
      "y": 0.5193
    },
    "frame3": {
      "x": 0.5072,
      "y": 0.5198
    },
    "frame39": {
      "x": 0.4999,
      "y": 0.5163
    },
    "frame4": {
      "x": 0.5079,
      "y": 0.5186
    },
    "frame40": {
      "x": 0.5074,
      "y": 0.5173
    },
    "frame41": {
      "x": 0.5086,
      "y": 0.5182
    },
    "frame42": {
      "x": 0.5073,
      "y": 0.5194
    },
    "frame43": {
      "x": 0.5069,
      "y": 0.5198
    },
    "frame44": {
      "x": 0.5069,
      "y": 0.5192
    },
    "frame45": {
      "x": 0.5068,
      "y": 0.5194
    },
    "frame5": {
      "x": 0.5092,
      "y": 0.5184
    },
    "frame6": {
      "x": 0.5092,
      "y": 0.5181
    },
    "frame7": {
      "x": 0.5092,
      "y": 0.5183
    },
    "frame8": {
      "x": 0.5093,
      "y": 0.5181
    },
    "frame9": {
      "x": 0.5096,
      "y": 0.5172
    },
    "frame38": {
      "x": 0.4955,
      "y": 0.5137
    },
    "frame33": {
      "x": 0.4997,
      "y": 0.5271
    },
    "frame34": {
      "x": 0.4839,
      "y": 0.517
    },
    "frame37": {
      "x": 0.4852,
      "y": 0.511
    },
    "frame35": {
      "x": 0.4781,
      "y": 0.5114
    },
    "frame36": {
      "x": 0.4795,
      "y": 0.5088
    }
  },
  "p3a5": {
    "frame13": {
      "x": 0.5083,
      "y": 0.5226
    },
    "frame16": {
      "x": 0.504,
      "y": 0.522
    },
    "frame17": {
      "x": 0.5045,
      "y": 0.5182
    },
    "frame18": {
      "x": 0.5014,
      "y": 0.5204
    },
    "frame19": {
      "x": 0.5013,
      "y": 0.52
    },
    "frame20": {
      "x": 0.5021,
      "y": 0.5205
    },
    "frame21": {
      "x": 0.5018,
      "y": 0.5189
    },
    "frame22": {
      "x": 0.5065,
      "y": 0.5158
    },
    "frame23": {
      "x": 0.5036,
      "y": 0.5172
    },
    "frame24": {
      "x": 0.5064,
      "y": 0.5186
    },
    "frame25": {
      "x": 0.5126,
      "y": 0.5211
    },
    "frame26": {
      "x": 0.5082,
      "y": 0.5203
    },
    "frame1": {
      "x": 0.5091,
      "y": 0.5167
    },
    "frame27": {
      "x": 0.5091,
      "y": 0.5167
    },
    "frame12": {
      "x": 0.5071,
      "y": 0.5222
    },
    "frame14": {
      "x": 0.5082,
      "y": 0.5186
    },
    "frame9": {
      "x": 0.4984,
      "y": 0.5248
    },
    "frame15": {
      "x": 0.505,
      "y": 0.5182
    },
    "frame2": {
      "x": 0.509,
      "y": 0.5174
    },
    "frame3": {
      "x": 0.5085,
      "y": 0.5175
    },
    "frame4": {
      "x": 0.5096,
      "y": 0.5177
    },
    "frame5": {
      "x": 0.5107,
      "y": 0.5196
    },
    "frame6": {
      "x": 0.5068,
      "y": 0.5157
    },
    "frame7": {
      "x": 0.5046,
      "y": 0.518
    },
    "frame8": {
      "x": 0.4935,
      "y": 0.5214
    },
    "frame10": {
      "x": 0.4998,
      "y": 0.5249
    },
    "frame11": {
      "x": 0.5025,
      "y": 0.5183
    }
  },
  "p4a1": {
    "frame1": {
      "x": 0.4865,
      "y": 0.5236
    },
    "frame23": {
      "x": 0.4865,
      "y": 0.5236
    },
    "frame10": {
      "x": 0.4872,
      "y": 0.5238
    },
    "frame11": {
      "x": 0.4872,
      "y": 0.5238
    },
    "frame12": {
      "x": 0.4865,
      "y": 0.5236
    },
    "frame13": {
      "x": 0.4865,
      "y": 0.5236
    },
    "frame14": {
      "x": 0.4866,
      "y": 0.5241
    },
    "frame15": {
      "x": 0.4866,
      "y": 0.5241
    },
    "frame16": {
      "x": 0.4864,
      "y": 0.524
    },
    "frame17": {
      "x": 0.4864,
      "y": 0.524
    },
    "frame18": {
      "x": 0.4864,
      "y": 0.5243
    },
    "frame19": {
      "x": 0.4864,
      "y": 0.5243
    },
    "frame7": {
      "x": 0.4864,
      "y": 0.5243
    },
    "frame2": {
      "x": 0.4866,
      "y": 0.5241
    },
    "frame3": {
      "x": 0.4866,
      "y": 0.5241
    },
    "frame20": {
      "x": 0.4872,
      "y": 0.5238
    },
    "frame21": {
      "x": 0.4872,
      "y": 0.5238
    },
    "frame22": {
      "x": 0.4865,
      "y": 0.5236
    },
    "frame4": {
      "x": 0.4864,
      "y": 0.524
    },
    "frame5": {
      "x": 0.4864,
      "y": 0.524
    },
    "frame6": {
      "x": 0.4864,
      "y": 0.5243
    },
    "frame8": {
      "x": 0.4864,
      "y": 0.5243
    },
    "frame9": {
      "x": 0.4864,
      "y": 0.5243
    }
  },
  "p4a2": {
    "frame1": {
      "x": 0.4865,
      "y": 0.5236
    },
    "frame10": {
      "x": 0.4865,
      "y": 0.5223
    },
    "frame11": {
      "x": 0.4866,
      "y": 0.5235
    },
    "frame12": {
      "x": 0.4866,
      "y": 0.5205
    },
    "frame13": {
      "x": 0.4867,
      "y": 0.5188
    },
    "frame14": {
      "x": 0.4865,
      "y": 0.5183
    },
    "frame15": {
      "x": 0.4855,
      "y": 0.5186
    },
    "frame16": {
      "x": 0.4853,
      "y": 0.5182
    },
    "frame17": {
      "x": 0.4854,
      "y": 0.5179
    },
    "frame18": {
      "x": 0.4855,
      "y": 0.5183
    },
    "frame19": {
      "x": 0.4852,
      "y": 0.5192
    },
    "frame2": {
      "x": 0.4865,
      "y": 0.5234
    },
    "frame20": {
      "x": 0.485,
      "y": 0.5188
    },
    "frame21": {
      "x": 0.4863,
      "y": 0.5192
    },
    "frame22": {
      "x": 0.4863,
      "y": 0.5191
    },
    "frame23": {
      "x": 0.4863,
      "y": 0.5188
    },
    "frame24": {
      "x": 0.4864,
      "y": 0.5184
    },
    "frame25": {
      "x": 0.4865,
      "y": 0.5188
    },
    "frame26": {
      "x": 0.4864,
      "y": 0.5187
    },
    "frame27": {
      "x": 0.4866,
      "y": 0.5214
    },
    "frame28": {
      "x": 0.4864,
      "y": 0.5227
    },
    "frame29": {
      "x": 0.4864,
      "y": 0.522
    },
    "frame3": {
      "x": 0.4865,
      "y": 0.5225
    },
    "frame30": {
      "x": 0.4867,
      "y": 0.5206
    },
    "frame31": {
      "x": 0.4865,
      "y": 0.5203
    },
    "frame32": {
      "x": 0.4865,
      "y": 0.52
    },
    "frame33": {
      "x": 0.4865,
      "y": 0.5201
    },
    "frame34": {
      "x": 0.4867,
      "y": 0.5206
    },
    "frame35": {
      "x": 0.4867,
      "y": 0.5212
    },
    "frame36": {
      "x": 0.4867,
      "y": 0.5215
    },
    "frame37": {
      "x": 0.4865,
      "y": 0.5219
    },
    "frame38": {
      "x": 0.4865,
      "y": 0.5225
    },
    "frame39": {
      "x": 0.4864,
      "y": 0.5237
    },
    "frame4": {
      "x": 0.4866,
      "y": 0.5209
    },
    "frame40": {
      "x": 0.4864,
      "y": 0.5232
    },
    "frame41": {
      "x": 0.4864,
      "y": 0.5233
    },
    "frame42": {
      "x": 0.4865,
      "y": 0.5239
    },
    "frame43": {
      "x": 0.4865,
      "y": 0.5237
    },
    "frame44": {
      "x": 0.4865,
      "y": 0.5237
    },
    "frame5": {
      "x": 0.4866,
      "y": 0.5208
    },
    "frame6": {
      "x": 0.4866,
      "y": 0.5208
    },
    "frame7": {
      "x": 0.4866,
      "y": 0.5208
    },
    "frame8": {
      "x": 0.4866,
      "y": 0.521
    },
    "frame9": {
      "x": 0.4867,
      "y": 0.5213
    }
  },
  "p4a3": {
    "frame1": {
      "x": 0.4865,
      "y": 0.5236
    },
    "frame38": {
      "x": 0.4865,
      "y": 0.5236
    },
    "frame10": {
      "x": 0.4864,
      "y": 0.5231
    },
    "frame11": {
      "x": 0.4865,
      "y": 0.522
    },
    "frame12": {
      "x": 0.4866,
      "y": 0.5216
    },
    "frame13": {
      "x": 0.4865,
      "y": 0.5224
    },
    "frame14": {
      "x": 0.4865,
      "y": 0.5223
    },
    "frame15": {
      "x": 0.4863,
      "y": 0.5232
    },
    "frame16": {
      "x": 0.4866,
      "y": 0.5224
    },
    "frame17": {
      "x": 0.4863,
      "y": 0.5231
    },
    "frame18": {
      "x": 0.4864,
      "y": 0.5231
    },
    "frame19": {
      "x": 0.4865,
      "y": 0.522
    },
    "frame2": {
      "x": 0.4865,
      "y": 0.5237
    },
    "frame20": {
      "x": 0.4866,
      "y": 0.5216
    },
    "frame21": {
      "x": 0.4865,
      "y": 0.5224
    },
    "frame22": {
      "x": 0.4865,
      "y": 0.5223
    },
    "frame23": {
      "x": 0.4863,
      "y": 0.5232
    },
    "frame24": {
      "x": 0.4866,
      "y": 0.5224
    },
    "frame25": {
      "x": 0.4864,
      "y": 0.5231
    },
    "frame26": {
      "x": 0.4865,
      "y": 0.5213
    },
    "frame27": {
      "x": 0.4866,
      "y": 0.5208
    },
    "frame28": {
      "x": 0.4863,
      "y": 0.5207
    },
    "frame29": {
      "x": 0.4864,
      "y": 0.5198
    },
    "frame3": {
      "x": 0.4864,
      "y": 0.5225
    },
    "frame30": {
      "x": 0.4865,
      "y": 0.5191
    },
    "frame31": {
      "x": 0.4865,
      "y": 0.5191
    },
    "frame32": {
      "x": 0.4866,
      "y": 0.5197
    },
    "frame33": {
      "x": 0.4865,
      "y": 0.5207
    },
    "frame34": {
      "x": 0.4864,
      "y": 0.5227
    },
    "frame35": {
      "x": 0.4866,
      "y": 0.5234
    },
    "frame36": {
      "x": 0.4865,
      "y": 0.5234
    },
    "frame37": {
      "x": 0.4865,
      "y": 0.5237
    },
    "frame4": {
      "x": 0.4864,
      "y": 0.5219
    },
    "frame5": {
      "x": 0.4865,
      "y": 0.5226
    },
    "frame6": {
      "x": 0.4865,
      "y": 0.5221
    },
    "frame7": {
      "x": 0.4864,
      "y": 0.5231
    },
    "frame8": {
      "x": 0.4866,
      "y": 0.5224
    },
    "frame9": {
      "x": 0.4863,
      "y": 0.5231
    }
  },
  "p4a4": {
    "frame1": {
      "x": 0.4865,
      "y": 0.5236
    },
    "frame67": {
      "x": 0.4865,
      "y": 0.5236
    },
    "frame10": {
      "x": 0.4866,
      "y": 0.5226
    },
    "frame11": {
      "x": 0.4866,
      "y": 0.523
    },
    "frame12": {
      "x": 0.4869,
      "y": 0.5234
    },
    "frame13": {
      "x": 0.4866,
      "y": 0.5228
    },
    "frame14": {
      "x": 0.4864,
      "y": 0.5223
    },
    "frame15": {
      "x": 0.4867,
      "y": 0.5231
    },
    "frame16": {
      "x": 0.4854,
      "y": 0.5238
    },
    "frame17": {
      "x": 0.4849,
      "y": 0.5261
    },
    "frame18": {
      "x": 0.4854,
      "y": 0.5243
    },
    "frame19": {
      "x": 0.4858,
      "y": 0.5237
    },
    "frame2": {
      "x": 0.4865,
      "y": 0.5233
    },
    "frame20": {
      "x": 0.4857,
      "y": 0.5244
    },
    "frame21": {
      "x": 0.4841,
      "y": 0.5275
    },
    "frame29": {
      "x": 0.4849,
      "y": 0.5286
    },
    "frame3": {
      "x": 0.4865,
      "y": 0.5235
    },
    "frame38": {
      "x": 0.4878,
      "y": 0.5258
    },
    "frame39": {
      "x": 0.4859,
      "y": 0.5248
    },
    "frame4": {
      "x": 0.4864,
      "y": 0.5242
    },
    "frame40": {
      "x": 0.4872,
      "y": 0.5222
    },
    "frame41": {
      "x": 0.4866,
      "y": 0.5209
    },
    "frame42": {
      "x": 0.4867,
      "y": 0.5207
    },
    "frame43": {
      "x": 0.4865,
      "y": 0.5215
    },
    "frame44": {
      "x": 0.4864,
      "y": 0.5215
    },
    "frame45": {
      "x": 0.4863,
      "y": 0.5219
    },
    "frame46": {
      "x": 0.4862,
      "y": 0.5216
    },
    "frame47": {
      "x": 0.4864,
      "y": 0.5215
    },
    "frame48": {
      "x": 0.4863,
      "y": 0.5213
    },
    "frame49": {
      "x": 0.4865,
      "y": 0.5206
    },
    "frame5": {
      "x": 0.4865,
      "y": 0.5234
    },
    "frame50": {
      "x": 0.4866,
      "y": 0.5201
    },
    "frame51": {
      "x": 0.4866,
      "y": 0.5203
    },
    "frame52": {
      "x": 0.4865,
      "y": 0.5204
    },
    "frame53": {
      "x": 0.4864,
      "y": 0.5205
    },
    "frame54": {
      "x": 0.4866,
      "y": 0.5203
    },
    "frame55": {
      "x": 0.4866,
      "y": 0.5202
    },
    "frame56": {
      "x": 0.4866,
      "y": 0.5206
    },
    "frame57": {
      "x": 0.4864,
      "y": 0.521
    },
    "frame58": {
      "x": 0.4866,
      "y": 0.5214
    },
    "frame59": {
      "x": 0.4867,
      "y": 0.5216
    },
    "frame6": {
      "x": 0.4865,
      "y": 0.5225
    },
    "frame30": {
      "x": 0.4863,
      "y": 0.5363
    },
    "frame60": {
      "x": 0.4865,
      "y": 0.5226
    },
    "frame61": {
      "x": 0.4864,
      "y": 0.5234
    },
    "frame62": {
      "x": 0.4865,
      "y": 0.5232
    },
    "frame63": {
      "x": 0.4864,
      "y": 0.5238
    },
    "frame64": {
      "x": 0.4865,
      "y": 0.5236
    },
    "frame65": {
      "x": 0.4865,
      "y": 0.5238
    },
    "frame31": {
      "x": 0.4868,
      "y": 0.5372
    },
    "frame66": {
      "x": 0.4865,
      "y": 0.5237
    },
    "frame7": {
      "x": 0.4866,
      "y": 0.5223
    },
    "frame8": {
      "x": 0.4865,
      "y": 0.5224
    },
    "frame9": {
      "x": 0.4866,
      "y": 0.5226
    },
    "frame22": {
      "x": 0.4848,
      "y": 0.5264
    },
    "frame27": {
      "x": 0.4842,
      "y": 0.5348
    },
    "frame23": {
      "x": 0.485,
      "y": 0.5282
    },
    "frame24": {
      "x": 0.4841,
      "y": 0.5294
    },
    "frame25": {
      "x": 0.4839,
      "y": 0.5324
    },
    "frame26": {
      "x": 0.4835,
      "y": 0.5366
    },
    "frame36": {
      "x": 0.4893,
      "y": 0.5251
    },
    "frame37": {
      "x": 0.4877,
      "y": 0.525
    },
    "frame28": {
      "x": 0.4843,
      "y": 0.534
    },
    "frame34": {
      "x": 0.4889,
      "y": 0.5276
    },
    "frame35": {
      "x": 0.4893,
      "y": 0.5246
    },
    "frame32": {
      "x": 0.4878,
      "y": 0.5321
    },
    "frame33": {
      "x": 0.4894,
      "y": 0.5271
    }
  },
  "p4a5": {
    "frame57": {
      "x": 0.4163,
      "y": 0.5345
    },
    "frame55": {
      "x": 0.417,
      "y": 0.5296
    },
    "frame56": {
      "x": 0.4179,
      "y": 0.5308
    },
    "frame54": {
      "x": 0.4206,
      "y": 0.5284
    },
    "frame50": {
      "x": 0.4561,
      "y": 0.5284
    },
    "frame51": {
      "x": 0.4436,
      "y": 0.5281
    },
    "frame52": {
      "x": 0.4357,
      "y": 0.5275
    },
    "frame53": {
      "x": 0.4269,
      "y": 0.5281
    },
    "frame59": {
      "x": 0.4026,
      "y": 0.5376
    },
    "frame58": {
      "x": 0.4118,
      "y": 0.5357
    },
    "frame25": {
      "x": 0.514,
      "y": 0.509
    },
    "frame19": {
      "x": 0.5649,
      "y": 0.5271
    },
    "frame20": {
      "x": 0.5633,
      "y": 0.5228
    },
    "frame21": {
      "x": 0.5528,
      "y": 0.5227
    },
    "frame22": {
      "x": 0.5459,
      "y": 0.5236
    },
    "frame26": {
      "x": 0.508,
      "y": 0.5082
    },
    "frame23": {
      "x": 0.537,
      "y": 0.5206
    },
    "frame24": {
      "x": 0.5257,
      "y": 0.5131
    },
    "frame34": {
      "x": 0.5087,
      "y": 0.4977
    },
    "frame27": {
      "x": 0.5029,
      "y": 0.5076
    },
    "frame28": {
      "x": 0.5074,
      "y": 0.5072
    },
    "frame29": {
      "x": 0.5063,
      "y": 0.5032
    },
    "frame30": {
      "x": 0.5019,
      "y": 0.4976
    },
    "frame31": {
      "x": 0.5008,
      "y": 0.4973
    },
    "frame32": {
      "x": 0.5005,
      "y": 0.4976
    },
    "frame33": {
      "x": 0.5042,
      "y": 0.4998
    },
    "frame35": {
      "x": 0.5056,
      "y": 0.496
    },
    "frame36": {
      "x": 0.503,
      "y": 0.4961
    },
    "frame37": {
      "x": 0.4984,
      "y": 0.4999
    },
    "frame38": {
      "x": 0.4976,
      "y": 0.5004
    },
    "frame60": {
      "x": 0.3983,
      "y": 0.5415
    },
    "frame49": {
      "x": 0.4629,
      "y": 0.5212
    },
    "frame39": {
      "x": 0.4949,
      "y": 0.4965
    },
    "frame62": {
      "x": 0.393,
      "y": 0.5453
    },
    "frame63": {
      "x": 0.3934,
      "y": 0.5451
    },
    "frame64": {
      "x": 0.3927,
      "y": 0.5449
    },
    "frame65": {
      "x": 0.3927,
      "y": 0.5446
    },
    "frame66": {
      "x": 0.3924,
      "y": 0.5451
    },
    "frame67": {
      "x": 0.3913,
      "y": 0.5433
    },
    "frame68": {
      "x": 0.3903,
      "y": 0.5429
    },
    "frame69": {
      "x": 0.3888,
      "y": 0.5417
    },
    "frame61": {
      "x": 0.3922,
      "y": 0.5417
    },
    "frame18": {
      "x": 0.5718,
      "y": 0.5281
    },
    "frame40": {
      "x": 0.4908,
      "y": 0.4947
    },
    "frame70": {
      "x": 0.3877,
      "y": 0.5433
    },
    "frame41": {
      "x": 0.4894,
      "y": 0.4968
    },
    "frame48": {
      "x": 0.475,
      "y": 0.5179
    },
    "frame17": {
      "x": 0.5751,
      "y": 0.5286
    },
    "frame78": {
      "x": 0.4905,
      "y": 0.5463
    },
    "frame42": {
      "x": 0.4854,
      "y": 0.4958
    },
    "frame16": {
      "x": 0.5785,
      "y": 0.5353
    },
    "frame47": {
      "x": 0.4865,
      "y": 0.5097
    },
    "frame75": {
      "x": 0.4902,
      "y": 0.5565
    },
    "frame77": {
      "x": 0.4911,
      "y": 0.5472
    },
    "frame79": {
      "x": 0.4911,
      "y": 0.5431
    },
    "frame71": {
      "x": 0.3875,
      "y": 0.5588
    },
    "frame72": {
      "x": 0.3874,
      "y": 0.5585
    },
    "frame15": {
      "x": 0.5884,
      "y": 0.5348
    },
    "frame43": {
      "x": 0.4805,
      "y": 0.5008
    },
    "frame73": {
      "x": 0.4842,
      "y": 0.5612
    },
    "frame74": {
      "x": 0.4854,
      "y": 0.558
    },
    "frame76": {
      "x": 0.4883,
      "y": 0.5516
    },
    "frame80": {
      "x": 0.4908,
      "y": 0.5369
    },
    "frame14": {
      "x": 0.5966,
      "y": 0.5325
    },
    "frame13": {
      "x": 0.6063,
      "y": 0.5322
    },
    "frame46": {
      "x": 0.4841,
      "y": 0.5084
    },
    "frame44": {
      "x": 0.478,
      "y": 0.5007
    },
    "frame81": {
      "x": 0.4929,
      "y": 0.5318
    },
    "frame12": {
      "x": 0.6107,
      "y": 0.529
    },
    "frame10": {
      "x": 0.6106,
      "y": 0.5252
    },
    "frame11": {
      "x": 0.6085,
      "y": 0.5269
    },
    "frame3": {
      "x": 0.619,
      "y": 0.518
    },
    "frame4": {
      "x": 0.6164,
      "y": 0.52
    },
    "frame5": {
      "x": 0.6149,
      "y": 0.5213
    },
    "frame6": {
      "x": 0.6144,
      "y": 0.5218
    },
    "frame7": {
      "x": 0.614,
      "y": 0.5222
    },
    "frame8": {
      "x": 0.6135,
      "y": 0.5228
    },
    "frame9": {
      "x": 0.612,
      "y": 0.5242
    },
    "frame45": {
      "x": 0.4811,
      "y": 0.4987
    },
    "frame82": {
      "x": 0.4939,
      "y": 0.5271
    },
    "frame88": {
      "x": 0.4899,
      "y": 0.5248
    },
    "frame89": {
      "x": 0.4872,
      "y": 0.5214
    },
    "frame90": {
      "x": 0.4882,
      "y": 0.5191
    },
    "frame2": {
      "x": 0.62,
      "y": 0.5235
    },
    "frame85": {
      "x": 0.4933,
      "y": 0.5245
    },
    "frame86": {
      "x": 0.4924,
      "y": 0.5244
    },
    "frame87": {
      "x": 0.4877,
      "y": 0.5224
    },
    "frame91": {
      "x": 0.4876,
      "y": 0.5205
    },
    "frame1": {
      "x": 0.4865,
      "y": 0.5236
    },
    "frame106": {
      "x": 0.4865,
      "y": 0.5236
    },
    "frame100": {
      "x": 0.4864,
      "y": 0.5212
    },
    "frame101": {
      "x": 0.4866,
      "y": 0.5218
    },
    "frame102": {
      "x": 0.4865,
      "y": 0.523
    },
    "frame103": {
      "x": 0.4865,
      "y": 0.5232
    },
    "frame104": {
      "x": 0.4865,
      "y": 0.5237
    },
    "frame105": {
      "x": 0.4865,
      "y": 0.5233
    },
    "frame92": {
      "x": 0.491,
      "y": 0.5171
    },
    "frame93": {
      "x": 0.488,
      "y": 0.5161
    },
    "frame94": {
      "x": 0.4866,
      "y": 0.517
    },
    "frame95": {
      "x": 0.4867,
      "y": 0.5169
    },
    "frame96": {
      "x": 0.4866,
      "y": 0.5178
    },
    "frame97": {
      "x": 0.4868,
      "y": 0.5183
    },
    "frame98": {
      "x": 0.4866,
      "y": 0.5193
    },
    "frame99": {
      "x": 0.4865,
      "y": 0.5206
    },
    "frame84": {
      "x": 0.4898,
      "y": 0.5277
    },
    "frame83": {
      "x": 0.4919,
      "y": 0.5202
    }
  },
  "p5a1": {
    "frame1": {
      "x": 0.5023,
      "y": 0.463
    },
    "frame10": {
      "x": 0.5025,
      "y": 0.4632
    },
    "frame11": {
      "x": 0.5022,
      "y": 0.4632
    },
    "frame12": {
      "x": 0.5023,
      "y": 0.4632
    },
    "frame13": {
      "x": 0.5021,
      "y": 0.4633
    },
    "frame22": {
      "x": 0.5021,
      "y": 0.4633
    },
    "frame23": {
      "x": 0.5021,
      "y": 0.4633
    },
    "frame24": {
      "x": 0.5021,
      "y": 0.4633
    },
    "frame14": {
      "x": 0.502,
      "y": 0.4634
    },
    "frame15": {
      "x": 0.502,
      "y": 0.4633
    },
    "frame16": {
      "x": 0.5022,
      "y": 0.4631
    },
    "frame17": {
      "x": 0.5016,
      "y": 0.4638
    },
    "frame18": {
      "x": 0.5021,
      "y": 0.4642
    },
    "frame19": {
      "x": 0.5018,
      "y": 0.4632
    },
    "frame2": {
      "x": 0.5022,
      "y": 0.4636
    },
    "frame20": {
      "x": 0.5021,
      "y": 0.4628
    },
    "frame21": {
      "x": 0.5021,
      "y": 0.4634
    },
    "frame3": {
      "x": 0.502,
      "y": 0.463
    },
    "frame4": {
      "x": 0.5019,
      "y": 0.4628
    },
    "frame5": {
      "x": 0.5027,
      "y": 0.4638
    },
    "frame6": {
      "x": 0.5026,
      "y": 0.4639
    },
    "frame7": {
      "x": 0.5022,
      "y": 0.4637
    },
    "frame8": {
      "x": 0.5021,
      "y": 0.4638
    },
    "frame9": {
      "x": 0.5024,
      "y": 0.463
    }
  },
  "p5a2": {
    "frame15": {
      "x": 0.5133,
      "y": 0.4564
    },
    "frame16": {
      "x": 0.5154,
      "y": 0.4552
    },
    "frame17": {
      "x": 0.5159,
      "y": 0.4542
    },
    "frame21": {
      "x": 0.5142,
      "y": 0.4631
    },
    "frame22": {
      "x": 0.5149,
      "y": 0.4604
    },
    "frame23": {
      "x": 0.5163,
      "y": 0.4598
    },
    "frame24": {
      "x": 0.5183,
      "y": 0.4587
    },
    "frame25": {
      "x": 0.5187,
      "y": 0.4565
    },
    "frame26": {
      "x": 0.5191,
      "y": 0.4567
    },
    "frame27": {
      "x": 0.5172,
      "y": 0.4598
    },
    "frame28": {
      "x": 0.5164,
      "y": 0.4587
    },
    "frame29": {
      "x": 0.513,
      "y": 0.4598
    },
    "frame30": {
      "x": 0.5124,
      "y": 0.4628
    },
    "frame31": {
      "x": 0.5117,
      "y": 0.4658
    },
    "frame35": {
      "x": 0.5139,
      "y": 0.4589
    },
    "frame36": {
      "x": 0.5138,
      "y": 0.4585
    },
    "frame37": {
      "x": 0.512,
      "y": 0.4612
    },
    "frame38": {
      "x": 0.5121,
      "y": 0.4636
    },
    "frame39": {
      "x": 0.5128,
      "y": 0.4655
    },
    "frame40": {
      "x": 0.5139,
      "y": 0.4678
    },
    "frame43": {
      "x": 0.5132,
      "y": 0.4708
    },
    "frame11": {
      "x": 0.5144,
      "y": 0.4565
    },
    "frame12": {
      "x": 0.5169,
      "y": 0.461
    },
    "frame13": {
      "x": 0.5138,
      "y": 0.4641
    },
    "frame14": {
      "x": 0.514,
      "y": 0.4623
    },
    "frame18": {
      "x": 0.5162,
      "y": 0.4567
    },
    "frame19": {
      "x": 0.5159,
      "y": 0.4593
    },
    "frame20": {
      "x": 0.5151,
      "y": 0.4603
    },
    "frame32": {
      "x": 0.5125,
      "y": 0.4612
    },
    "frame33": {
      "x": 0.5143,
      "y": 0.4626
    },
    "frame34": {
      "x": 0.5143,
      "y": 0.4613
    },
    "frame41": {
      "x": 0.5158,
      "y": 0.4701
    },
    "frame42": {
      "x": 0.5171,
      "y": 0.4729
    },
    "frame44": {
      "x": 0.5133,
      "y": 0.4698
    },
    "frame45": {
      "x": 0.5134,
      "y": 0.4733
    },
    "frame46": {
      "x": 0.5138,
      "y": 0.4707
    },
    "frame47": {
      "x": 0.5099,
      "y": 0.4699
    },
    "frame10": {
      "x": 0.515,
      "y": 0.4538
    },
    "frame49": {
      "x": 0.5068,
      "y": 0.4745
    },
    "frame6": {
      "x": 0.5092,
      "y": 0.4478
    },
    "frame7": {
      "x": 0.5119,
      "y": 0.4493
    },
    "frame8": {
      "x": 0.5125,
      "y": 0.4515
    },
    "frame9": {
      "x": 0.5167,
      "y": 0.4505
    },
    "frame3": {
      "x": 0.501,
      "y": 0.46
    },
    "frame4": {
      "x": 0.5032,
      "y": 0.4513
    },
    "frame48": {
      "x": 0.5121,
      "y": 0.4745
    },
    "frame5": {
      "x": 0.5074,
      "y": 0.4527
    },
    "frame50": {
      "x": 0.5058,
      "y": 0.4716
    },
    "frame51": {
      "x": 0.5037,
      "y": 0.4692
    },
    "frame1": {
      "x": 0.5022,
      "y": 0.4629
    },
    "frame2": {
      "x": 0.5033,
      "y": 0.4602
    },
    "frame52": {
      "x": 0.5036,
      "y": 0.4672
    },
    "frame53": {
      "x": 0.5004,
      "y": 0.4641
    },
    "frame54": {
      "x": 0.5007,
      "y": 0.4645
    },
    "frame55": {
      "x": 0.4997,
      "y": 0.4619
    },
    "frame56": {
      "x": 0.502,
      "y": 0.4632
    },
    "frame57": {
      "x": 0.502,
      "y": 0.4632
    },
    "frame58": {
      "x": 0.502,
      "y": 0.4632
    }
  },
  "p5a3": {
    "frame60": {
      "x": 0.4623,
      "y": 0.5184
    },
    "frame61": {
      "x": 0.4628,
      "y": 0.5182
    },
    "frame62": {
      "x": 0.4627,
      "y": 0.514
    },
    "frame63": {
      "x": 0.4623,
      "y": 0.515
    },
    "frame64": {
      "x": 0.4621,
      "y": 0.5158
    },
    "frame65": {
      "x": 0.4622,
      "y": 0.5155
    },
    "frame66": {
      "x": 0.4625,
      "y": 0.5153
    },
    "frame67": {
      "x": 0.4625,
      "y": 0.5157
    },
    "frame68": {
      "x": 0.4617,
      "y": 0.5166
    },
    "frame69": {
      "x": 0.4623,
      "y": 0.5162
    },
    "frame70": {
      "x": 0.4624,
      "y": 0.5151
    },
    "frame71": {
      "x": 0.4626,
      "y": 0.515
    },
    "frame72": {
      "x": 0.462,
      "y": 0.5156
    },
    "frame73": {
      "x": 0.462,
      "y": 0.5155
    },
    "frame74": {
      "x": 0.4621,
      "y": 0.5155
    },
    "frame75": {
      "x": 0.4621,
      "y": 0.5154
    },
    "frame76": {
      "x": 0.4622,
      "y": 0.5154
    },
    "frame77": {
      "x": 0.4622,
      "y": 0.5153
    },
    "frame78": {
      "x": 0.4622,
      "y": 0.5152
    },
    "frame79": {
      "x": 0.4622,
      "y": 0.5152
    },
    "frame80": {
      "x": 0.4623,
      "y": 0.5152
    },
    "frame81": {
      "x": 0.4623,
      "y": 0.5151
    },
    "frame82": {
      "x": 0.4623,
      "y": 0.5151
    },
    "frame83": {
      "x": 0.463,
      "y": 0.5142
    },
    "frame84": {
      "x": 0.4618,
      "y": 0.5096
    },
    "frame59": {
      "x": 0.4663,
      "y": 0.5172
    },
    "frame27": {
      "x": 0.5501,
      "y": 0.4833
    },
    "frame28": {
      "x": 0.5547,
      "y": 0.4838
    },
    "frame26": {
      "x": 0.5518,
      "y": 0.4893
    },
    "frame85": {
      "x": 0.4617,
      "y": 0.5072
    },
    "frame29": {
      "x": 0.5523,
      "y": 0.4834
    },
    "frame30": {
      "x": 0.5528,
      "y": 0.4847
    },
    "frame25": {
      "x": 0.55,
      "y": 0.486
    },
    "frame31": {
      "x": 0.5526,
      "y": 0.4856
    },
    "frame32": {
      "x": 0.5525,
      "y": 0.4847
    },
    "frame33": {
      "x": 0.5522,
      "y": 0.4848
    },
    "frame34": {
      "x": 0.5514,
      "y": 0.4863
    },
    "frame20": {
      "x": 0.5169,
      "y": 0.4707
    },
    "frame35": {
      "x": 0.552,
      "y": 0.4885
    },
    "frame36": {
      "x": 0.5522,
      "y": 0.4891
    },
    "frame37": {
      "x": 0.553,
      "y": 0.4893
    },
    "frame91": {
      "x": 0.4948,
      "y": 0.464
    },
    "frame38": {
      "x": 0.5529,
      "y": 0.4915
    },
    "frame39": {
      "x": 0.5533,
      "y": 0.4904
    },
    "frame24": {
      "x": 0.5414,
      "y": 0.4824
    },
    "frame40": {
      "x": 0.5524,
      "y": 0.4889
    },
    "frame41": {
      "x": 0.552,
      "y": 0.4888
    },
    "frame42": {
      "x": 0.5512,
      "y": 0.488
    },
    "frame43": {
      "x": 0.5518,
      "y": 0.4865
    },
    "frame44": {
      "x": 0.5523,
      "y": 0.4866
    },
    "frame45": {
      "x": 0.5527,
      "y": 0.4859
    },
    "frame46": {
      "x": 0.5514,
      "y": 0.4856
    },
    "frame47": {
      "x": 0.5496,
      "y": 0.4872
    },
    "frame58": {
      "x": 0.4625,
      "y": 0.5179
    },
    "frame90": {
      "x": 0.4853,
      "y": 0.4726
    },
    "frame87": {
      "x": 0.4657,
      "y": 0.4993
    },
    "frame89": {
      "x": 0.4804,
      "y": 0.48
    },
    "frame48": {
      "x": 0.5453,
      "y": 0.4848
    },
    "frame86": {
      "x": 0.4575,
      "y": 0.5038
    },
    "frame88": {
      "x": 0.4783,
      "y": 0.4897
    },
    "frame57": {
      "x": 0.4701,
      "y": 0.5121
    },
    "frame23": {
      "x": 0.5363,
      "y": 0.4828
    },
    "frame92": {
      "x": 0.4997,
      "y": 0.4599
    },
    "frame49": {
      "x": 0.5349,
      "y": 0.4854
    },
    "frame17": {
      "x": 0.5074,
      "y": 0.4681
    },
    "frame93": {
      "x": 0.5061,
      "y": 0.4539
    },
    "frame94": {
      "x": 0.5056,
      "y": 0.4515
    },
    "frame95": {
      "x": 0.5029,
      "y": 0.4535
    },
    "frame96": {
      "x": 0.5043,
      "y": 0.452
    },
    "frame56": {
      "x": 0.4782,
      "y": 0.5028
    },
    "frame1": {
      "x": 0.5016,
      "y": 0.4635
    },
    "frame10": {
      "x": 0.5012,
      "y": 0.4637
    },
    "frame100": {
      "x": 0.5044,
      "y": 0.4492
    },
    "frame101": {
      "x": 0.5034,
      "y": 0.4497
    },
    "frame102": {
      "x": 0.5029,
      "y": 0.4515
    },
    "frame103": {
      "x": 0.5029,
      "y": 0.4519
    },
    "frame104": {
      "x": 0.5028,
      "y": 0.4533
    },
    "frame105": {
      "x": 0.5027,
      "y": 0.4542
    },
    "frame106": {
      "x": 0.5028,
      "y": 0.4521
    },
    "frame107": {
      "x": 0.5029,
      "y": 0.4509
    },
    "frame108": {
      "x": 0.503,
      "y": 0.4497
    },
    "frame109": {
      "x": 0.5032,
      "y": 0.4478
    },
    "frame11": {
      "x": 0.5016,
      "y": 0.4631
    },
    "frame110": {
      "x": 0.5031,
      "y": 0.4479
    },
    "frame111": {
      "x": 0.5026,
      "y": 0.4488
    },
    "frame112": {
      "x": 0.5021,
      "y": 0.4514
    },
    "frame113": {
      "x": 0.5021,
      "y": 0.453
    },
    "frame114": {
      "x": 0.5023,
      "y": 0.4542
    },
    "frame115": {
      "x": 0.5013,
      "y": 0.4567
    },
    "frame116": {
      "x": 0.5013,
      "y": 0.4589
    },
    "frame117": {
      "x": 0.5011,
      "y": 0.4615
    },
    "frame118": {
      "x": 0.5011,
      "y": 0.4631
    },
    "frame119": {
      "x": 0.5013,
      "y": 0.4635
    },
    "frame12": {
      "x": 0.5015,
      "y": 0.4636
    },
    "frame120": {
      "x": 0.5014,
      "y": 0.4638
    },
    "frame13": {
      "x": 0.5019,
      "y": 0.4634
    },
    "frame14": {
      "x": 0.5012,
      "y": 0.4642
    },
    "frame15": {
      "x": 0.5014,
      "y": 0.4644
    },
    "frame16": {
      "x": 0.5019,
      "y": 0.463
    },
    "frame18": {
      "x": 0.5091,
      "y": 0.4641
    },
    "frame2": {
      "x": 0.5017,
      "y": 0.463
    },
    "frame3": {
      "x": 0.5017,
      "y": 0.4634
    },
    "frame54": {
      "x": 0.5041,
      "y": 0.4752
    },
    "frame53": {
      "x": 0.5067,
      "y": 0.4698
    },
    "frame50": {
      "x": 0.5245,
      "y": 0.4847
    },
    "frame4": {
      "x": 0.5018,
      "y": 0.4629
    },
    "frame5": {
      "x": 0.502,
      "y": 0.4625
    },
    "frame6": {
      "x": 0.5011,
      "y": 0.4635
    },
    "frame7": {
      "x": 0.5017,
      "y": 0.4632
    },
    "frame8": {
      "x": 0.5016,
      "y": 0.4638
    },
    "frame55": {
      "x": 0.4942,
      "y": 0.4867
    },
    "frame9": {
      "x": 0.5016,
      "y": 0.4639
    },
    "frame51": {
      "x": 0.5045,
      "y": 0.4825
    },
    "frame97": {
      "x": 0.5046,
      "y": 0.4506
    },
    "frame98": {
      "x": 0.5044,
      "y": 0.4476
    },
    "frame99": {
      "x": 0.5041,
      "y": 0.4489
    },
    "frame22": {
      "x": 0.5247,
      "y": 0.4779
    },
    "frame19": {
      "x": 0.518,
      "y": 0.4668
    },
    "frame21": {
      "x": 0.511,
      "y": 0.4744
    },
    "frame52": {
      "x": 0.5104,
      "y": 0.4707
    }
  },
  "p5a4": {
    "frame77": {
      "x": 0.4737,
      "y": 0.4801
    },
    "frame79": {
      "x": 0.4706,
      "y": 0.4788
    },
    "frame80": {
      "x": 0.4744,
      "y": 0.4826
    },
    "frame81": {
      "x": 0.4717,
      "y": 0.4819
    },
    "frame82": {
      "x": 0.4754,
      "y": 0.4799
    },
    "frame76": {
      "x": 0.4772,
      "y": 0.4777
    },
    "frame78": {
      "x": 0.4733,
      "y": 0.4795
    },
    "frame83": {
      "x": 0.4746,
      "y": 0.4739
    },
    "frame73": {
      "x": 0.4854,
      "y": 0.4725
    },
    "frame74": {
      "x": 0.4836,
      "y": 0.4784
    },
    "frame75": {
      "x": 0.4804,
      "y": 0.4781
    },
    "frame84": {
      "x": 0.4789,
      "y": 0.4697
    },
    "frame85": {
      "x": 0.4805,
      "y": 0.4681
    },
    "frame69": {
      "x": 0.505,
      "y": 0.4633
    },
    "frame71": {
      "x": 0.4975,
      "y": 0.4669
    },
    "frame72": {
      "x": 0.4928,
      "y": 0.4753
    },
    "frame67": {
      "x": 0.5096,
      "y": 0.4522
    },
    "frame68": {
      "x": 0.5067,
      "y": 0.4595
    },
    "frame70": {
      "x": 0.5019,
      "y": 0.4699
    },
    "frame86": {
      "x": 0.4797,
      "y": 0.4631
    },
    "frame64": {
      "x": 0.5181,
      "y": 0.4342
    },
    "frame65": {
      "x": 0.5129,
      "y": 0.4414
    },
    "frame66": {
      "x": 0.5111,
      "y": 0.4503
    },
    "frame62": {
      "x": 0.5203,
      "y": 0.4381
    },
    "frame63": {
      "x": 0.5195,
      "y": 0.439
    },
    "frame88": {
      "x": 0.4817,
      "y": 0.4691
    },
    "frame60": {
      "x": 0.5213,
      "y": 0.4361
    },
    "frame61": {
      "x": 0.5185,
      "y": 0.439
    },
    "frame87": {
      "x": 0.4811,
      "y": 0.4604
    },
    "frame89": {
      "x": 0.4806,
      "y": 0.4661
    },
    "frame56": {
      "x": 0.5216,
      "y": 0.4413
    },
    "frame57": {
      "x": 0.5199,
      "y": 0.4432
    },
    "frame58": {
      "x": 0.5197,
      "y": 0.4386
    },
    "frame59": {
      "x": 0.5234,
      "y": 0.4386
    },
    "frame90": {
      "x": 0.4808,
      "y": 0.4598
    },
    "frame91": {
      "x": 0.4829,
      "y": 0.4599
    },
    "frame92": {
      "x": 0.4856,
      "y": 0.4565
    },
    "frame55": {
      "x": 0.5181,
      "y": 0.4451
    },
    "frame93": {
      "x": 0.49,
      "y": 0.4501
    },
    "frame94": {
      "x": 0.4951,
      "y": 0.4437
    },
    "frame54": {
      "x": 0.5161,
      "y": 0.4488
    },
    "frame53": {
      "x": 0.5124,
      "y": 0.4584
    },
    "frame95": {
      "x": 0.4986,
      "y": 0.4455
    },
    "frame96": {
      "x": 0.4998,
      "y": 0.4418
    },
    "frame97": {
      "x": 0.5009,
      "y": 0.4416
    },
    "frame52": {
      "x": 0.5048,
      "y": 0.4607
    },
    "frame98": {
      "x": 0.5013,
      "y": 0.4441
    },
    "frame1": {
      "x": 0.5016,
      "y": 0.4635
    },
    "frame10": {
      "x": 0.499,
      "y": 0.4616
    },
    "frame100": {
      "x": 0.5034,
      "y": 0.4438
    },
    "frame101": {
      "x": 0.5053,
      "y": 0.4456
    },
    "frame102": {
      "x": 0.5013,
      "y": 0.4457
    },
    "frame103": {
      "x": 0.5008,
      "y": 0.4454
    },
    "frame104": {
      "x": 0.5007,
      "y": 0.4467
    },
    "frame2": {
      "x": 0.5017,
      "y": 0.4633
    },
    "frame3": {
      "x": 0.5017,
      "y": 0.4633
    },
    "frame105": {
      "x": 0.5005,
      "y": 0.4486
    },
    "frame4": {
      "x": 0.5017,
      "y": 0.4633
    },
    "frame5": {
      "x": 0.5018,
      "y": 0.4632
    },
    "frame106": {
      "x": 0.4999,
      "y": 0.4521
    },
    "frame107": {
      "x": 0.4994,
      "y": 0.4551
    },
    "frame108": {
      "x": 0.4993,
      "y": 0.4566
    },
    "frame109": {
      "x": 0.4993,
      "y": 0.4596
    },
    "frame11": {
      "x": 0.4988,
      "y": 0.4619
    },
    "frame110": {
      "x": 0.4992,
      "y": 0.4595
    },
    "frame99": {
      "x": 0.5032,
      "y": 0.4465
    },
    "frame111": {
      "x": 0.4992,
      "y": 0.4612
    },
    "frame112": {
      "x": 0.4991,
      "y": 0.4613
    },
    "frame113": {
      "x": 0.499,
      "y": 0.4624
    },
    "frame114": {
      "x": 0.499,
      "y": 0.4626
    },
    "frame115": {
      "x": 0.4991,
      "y": 0.4623
    },
    "frame116": {
      "x": 0.4993,
      "y": 0.462
    },
    "frame117": {
      "x": 0.4993,
      "y": 0.4625
    },
    "frame118": {
      "x": 0.4993,
      "y": 0.4625
    },
    "frame119": {
      "x": 0.4993,
      "y": 0.4625
    },
    "frame120": {
      "x": 0.4993,
      "y": 0.4625
    },
    "frame12": {
      "x": 0.4991,
      "y": 0.4618
    },
    "frame13": {
      "x": 0.4994,
      "y": 0.4616
    },
    "frame14": {
      "x": 0.4995,
      "y": 0.4617
    },
    "frame15": {
      "x": 0.4995,
      "y": 0.462
    },
    "frame16": {
      "x": 0.4992,
      "y": 0.4623
    },
    "frame17": {
      "x": 0.4991,
      "y": 0.4626
    },
    "frame18": {
      "x": 0.499,
      "y": 0.4618
    },
    "frame19": {
      "x": 0.499,
      "y": 0.462
    },
    "frame20": {
      "x": 0.4993,
      "y": 0.4615
    },
    "frame21": {
      "x": 0.4994,
      "y": 0.4615
    },
    "frame22": {
      "x": 0.4994,
      "y": 0.4616
    },
    "frame23": {
      "x": 0.4995,
      "y": 0.4621
    },
    "frame24": {
      "x": 0.4994,
      "y": 0.4616
    },
    "frame25": {
      "x": 0.4993,
      "y": 0.4619
    },
    "frame26": {
      "x": 0.4992,
      "y": 0.462
    },
    "frame27": {
      "x": 0.4992,
      "y": 0.4624
    },
    "frame28": {
      "x": 0.499,
      "y": 0.462
    },
    "frame29": {
      "x": 0.4991,
      "y": 0.4617
    },
    "frame30": {
      "x": 0.4994,
      "y": 0.4618
    },
    "frame31": {
      "x": 0.4995,
      "y": 0.4618
    },
    "frame32": {
      "x": 0.4992,
      "y": 0.4624
    },
    "frame33": {
      "x": 0.4994,
      "y": 0.4624
    },
    "frame34": {
      "x": 0.499,
      "y": 0.4627
    },
    "frame35": {
      "x": 0.4989,
      "y": 0.4631
    },
    "frame36": {
      "x": 0.4986,
      "y": 0.462
    },
    "frame37": {
      "x": 0.499,
      "y": 0.4619
    },
    "frame38": {
      "x": 0.499,
      "y": 0.4621
    },
    "frame39": {
      "x": 0.4996,
      "y": 0.4616
    },
    "frame40": {
      "x": 0.4995,
      "y": 0.4613
    },
    "frame41": {
      "x": 0.4994,
      "y": 0.4614
    },
    "frame42": {
      "x": 0.4993,
      "y": 0.4619
    },
    "frame43": {
      "x": 0.4991,
      "y": 0.4622
    },
    "frame44": {
      "x": 0.4992,
      "y": 0.462
    },
    "frame45": {
      "x": 0.4992,
      "y": 0.462
    },
    "frame46": {
      "x": 0.4993,
      "y": 0.4619
    },
    "frame47": {
      "x": 0.4993,
      "y": 0.4622
    },
    "frame48": {
      "x": 0.4993,
      "y": 0.4618
    },
    "frame49": {
      "x": 0.4992,
      "y": 0.4621
    },
    "frame50": {
      "x": 0.4989,
      "y": 0.4622
    },
    "frame51": {
      "x": 0.4991,
      "y": 0.4623
    },
    "frame6": {
      "x": 0.4997,
      "y": 0.4615
    },
    "frame7": {
      "x": 0.4997,
      "y": 0.4615
    },
    "frame8": {
      "x": 0.4994,
      "y": 0.4623
    },
    "frame9": {
      "x": 0.4995,
      "y": 0.4622
    }
  },
  "p5a5": {
    "frame13": {
      "x": 0.5071,
      "y": 0.4894
    },
    "frame67": {
      "x": 0.4016,
      "y": 0.3704
    },
    "frame68": {
      "x": 0.3992,
      "y": 0.3675
    },
    "frame61": {
      "x": 0.4975,
      "y": 0.4562
    },
    "frame29": {
      "x": 0.4915,
      "y": 0.4676
    },
    "frame12": {
      "x": 0.5039,
      "y": 0.4517
    },
    "frame46": {
      "x": 0.4775,
      "y": 0.4517
    },
    "frame45": {
      "x": 0.4752,
      "y": 0.4612
    },
    "frame44": {
      "x": 0.4994,
      "y": 0.4505
    },
    "frame14": {
      "x": 0.5049,
      "y": 0.4785
    },
    "frame60": {
      "x": 0.4875,
      "y": 0.4584
    },
    "frame18": {
      "x": 0.3972,
      "y": 0.4302
    },
    "frame63": {
      "x": 0.3982,
      "y": 0.4049
    },
    "frame31": {
      "x": 0.4958,
      "y": 0.4627
    },
    "frame4": {
      "x": 0.4001,
      "y": 0.3909
    },
    "frame5": {
      "x": 0.4,
      "y": 0.3898
    },
    "frame62": {
      "x": 0.3897,
      "y": 0.406
    },
    "frame64": {
      "x": 0.401,
      "y": 0.4125
    },
    "frame65": {
      "x": 0.4003,
      "y": 0.4098
    },
    "frame66": {
      "x": 0.3991,
      "y": 0.3962
    },
    "frame28": {
      "x": 0.5068,
      "y": 0.4564
    },
    "frame59": {
      "x": 0.41,
      "y": 0.4578
    },
    "frame30": {
      "x": 0.4986,
      "y": 0.4719
    },
    "frame10": {
      "x": 0.5051,
      "y": 0.4051
    },
    "frame43": {
      "x": 0.5081,
      "y": 0.4397
    },
    "frame47": {
      "x": 0.4952,
      "y": 0.4585
    },
    "frame11": {
      "x": 0.5037,
      "y": 0.4336
    },
    "frame27": {
      "x": 0.5124,
      "y": 0.4436
    },
    "frame33": {
      "x": 0.4261,
      "y": 0.4348
    },
    "frame34": {
      "x": 0.4315,
      "y": 0.4333
    },
    "frame15": {
      "x": 0.5038,
      "y": 0.4754
    },
    "frame17": {
      "x": 0.5034,
      "y": 0.4697
    },
    "frame39": {
      "x": 0.5093,
      "y": 0.4221
    },
    "frame6": {
      "x": 0.4912,
      "y": 0.3919
    },
    "frame9": {
      "x": 0.506,
      "y": 0.3861
    },
    "frame16": {
      "x": 0.5007,
      "y": 0.4715
    },
    "frame7": {
      "x": 0.4978,
      "y": 0.3731
    },
    "frame8": {
      "x": 0.5015,
      "y": 0.3687
    },
    "frame20": {
      "x": 0.4982,
      "y": 0.3873
    },
    "frame48": {
      "x": 0.4997,
      "y": 0.4595
    },
    "frame38": {
      "x": 0.5314,
      "y": 0.419
    },
    "frame26": {
      "x": 0.5172,
      "y": 0.4285
    },
    "frame21": {
      "x": 0.514,
      "y": 0.3895
    },
    "frame42": {
      "x": 0.5076,
      "y": 0.429
    },
    "frame41": {
      "x": 0.515,
      "y": 0.4266
    },
    "frame40": {
      "x": 0.5114,
      "y": 0.4265
    },
    "frame25": {
      "x": 0.5151,
      "y": 0.4162
    },
    "frame53": {
      "x": 0.5154,
      "y": 0.4587
    },
    "frame1": {
      "x": 0.5017,
      "y": 0.4603
    },
    "frame19": {
      "x": 0.4726,
      "y": 0.4207
    },
    "frame22": {
      "x": 0.5162,
      "y": 0.3991
    },
    "frame32": {
      "x": 0.4968,
      "y": 0.4662
    },
    "frame23": {
      "x": 0.5159,
      "y": 0.4009
    },
    "frame24": {
      "x": 0.5158,
      "y": 0.401
    },
    "frame35": {
      "x": 0.4844,
      "y": 0.4041
    },
    "frame36": {
      "x": 0.5039,
      "y": 0.3893
    },
    "frame37": {
      "x": 0.5125,
      "y": 0.4052
    },
    "frame49": {
      "x": 0.5003,
      "y": 0.4596
    },
    "frame2": {
      "x": 0.5016,
      "y": 0.4596
    },
    "frame3": {
      "x": 0.5015,
      "y": 0.4587
    },
    "frame50": {
      "x": 0.497,
      "y": 0.4565
    },
    "frame51": {
      "x": 0.4968,
      "y": 0.4562
    },
    "frame52": {
      "x": 0.4969,
      "y": 0.4554
    },
    "frame54": {
      "x": 0.5212,
      "y": 0.4626
    },
    "frame57": {
      "x": 0.4631,
      "y": 0.4555
    },
    "frame55": {
      "x": 0.5347,
      "y": 0.4692
    },
    "frame56": {
      "x": 0.5107,
      "y": 0.4565
    },
    "frame58": {
      "x": 0.4566,
      "y": 0.4783
    }
  },
  "p6a1": {
    "frame1": {
      "x": 0.5022,
      "y": 0.4581
    },
    "frame24": {
      "x": 0.5022,
      "y": 0.4581
    },
    "frame10": {
      "x": 0.501,
      "y": 0.4582
    },
    "frame11": {
      "x": 0.501,
      "y": 0.4582
    },
    "frame12": {
      "x": 0.501,
      "y": 0.4582
    },
    "frame13": {
      "x": 0.501,
      "y": 0.4582
    },
    "frame14": {
      "x": 0.501,
      "y": 0.4582
    },
    "frame15": {
      "x": 0.501,
      "y": 0.4582
    },
    "frame16": {
      "x": 0.501,
      "y": 0.4582
    },
    "frame17": {
      "x": 0.5042,
      "y": 0.4593
    },
    "frame18": {
      "x": 0.5041,
      "y": 0.4593
    },
    "frame19": {
      "x": 0.5051,
      "y": 0.4601
    },
    "frame2": {
      "x": 0.5016,
      "y": 0.4578
    },
    "frame20": {
      "x": 0.5047,
      "y": 0.4599
    },
    "frame21": {
      "x": 0.501,
      "y": 0.4582
    },
    "frame22": {
      "x": 0.5017,
      "y": 0.4585
    },
    "frame23": {
      "x": 0.5024,
      "y": 0.4583
    },
    "frame3": {
      "x": 0.5016,
      "y": 0.4582
    },
    "frame4": {
      "x": 0.5043,
      "y": 0.4594
    },
    "frame5": {
      "x": 0.5048,
      "y": 0.4599
    },
    "frame6": {
      "x": 0.5051,
      "y": 0.46
    },
    "frame7": {
      "x": 0.5034,
      "y": 0.459
    },
    "frame8": {
      "x": 0.504,
      "y": 0.459
    },
    "frame9": {
      "x": 0.5012,
      "y": 0.4582
    }
  },
  "p6a2": {
    "frame10": {
      "x": 0.5288,
      "y": 0.4529
    },
    "frame6": {
      "x": 0.534,
      "y": 0.4543
    },
    "frame7": {
      "x": 0.5339,
      "y": 0.4531
    },
    "frame8": {
      "x": 0.5335,
      "y": 0.4528
    },
    "frame9": {
      "x": 0.5292,
      "y": 0.453
    },
    "frame1": {
      "x": 0.5022,
      "y": 0.4581
    },
    "frame16": {
      "x": 0.5022,
      "y": 0.4581
    },
    "frame11": {
      "x": 0.5211,
      "y": 0.4526
    },
    "frame12": {
      "x": 0.5152,
      "y": 0.4549
    },
    "frame13": {
      "x": 0.5051,
      "y": 0.4588
    },
    "frame14": {
      "x": 0.5051,
      "y": 0.4574
    },
    "frame15": {
      "x": 0.5012,
      "y": 0.4591
    },
    "frame2": {
      "x": 0.4985,
      "y": 0.4613
    },
    "frame3": {
      "x": 0.5033,
      "y": 0.4595
    },
    "frame4": {
      "x": 0.5134,
      "y": 0.4583
    },
    "frame5": {
      "x": 0.5151,
      "y": 0.4596
    }
  },
  "p6a3": {
    "frame1": {
      "x": 0.5022,
      "y": 0.4581
    },
    "frame29": {
      "x": 0.5022,
      "y": 0.4581
    },
    "frame30": {
      "x": 0.5022,
      "y": 0.4581
    },
    "frame39": {
      "x": 0.5022,
      "y": 0.4581
    },
    "frame10": {
      "x": 0.5025,
      "y": 0.4622
    },
    "frame11": {
      "x": 0.5012,
      "y": 0.4625
    },
    "frame12": {
      "x": 0.5021,
      "y": 0.4624
    },
    "frame13": {
      "x": 0.5029,
      "y": 0.4623
    },
    "frame14": {
      "x": 0.5034,
      "y": 0.462
    },
    "frame15": {
      "x": 0.5033,
      "y": 0.4619
    },
    "frame16": {
      "x": 0.5032,
      "y": 0.4614
    },
    "frame17": {
      "x": 0.5027,
      "y": 0.4617
    },
    "frame18": {
      "x": 0.5018,
      "y": 0.462
    },
    "frame19": {
      "x": 0.5023,
      "y": 0.4621
    },
    "frame2": {
      "x": 0.4972,
      "y": 0.4638
    },
    "frame20": {
      "x": 0.5024,
      "y": 0.4626
    },
    "frame21": {
      "x": 0.5034,
      "y": 0.4621
    },
    "frame22": {
      "x": 0.5034,
      "y": 0.462
    },
    "frame23": {
      "x": 0.5034,
      "y": 0.4618
    },
    "frame24": {
      "x": 0.5025,
      "y": 0.4616
    },
    "frame25": {
      "x": 0.5008,
      "y": 0.4624
    },
    "frame26": {
      "x": 0.4988,
      "y": 0.4632
    },
    "frame27": {
      "x": 0.4986,
      "y": 0.4623
    },
    "frame28": {
      "x": 0.4995,
      "y": 0.4606
    },
    "frame3": {
      "x": 0.4964,
      "y": 0.4668
    },
    "frame31": {
      "x": 0.4992,
      "y": 0.4608
    },
    "frame32": {
      "x": 0.4982,
      "y": 0.4625
    },
    "frame33": {
      "x": 0.4977,
      "y": 0.4635
    },
    "frame34": {
      "x": 0.4965,
      "y": 0.4648
    },
    "frame35": {
      "x": 0.4963,
      "y": 0.4649
    },
    "frame36": {
      "x": 0.4986,
      "y": 0.4624
    },
    "frame37": {
      "x": 0.4999,
      "y": 0.4605
    },
    "frame38": {
      "x": 0.5015,
      "y": 0.4586
    },
    "frame4": {
      "x": 0.4991,
      "y": 0.4655
    },
    "frame5": {
      "x": 0.502,
      "y": 0.4631
    },
    "frame6": {
      "x": 0.503,
      "y": 0.4623
    },
    "frame7": {
      "x": 0.5031,
      "y": 0.4625
    },
    "frame8": {
      "x": 0.5031,
      "y": 0.4619
    },
    "frame9": {
      "x": 0.5023,
      "y": 0.4623
    }
  },
  "p6a4": {
    "frame9": {
      "x": 0.5021,
      "y": 0.4631
    },
    "frame1": {
      "x": 0.5022,
      "y": 0.4581
    },
    "frame43": {
      "x": 0.5022,
      "y": 0.4581
    },
    "frame10": {
      "x": 0.5014,
      "y": 0.4642
    },
    "frame2": {
      "x": 0.5019,
      "y": 0.4583
    },
    "frame3": {
      "x": 0.5022,
      "y": 0.4581
    },
    "frame30": {
      "x": 0.5037,
      "y": 0.457
    },
    "frame31": {
      "x": 0.5023,
      "y": 0.4581
    },
    "frame32": {
      "x": 0.5015,
      "y": 0.4591
    },
    "frame33": {
      "x": 0.5032,
      "y": 0.46
    },
    "frame34": {
      "x": 0.5002,
      "y": 0.4629
    },
    "frame35": {
      "x": 0.5017,
      "y": 0.4637
    },
    "frame25": {
      "x": 0.4933,
      "y": 0.462
    },
    "frame36": {
      "x": 0.501,
      "y": 0.4652
    },
    "frame37": {
      "x": 0.4966,
      "y": 0.4643
    },
    "frame38": {
      "x": 0.4965,
      "y": 0.4644
    },
    "frame26": {
      "x": 0.4965,
      "y": 0.4546
    },
    "frame39": {
      "x": 0.4983,
      "y": 0.4616
    },
    "frame4": {
      "x": 0.5023,
      "y": 0.4572
    },
    "frame40": {
      "x": 0.5004,
      "y": 0.4595
    },
    "frame27": {
      "x": 0.5016,
      "y": 0.4558
    },
    "frame41": {
      "x": 0.5022,
      "y": 0.4581
    },
    "frame42": {
      "x": 0.502,
      "y": 0.4582
    },
    "frame5": {
      "x": 0.5,
      "y": 0.4607
    },
    "frame28": {
      "x": 0.4981,
      "y": 0.4541
    },
    "frame6": {
      "x": 0.4977,
      "y": 0.46
    },
    "frame8": {
      "x": 0.5031,
      "y": 0.4622
    },
    "frame29": {
      "x": 0.4984,
      "y": 0.4555
    },
    "frame7": {
      "x": 0.4988,
      "y": 0.464
    },
    "frame15": {
      "x": 0.5149,
      "y": 0.4689
    },
    "frame16": {
      "x": 0.5099,
      "y": 0.4698
    },
    "frame18": {
      "x": 0.5324,
      "y": 0.4657
    },
    "frame11": {
      "x": 0.5106,
      "y": 0.4617
    },
    "frame12": {
      "x": 0.5096,
      "y": 0.4635
    },
    "frame13": {
      "x": 0.5101,
      "y": 0.4672
    },
    "frame14": {
      "x": 0.5061,
      "y": 0.4672
    },
    "frame17": {
      "x": 0.5195,
      "y": 0.4724
    },
    "frame19": {
      "x": 0.5256,
      "y": 0.469
    },
    "frame20": {
      "x": 0.5251,
      "y": 0.4732
    },
    "frame21": {
      "x": 0.5175,
      "y": 0.4735
    },
    "frame24": {
      "x": 0.4991,
      "y": 0.4653
    },
    "frame22": {
      "x": 0.5077,
      "y": 0.4701
    },
    "frame23": {
      "x": 0.4992,
      "y": 0.4674
    }
  },
  "p6a5": {
    "frame69": {
      "x": 0.5006,
      "y": 0.4973
    },
    "frame70": {
      "x": 0.5075,
      "y": 0.4901
    },
    "frame14": {
      "x": 0.5819,
      "y": 0.4877
    },
    "frame68": {
      "x": 0.5121,
      "y": 0.5016
    },
    "frame12": {
      "x": 0.6003,
      "y": 0.4865
    },
    "frame13": {
      "x": 0.5858,
      "y": 0.4853
    },
    "frame66": {
      "x": 0.521,
      "y": 0.5086
    },
    "frame65": {
      "x": 0.5134,
      "y": 0.5078
    },
    "frame63": {
      "x": 0.4976,
      "y": 0.5059
    },
    "frame64": {
      "x": 0.5078,
      "y": 0.5086
    },
    "frame67": {
      "x": 0.5084,
      "y": 0.5029
    },
    "frame11": {
      "x": 0.6164,
      "y": 0.4827
    },
    "frame15": {
      "x": 0.5783,
      "y": 0.4828
    },
    "frame56": {
      "x": 0.4969,
      "y": 0.4935
    },
    "frame62": {
      "x": 0.4898,
      "y": 0.5043
    },
    "frame57": {
      "x": 0.4895,
      "y": 0.4974
    },
    "frame58": {
      "x": 0.4825,
      "y": 0.4986
    },
    "frame59": {
      "x": 0.4809,
      "y": 0.4999
    },
    "frame71": {
      "x": 0.5035,
      "y": 0.485
    },
    "frame60": {
      "x": 0.48,
      "y": 0.5014
    },
    "frame61": {
      "x": 0.4808,
      "y": 0.503
    },
    "frame16": {
      "x": 0.5727,
      "y": 0.484
    },
    "frame10": {
      "x": 0.6281,
      "y": 0.4776
    },
    "frame17": {
      "x": 0.5673,
      "y": 0.4774
    },
    "frame55": {
      "x": 0.4956,
      "y": 0.4837
    },
    "frame18": {
      "x": 0.5521,
      "y": 0.4776
    },
    "frame72": {
      "x": 0.5143,
      "y": 0.4724
    },
    "frame9": {
      "x": 0.6503,
      "y": 0.4734
    },
    "frame19": {
      "x": 0.5285,
      "y": 0.471
    },
    "frame20": {
      "x": 0.516,
      "y": 0.4671
    },
    "frame21": {
      "x": 0.5158,
      "y": 0.4676
    },
    "frame22": {
      "x": 0.5157,
      "y": 0.468
    },
    "frame23": {
      "x": 0.5164,
      "y": 0.4671
    },
    "frame24": {
      "x": 0.5171,
      "y": 0.466
    },
    "frame25": {
      "x": 0.5176,
      "y": 0.4653
    },
    "frame26": {
      "x": 0.5175,
      "y": 0.4654
    },
    "frame27": {
      "x": 0.5165,
      "y": 0.4668
    },
    "frame28": {
      "x": 0.5159,
      "y": 0.4677
    },
    "frame29": {
      "x": 0.5148,
      "y": 0.4687
    },
    "frame30": {
      "x": 0.5127,
      "y": 0.4702
    },
    "frame31": {
      "x": 0.5103,
      "y": 0.4716
    },
    "frame32": {
      "x": 0.5094,
      "y": 0.471
    },
    "frame33": {
      "x": 0.5144,
      "y": 0.4658
    },
    "frame34": {
      "x": 0.5147,
      "y": 0.4659
    },
    "frame35": {
      "x": 0.5163,
      "y": 0.4677
    },
    "frame36": {
      "x": 0.5175,
      "y": 0.4693
    },
    "frame37": {
      "x": 0.5143,
      "y": 0.4722
    },
    "frame38": {
      "x": 0.5107,
      "y": 0.4716
    },
    "frame39": {
      "x": 0.5095,
      "y": 0.4718
    },
    "frame54": {
      "x": 0.5014,
      "y": 0.4745
    },
    "frame40": {
      "x": 0.5064,
      "y": 0.4713
    },
    "frame8": {
      "x": 0.6683,
      "y": 0.4702
    },
    "frame41": {
      "x": 0.5095,
      "y": 0.4709
    },
    "frame7": {
      "x": 0.6947,
      "y": 0.475
    },
    "frame6": {
      "x": 0.704,
      "y": 0.4847
    },
    "frame42": {
      "x": 0.5142,
      "y": 0.4673
    },
    "frame5": {
      "x": 0.7004,
      "y": 0.4798
    },
    "frame74": {
      "x": 0.5025,
      "y": 0.466
    },
    "frame75": {
      "x": 0.5078,
      "y": 0.4694
    },
    "frame73": {
      "x": 0.5087,
      "y": 0.4559
    },
    "frame76": {
      "x": 0.4987,
      "y": 0.4684
    },
    "frame4": {
      "x": 0.4953,
      "y": 0.4767
    },
    "frame53": {
      "x": 0.5102,
      "y": 0.4579
    },
    "frame3": {
      "x": 0.4992,
      "y": 0.4676
    },
    "frame43": {
      "x": 0.5149,
      "y": 0.4623
    },
    "frame77": {
      "x": 0.493,
      "y": 0.4705
    },
    "frame78": {
      "x": 0.5,
      "y": 0.4721
    },
    "frame80": {
      "x": 0.5001,
      "y": 0.461
    },
    "frame45": {
      "x": 0.5116,
      "y": 0.4619
    },
    "frame81": {
      "x": 0.5054,
      "y": 0.4614
    },
    "frame46": {
      "x": 0.5115,
      "y": 0.4598
    },
    "frame47": {
      "x": 0.5087,
      "y": 0.4661
    },
    "frame48": {
      "x": 0.5141,
      "y": 0.4638
    },
    "frame49": {
      "x": 0.5139,
      "y": 0.4638
    },
    "frame50": {
      "x": 0.5138,
      "y": 0.4639
    },
    "frame51": {
      "x": 0.5139,
      "y": 0.4639
    },
    "frame52": {
      "x": 0.5138,
      "y": 0.4638
    },
    "frame79": {
      "x": 0.4955,
      "y": 0.4668
    },
    "frame1": {
      "x": 0.5025,
      "y": 0.4608
    },
    "frame139": {
      "x": 0.5025,
      "y": 0.4608
    },
    "frame100": {
      "x": 0.5004,
      "y": 0.4689
    },
    "frame101": {
      "x": 0.499,
      "y": 0.4707
    },
    "frame102": {
      "x": 0.499,
      "y": 0.4706
    },
    "frame103": {
      "x": 0.5004,
      "y": 0.4689
    },
    "frame104": {
      "x": 0.5018,
      "y": 0.4676
    },
    "frame105": {
      "x": 0.5036,
      "y": 0.4656
    },
    "frame106": {
      "x": 0.506,
      "y": 0.4632
    },
    "frame107": {
      "x": 0.5071,
      "y": 0.4619
    },
    "frame108": {
      "x": 0.5065,
      "y": 0.4623
    },
    "frame109": {
      "x": 0.507,
      "y": 0.4623
    },
    "frame84": {
      "x": 0.507,
      "y": 0.4623
    },
    "frame94": {
      "x": 0.507,
      "y": 0.4623
    },
    "frame95": {
      "x": 0.507,
      "y": 0.4623
    },
    "frame96": {
      "x": 0.507,
      "y": 0.4623
    },
    "frame97": {
      "x": 0.507,
      "y": 0.4623
    },
    "frame110": {
      "x": 0.5076,
      "y": 0.4614
    },
    "frame111": {
      "x": 0.5029,
      "y": 0.4619
    },
    "frame112": {
      "x": 0.5027,
      "y": 0.4618
    },
    "frame113": {
      "x": 0.51,
      "y": 0.4613
    },
    "frame114": {
      "x": 0.5069,
      "y": 0.4633
    },
    "frame115": {
      "x": 0.5027,
      "y": 0.4642
    },
    "frame116": {
      "x": 0.5,
      "y": 0.4646
    },
    "frame117": {
      "x": 0.4986,
      "y": 0.463
    },
    "frame118": {
      "x": 0.5023,
      "y": 0.4599
    },
    "frame119": {
      "x": 0.5048,
      "y": 0.4584
    },
    "frame120": {
      "x": 0.5035,
      "y": 0.4592
    },
    "frame121": {
      "x": 0.5038,
      "y": 0.4593
    },
    "frame122": {
      "x": 0.5038,
      "y": 0.4593
    },
    "frame123": {
      "x": 0.5038,
      "y": 0.4593
    },
    "frame124": {
      "x": 0.5038,
      "y": 0.4593
    },
    "frame125": {
      "x": 0.5038,
      "y": 0.4593
    },
    "frame126": {
      "x": 0.5038,
      "y": 0.4593
    },
    "frame127": {
      "x": 0.5055,
      "y": 0.4579
    },
    "frame128": {
      "x": 0.5052,
      "y": 0.4581
    },
    "frame129": {
      "x": 0.5024,
      "y": 0.4608
    },
    "frame130": {
      "x": 0.5009,
      "y": 0.4625
    },
    "frame131": {
      "x": 0.5003,
      "y": 0.4633
    },
    "frame132": {
      "x": 0.5003,
      "y": 0.4629
    },
    "frame133": {
      "x": 0.5012,
      "y": 0.4623
    },
    "frame134": {
      "x": 0.5005,
      "y": 0.4632
    },
    "frame135": {
      "x": 0.5004,
      "y": 0.4631
    },
    "frame136": {
      "x": 0.5017,
      "y": 0.4616
    },
    "frame137": {
      "x": 0.5019,
      "y": 0.4614
    },
    "frame138": {
      "x": 0.5027,
      "y": 0.4606
    },
    "frame2": {
      "x": 0.5034,
      "y": 0.4612
    },
    "frame44": {
      "x": 0.5157,
      "y": 0.457
    },
    "frame82": {
      "x": 0.5029,
      "y": 0.4601
    },
    "frame83": {
      "x": 0.5063,
      "y": 0.4621
    },
    "frame85": {
      "x": 0.5058,
      "y": 0.4633
    },
    "frame86": {
      "x": 0.5015,
      "y": 0.4679
    },
    "frame91": {
      "x": 0.5015,
      "y": 0.4679
    },
    "frame87": {
      "x": 0.4989,
      "y": 0.4709
    },
    "frame88": {
      "x": 0.4991,
      "y": 0.4721
    },
    "frame89": {
      "x": 0.4986,
      "y": 0.4718
    },
    "frame90": {
      "x": 0.4994,
      "y": 0.4702
    },
    "frame92": {
      "x": 0.5056,
      "y": 0.4635
    },
    "frame93": {
      "x": 0.5073,
      "y": 0.4618
    },
    "frame98": {
      "x": 0.5071,
      "y": 0.4619
    },
    "frame99": {
      "x": 0.5036,
      "y": 0.4656
    }
  },
  "p7a1": {
    "frame1": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame10": {
      "x": 0.5132,
      "y": 0.5184
    },
    "frame11": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame12": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame13": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame14": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame15": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame16": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame17": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame18": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame19": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame2": {
      "x": 0.513,
      "y": 0.5205
    },
    "frame20": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame21": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame22": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame23": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame24": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame25": {
      "x": 0.513,
      "y": 0.5205
    },
    "frame26": {
      "x": 0.5137,
      "y": 0.5176
    },
    "frame27": {
      "x": 0.5141,
      "y": 0.5173
    },
    "frame28": {
      "x": 0.5139,
      "y": 0.5182
    },
    "frame29": {
      "x": 0.5139,
      "y": 0.5185
    },
    "frame3": {
      "x": 0.5137,
      "y": 0.5176
    },
    "frame30": {
      "x": 0.513,
      "y": 0.5246
    },
    "frame31": {
      "x": 0.5129,
      "y": 0.5239
    },
    "frame32": {
      "x": 0.514,
      "y": 0.5176
    },
    "frame33": {
      "x": 0.5132,
      "y": 0.5184
    },
    "frame34": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame35": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame36": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame37": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame38": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame39": {
      "x": 0.5137,
      "y": 0.5176
    },
    "frame4": {
      "x": 0.5141,
      "y": 0.5173
    },
    "frame40": {
      "x": 0.5139,
      "y": 0.5182
    },
    "frame41": {
      "x": 0.513,
      "y": 0.5246
    },
    "frame42": {
      "x": 0.514,
      "y": 0.5176
    },
    "frame43": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame44": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame45": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame46": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame47": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame48": {
      "x": 0.5134,
      "y": 0.5208
    },
    "frame5": {
      "x": 0.5139,
      "y": 0.5182
    },
    "frame6": {
      "x": 0.5138,
      "y": 0.5186
    },
    "frame7": {
      "x": 0.513,
      "y": 0.5246
    },
    "frame8": {
      "x": 0.5129,
      "y": 0.5239
    },
    "frame9": {
      "x": 0.514,
      "y": 0.5176
    }
  },
  "p7a2": {
    "frame2": {
      "x": 0.511,
      "y": 0.522
    },
    "frame1": {
      "x": 0.5124,
      "y": 0.5206
    },
    "frame3": {
      "x": 0.5127,
      "y": 0.5219
    },
    "frame4": {
      "x": 0.5119,
      "y": 0.5293
    },
    "frame53": {
      "x": 0.5091,
      "y": 0.5205
    },
    "frame54": {
      "x": 0.5133,
      "y": 0.5208
    },
    "frame55": {
      "x": 0.5133,
      "y": 0.5208
    },
    "frame56": {
      "x": 0.5133,
      "y": 0.5208
    },
    "frame57": {
      "x": 0.5133,
      "y": 0.5208
    },
    "frame58": {
      "x": 0.5133,
      "y": 0.5208
    },
    "frame59": {
      "x": 0.5133,
      "y": 0.5208
    },
    "frame60": {
      "x": 0.5133,
      "y": 0.5208
    },
    "frame6": {
      "x": 0.5207,
      "y": 0.5187
    },
    "frame5": {
      "x": 0.5153,
      "y": 0.5204
    },
    "frame52": {
      "x": 0.5119,
      "y": 0.5175
    },
    "frame51": {
      "x": 0.5137,
      "y": 0.5203
    },
    "frame50": {
      "x": 0.5153,
      "y": 0.5159
    },
    "frame32": {
      "x": 0.5203,
      "y": 0.5102
    },
    "frame33": {
      "x": 0.5166,
      "y": 0.5152
    },
    "frame7": {
      "x": 0.5217,
      "y": 0.5144
    },
    "frame25": {
      "x": 0.5189,
      "y": 0.5089
    },
    "frame26": {
      "x": 0.5186,
      "y": 0.5073
    },
    "frame27": {
      "x": 0.5174,
      "y": 0.5127
    },
    "frame28": {
      "x": 0.5179,
      "y": 0.5127
    },
    "frame34": {
      "x": 0.5189,
      "y": 0.5111
    },
    "frame8": {
      "x": 0.5181,
      "y": 0.5136
    },
    "frame10": {
      "x": 0.5201,
      "y": 0.5124
    },
    "frame11": {
      "x": 0.52,
      "y": 0.5121
    },
    "frame12": {
      "x": 0.5207,
      "y": 0.512
    },
    "frame13": {
      "x": 0.5204,
      "y": 0.5117
    },
    "frame14": {
      "x": 0.5191,
      "y": 0.5119
    },
    "frame15": {
      "x": 0.5191,
      "y": 0.5122
    },
    "frame16": {
      "x": 0.5194,
      "y": 0.5122
    },
    "frame17": {
      "x": 0.5191,
      "y": 0.5117
    },
    "frame18": {
      "x": 0.5187,
      "y": 0.5114
    },
    "frame19": {
      "x": 0.5201,
      "y": 0.511
    },
    "frame20": {
      "x": 0.5201,
      "y": 0.5113
    },
    "frame21": {
      "x": 0.5202,
      "y": 0.5116
    },
    "frame22": {
      "x": 0.5197,
      "y": 0.5112
    },
    "frame23": {
      "x": 0.5196,
      "y": 0.5116
    },
    "frame24": {
      "x": 0.5197,
      "y": 0.5123
    },
    "frame29": {
      "x": 0.5202,
      "y": 0.5123
    },
    "frame30": {
      "x": 0.5199,
      "y": 0.5123
    },
    "frame31": {
      "x": 0.5194,
      "y": 0.5131
    },
    "frame35": {
      "x": 0.5191,
      "y": 0.5121
    },
    "frame36": {
      "x": 0.5193,
      "y": 0.5116
    },
    "frame37": {
      "x": 0.519,
      "y": 0.511
    },
    "frame38": {
      "x": 0.519,
      "y": 0.5118
    },
    "frame39": {
      "x": 0.5192,
      "y": 0.5115
    },
    "frame40": {
      "x": 0.5192,
      "y": 0.5118
    },
    "frame41": {
      "x": 0.5189,
      "y": 0.5107
    },
    "frame42": {
      "x": 0.5157,
      "y": 0.5147
    },
    "frame43": {
      "x": 0.5174,
      "y": 0.5139
    },
    "frame44": {
      "x": 0.5166,
      "y": 0.514
    },
    "frame45": {
      "x": 0.5179,
      "y": 0.5137
    },
    "frame46": {
      "x": 0.5203,
      "y": 0.5106
    },
    "frame47": {
      "x": 0.5204,
      "y": 0.5112
    },
    "frame48": {
      "x": 0.5201,
      "y": 0.5122
    },
    "frame49": {
      "x": 0.5216,
      "y": 0.513
    },
    "frame9": {
      "x": 0.5199,
      "y": 0.5123
    }
  },
  "p7a3": {
    "frame28": {
      "x": 0.511,
      "y": 0.5252
    },
    "frame29": {
      "x": 0.5142,
      "y": 0.525
    },
    "frame30": {
      "x": 0.5122,
      "y": 0.524
    },
    "frame31": {
      "x": 0.5128,
      "y": 0.5246
    },
    "frame72": {
      "x": 0.4952,
      "y": 0.5138
    },
    "frame73": {
      "x": 0.4955,
      "y": 0.514
    },
    "frame74": {
      "x": 0.4943,
      "y": 0.5149
    },
    "frame47": {
      "x": 0.4946,
      "y": 0.5129
    },
    "frame48": {
      "x": 0.4949,
      "y": 0.5129
    },
    "frame49": {
      "x": 0.4939,
      "y": 0.5139
    },
    "frame50": {
      "x": 0.494,
      "y": 0.5142
    },
    "frame51": {
      "x": 0.4947,
      "y": 0.5142
    },
    "frame52": {
      "x": 0.4942,
      "y": 0.5148
    },
    "frame53": {
      "x": 0.4934,
      "y": 0.5152
    },
    "frame54": {
      "x": 0.4929,
      "y": 0.5149
    },
    "frame55": {
      "x": 0.4927,
      "y": 0.5147
    },
    "frame56": {
      "x": 0.4931,
      "y": 0.5146
    },
    "frame57": {
      "x": 0.4929,
      "y": 0.5145
    },
    "frame58": {
      "x": 0.4933,
      "y": 0.5139
    },
    "frame59": {
      "x": 0.4937,
      "y": 0.5136
    },
    "frame60": {
      "x": 0.4939,
      "y": 0.5137
    },
    "frame61": {
      "x": 0.4946,
      "y": 0.5137
    },
    "frame62": {
      "x": 0.4945,
      "y": 0.5139
    },
    "frame63": {
      "x": 0.4946,
      "y": 0.5137
    },
    "frame64": {
      "x": 0.4944,
      "y": 0.5137
    },
    "frame65": {
      "x": 0.4945,
      "y": 0.5138
    },
    "frame66": {
      "x": 0.4947,
      "y": 0.5141
    },
    "frame67": {
      "x": 0.4946,
      "y": 0.5142
    },
    "frame68": {
      "x": 0.4947,
      "y": 0.5143
    },
    "frame69": {
      "x": 0.4947,
      "y": 0.5144
    },
    "frame70": {
      "x": 0.4946,
      "y": 0.5146
    },
    "frame71": {
      "x": 0.4941,
      "y": 0.5147
    },
    "frame75": {
      "x": 0.4948,
      "y": 0.5141
    },
    "frame76": {
      "x": 0.4983,
      "y": 0.5134
    },
    "frame45": {
      "x": 0.4997,
      "y": 0.5105
    },
    "frame46": {
      "x": 0.494,
      "y": 0.5132
    },
    "frame77": {
      "x": 0.5036,
      "y": 0.5134
    },
    "frame44": {
      "x": 0.4946,
      "y": 0.519
    },
    "frame78": {
      "x": 0.5048,
      "y": 0.5137
    },
    "frame43": {
      "x": 0.4988,
      "y": 0.5185
    },
    "frame79": {
      "x": 0.5098,
      "y": 0.5133
    },
    "frame40": {
      "x": 0.5032,
      "y": 0.5153
    },
    "frame42": {
      "x": 0.5011,
      "y": 0.5129
    },
    "frame41": {
      "x": 0.5035,
      "y": 0.5104
    },
    "frame3": {
      "x": 0.5102,
      "y": 0.5189
    },
    "frame4": {
      "x": 0.5097,
      "y": 0.5177
    },
    "frame2": {
      "x": 0.5115,
      "y": 0.5178
    },
    "frame35": {
      "x": 0.5081,
      "y": 0.5229
    },
    "frame32": {
      "x": 0.5122,
      "y": 0.5244
    },
    "frame33": {
      "x": 0.5114,
      "y": 0.5212
    },
    "frame34": {
      "x": 0.5075,
      "y": 0.5214
    },
    "frame7": {
      "x": 0.5085,
      "y": 0.5194
    },
    "frame10": {
      "x": 0.5161,
      "y": 0.5223
    },
    "frame11": {
      "x": 0.5143,
      "y": 0.5229
    },
    "frame12": {
      "x": 0.5152,
      "y": 0.5229
    },
    "frame13": {
      "x": 0.5148,
      "y": 0.524
    },
    "frame14": {
      "x": 0.5149,
      "y": 0.5239
    },
    "frame15": {
      "x": 0.5154,
      "y": 0.5237
    },
    "frame16": {
      "x": 0.515,
      "y": 0.5235
    },
    "frame17": {
      "x": 0.5152,
      "y": 0.5234
    },
    "frame18": {
      "x": 0.515,
      "y": 0.5231
    },
    "frame19": {
      "x": 0.5151,
      "y": 0.5233
    },
    "frame20": {
      "x": 0.5152,
      "y": 0.5235
    },
    "frame21": {
      "x": 0.5154,
      "y": 0.5235
    },
    "frame22": {
      "x": 0.5153,
      "y": 0.5234
    },
    "frame23": {
      "x": 0.5154,
      "y": 0.5235
    },
    "frame24": {
      "x": 0.5153,
      "y": 0.5234
    },
    "frame25": {
      "x": 0.5149,
      "y": 0.5232
    },
    "frame26": {
      "x": 0.5147,
      "y": 0.5229
    },
    "frame27": {
      "x": 0.515,
      "y": 0.5232
    },
    "frame8": {
      "x": 0.5075,
      "y": 0.5217
    },
    "frame9": {
      "x": 0.5088,
      "y": 0.5235
    },
    "frame39": {
      "x": 0.5035,
      "y": 0.5192
    },
    "frame80": {
      "x": 0.5082,
      "y": 0.5199
    },
    "frame81": {
      "x": 0.5125,
      "y": 0.5228
    },
    "frame82": {
      "x": 0.5128,
      "y": 0.5217
    },
    "frame84": {
      "x": 0.5112,
      "y": 0.5225
    },
    "frame5": {
      "x": 0.51,
      "y": 0.5216
    },
    "frame83": {
      "x": 0.5099,
      "y": 0.5247
    },
    "frame38": {
      "x": 0.507,
      "y": 0.5217
    },
    "frame1": {
      "x": 0.5124,
      "y": 0.5206
    },
    "frame100": {
      "x": 0.5124,
      "y": 0.5206
    },
    "frame101": {
      "x": 0.5124,
      "y": 0.5206
    },
    "frame102": {
      "x": 0.5124,
      "y": 0.5206
    },
    "frame98": {
      "x": 0.5124,
      "y": 0.5206
    },
    "frame99": {
      "x": 0.5124,
      "y": 0.5206
    },
    "frame36": {
      "x": 0.509,
      "y": 0.5245
    },
    "frame85": {
      "x": 0.5123,
      "y": 0.5204
    },
    "frame86": {
      "x": 0.512,
      "y": 0.5207
    },
    "frame87": {
      "x": 0.5128,
      "y": 0.5188
    },
    "frame88": {
      "x": 0.5133,
      "y": 0.5194
    },
    "frame89": {
      "x": 0.5128,
      "y": 0.5251
    },
    "frame90": {
      "x": 0.5135,
      "y": 0.5252
    },
    "frame91": {
      "x": 0.5146,
      "y": 0.5192
    },
    "frame92": {
      "x": 0.5146,
      "y": 0.5193
    },
    "frame93": {
      "x": 0.5138,
      "y": 0.5207
    },
    "frame94": {
      "x": 0.5136,
      "y": 0.5207
    },
    "frame95": {
      "x": 0.5134,
      "y": 0.5202
    },
    "frame96": {
      "x": 0.513,
      "y": 0.5203
    },
    "frame97": {
      "x": 0.5124,
      "y": 0.5206
    },
    "frame6": {
      "x": 0.5086,
      "y": 0.5257
    },
    "frame37": {
      "x": 0.5076,
      "y": 0.5254
    }
  },
  "p7a4": {
    "frame3": {
      "x": 0.5158,
      "y": 0.5188
    },
    "frame4": {
      "x": 0.5121,
      "y": 0.5206
    },
    "frame55": {
      "x": 0.502,
      "y": 0.5113
    },
    "frame6": {
      "x": 0.5141,
      "y": 0.5173
    },
    "frame5": {
      "x": 0.5132,
      "y": 0.5178
    },
    "frame2": {
      "x": 0.5127,
      "y": 0.5212
    },
    "frame62": {
      "x": 0.5117,
      "y": 0.5198
    },
    "frame63": {
      "x": 0.5119,
      "y": 0.52
    },
    "frame57": {
      "x": 0.509,
      "y": 0.5083
    },
    "frame60": {
      "x": 0.5087,
      "y": 0.5158
    },
    "frame61": {
      "x": 0.5082,
      "y": 0.5194
    },
    "frame54": {
      "x": 0.5002,
      "y": 0.5095
    },
    "frame56": {
      "x": 0.5031,
      "y": 0.5132
    },
    "frame58": {
      "x": 0.5034,
      "y": 0.5144
    },
    "frame59": {
      "x": 0.5037,
      "y": 0.5142
    },
    "frame7": {
      "x": 0.5144,
      "y": 0.5192
    },
    "frame8": {
      "x": 0.5175,
      "y": 0.5218
    },
    "frame1": {
      "x": 0.5124,
      "y": 0.5206
    },
    "frame68": {
      "x": 0.5124,
      "y": 0.5206
    },
    "frame69": {
      "x": 0.5124,
      "y": 0.5206
    },
    "frame70": {
      "x": 0.5124,
      "y": 0.5206
    },
    "frame71": {
      "x": 0.5124,
      "y": 0.5206
    },
    "frame72": {
      "x": 0.5124,
      "y": 0.5206
    },
    "frame64": {
      "x": 0.5127,
      "y": 0.5203
    },
    "frame65": {
      "x": 0.5126,
      "y": 0.5205
    },
    "frame66": {
      "x": 0.5124,
      "y": 0.5204
    },
    "frame67": {
      "x": 0.5125,
      "y": 0.5206
    },
    "frame52": {
      "x": 0.4986,
      "y": 0.5074
    },
    "frame53": {
      "x": 0.503,
      "y": 0.5066
    },
    "frame10": {
      "x": 0.5152,
      "y": 0.5183
    },
    "frame9": {
      "x": 0.5146,
      "y": 0.518
    },
    "frame12": {
      "x": 0.5183,
      "y": 0.5153
    },
    "frame11": {
      "x": 0.516,
      "y": 0.5128
    },
    "frame13": {
      "x": 0.5186,
      "y": 0.5134
    },
    "frame14": {
      "x": 0.5189,
      "y": 0.5133
    },
    "frame15": {
      "x": 0.5214,
      "y": 0.5125
    },
    "frame51": {
      "x": 0.5016,
      "y": 0.5037
    },
    "frame16": {
      "x": 0.5184,
      "y": 0.5116
    },
    "frame18": {
      "x": 0.5207,
      "y": 0.5117
    },
    "frame17": {
      "x": 0.519,
      "y": 0.5114
    },
    "frame19": {
      "x": 0.5252,
      "y": 0.5117
    },
    "frame20": {
      "x": 0.5193,
      "y": 0.5093
    },
    "frame21": {
      "x": 0.5188,
      "y": 0.5091
    },
    "frame22": {
      "x": 0.5152,
      "y": 0.5081
    },
    "frame23": {
      "x": 0.5162,
      "y": 0.506
    },
    "frame47": {
      "x": 0.4964,
      "y": 0.4917
    },
    "frame49": {
      "x": 0.5022,
      "y": 0.4985
    },
    "frame24": {
      "x": 0.5158,
      "y": 0.5035
    },
    "frame25": {
      "x": 0.5136,
      "y": 0.5054
    },
    "frame46": {
      "x": 0.4933,
      "y": 0.4904
    },
    "frame48": {
      "x": 0.4988,
      "y": 0.4971
    },
    "frame50": {
      "x": 0.5005,
      "y": 0.5084
    },
    "frame26": {
      "x": 0.5169,
      "y": 0.499
    },
    "frame27": {
      "x": 0.5154,
      "y": 0.4984
    },
    "frame28": {
      "x": 0.5181,
      "y": 0.4983
    },
    "frame44": {
      "x": 0.4965,
      "y": 0.4867
    },
    "frame45": {
      "x": 0.4978,
      "y": 0.4852
    },
    "frame29": {
      "x": 0.5172,
      "y": 0.4948
    },
    "frame30": {
      "x": 0.5141,
      "y": 0.4936
    },
    "frame31": {
      "x": 0.5123,
      "y": 0.4931
    },
    "frame32": {
      "x": 0.5154,
      "y": 0.4928
    },
    "frame33": {
      "x": 0.511,
      "y": 0.4899
    },
    "frame34": {
      "x": 0.5116,
      "y": 0.4906
    },
    "frame35": {
      "x": 0.5103,
      "y": 0.4895
    },
    "frame37": {
      "x": 0.5062,
      "y": 0.4947
    },
    "frame36": {
      "x": 0.5056,
      "y": 0.4891
    },
    "frame38": {
      "x": 0.503,
      "y": 0.4916
    },
    "frame39": {
      "x": 0.5043,
      "y": 0.4844
    },
    "frame40": {
      "x": 0.5006,
      "y": 0.4842
    },
    "frame41": {
      "x": 0.5018,
      "y": 0.4831
    },
    "frame42": {
      "x": 0.5024,
      "y": 0.4799
    },
    "frame43": {
      "x": 0.4985,
      "y": 0.4807
    }
  },
  "p8a1": {
    "frame19": {
      "x": 0.4243,
      "y": 0.5212
    },
    "frame20": {
      "x": 0.4239,
      "y": 0.5217
    },
    "frame21": {
      "x": 0.4249,
      "y": 0.5213
    },
    "frame1": {
      "x": 0.4231,
      "y": 0.521
    },
    "frame22": {
      "x": 0.4231,
      "y": 0.521
    },
    "frame10": {
      "x": 0.4214,
      "y": 0.5218
    },
    "frame11": {
      "x": 0.4218,
      "y": 0.5215
    },
    "frame12": {
      "x": 0.4214,
      "y": 0.5215
    },
    "frame13": {
      "x": 0.4214,
      "y": 0.5219
    },
    "frame14": {
      "x": 0.422,
      "y": 0.5233
    },
    "frame15": {
      "x": 0.4212,
      "y": 0.523
    },
    "frame16": {
      "x": 0.4213,
      "y": 0.5236
    },
    "frame17": {
      "x": 0.4211,
      "y": 0.5232
    },
    "frame18": {
      "x": 0.4217,
      "y": 0.5215
    },
    "frame2": {
      "x": 0.4224,
      "y": 0.5206
    },
    "frame3": {
      "x": 0.4219,
      "y": 0.5212
    },
    "frame4": {
      "x": 0.4229,
      "y": 0.5228
    },
    "frame5": {
      "x": 0.4228,
      "y": 0.5233
    },
    "frame6": {
      "x": 0.4223,
      "y": 0.5233
    },
    "frame7": {
      "x": 0.4216,
      "y": 0.523
    },
    "frame8": {
      "x": 0.4213,
      "y": 0.5224
    },
    "frame9": {
      "x": 0.4217,
      "y": 0.5222
    }
  },
  "p8a2": {
    "frame10": {
      "x": 0.4196,
      "y": 0.5266
    },
    "frame11": {
      "x": 0.4219,
      "y": 0.5236
    },
    "frame12": {
      "x": 0.4267,
      "y": 0.5183
    },
    "frame13": {
      "x": 0.4263,
      "y": 0.5187
    },
    "frame14": {
      "x": 0.4315,
      "y": 0.5136
    },
    "frame15": {
      "x": 0.4214,
      "y": 0.525
    },
    "frame16": {
      "x": 0.4196,
      "y": 0.5266
    },
    "frame17": {
      "x": 0.419,
      "y": 0.5287
    },
    "frame18": {
      "x": 0.4182,
      "y": 0.5281
    },
    "frame19": {
      "x": 0.421,
      "y": 0.5244
    },
    "frame20": {
      "x": 0.4269,
      "y": 0.5174
    },
    "frame21": {
      "x": 0.4295,
      "y": 0.5142
    },
    "frame22": {
      "x": 0.4264,
      "y": 0.5179
    },
    "frame23": {
      "x": 0.4245,
      "y": 0.519
    },
    "frame24": {
      "x": 0.4254,
      "y": 0.5184
    },
    "frame25": {
      "x": 0.4247,
      "y": 0.5202
    },
    "frame26": {
      "x": 0.4238,
      "y": 0.5197
    },
    "frame8": {
      "x": 0.4186,
      "y": 0.5275
    },
    "frame9": {
      "x": 0.4184,
      "y": 0.528
    },
    "frame27": {
      "x": 0.4255,
      "y": 0.5197
    },
    "frame1": {
      "x": 0.4231,
      "y": 0.521
    },
    "frame42": {
      "x": 0.4231,
      "y": 0.521
    },
    "frame2": {
      "x": 0.421,
      "y": 0.5235
    },
    "frame5": {
      "x": 0.4278,
      "y": 0.5111
    },
    "frame6": {
      "x": 0.4185,
      "y": 0.5228
    },
    "frame7": {
      "x": 0.4188,
      "y": 0.5239
    },
    "frame28": {
      "x": 0.4247,
      "y": 0.5214
    },
    "frame30": {
      "x": 0.42,
      "y": 0.5201
    },
    "frame31": {
      "x": 0.4169,
      "y": 0.5251
    },
    "frame4": {
      "x": 0.4212,
      "y": 0.5198
    },
    "frame29": {
      "x": 0.4242,
      "y": 0.5221
    },
    "frame3": {
      "x": 0.4178,
      "y": 0.5267
    },
    "frame32": {
      "x": 0.4229,
      "y": 0.522
    },
    "frame33": {
      "x": 0.4291,
      "y": 0.5155
    },
    "frame34": {
      "x": 0.4187,
      "y": 0.5271
    },
    "frame35": {
      "x": 0.4171,
      "y": 0.5287
    },
    "frame36": {
      "x": 0.4158,
      "y": 0.5303
    },
    "frame37": {
      "x": 0.4159,
      "y": 0.5299
    },
    "frame38": {
      "x": 0.4188,
      "y": 0.5265
    },
    "frame39": {
      "x": 0.4242,
      "y": 0.52
    },
    "frame40": {
      "x": 0.4263,
      "y": 0.5172
    },
    "frame41": {
      "x": 0.4234,
      "y": 0.5204
    }
  },
  "p8a3": {
    "frame23": {
      "x": 0.4169,
      "y": 0.5364
    },
    "frame24": {
      "x": 0.4175,
      "y": 0.5389
    },
    "frame25": {
      "x": 0.4242,
      "y": 0.5339
    },
    "frame26": {
      "x": 0.4246,
      "y": 0.5295
    },
    "frame13": {
      "x": 0.4273,
      "y": 0.5133
    },
    "frame14": {
      "x": 0.426,
      "y": 0.5138
    },
    "frame15": {
      "x": 0.4251,
      "y": 0.5162
    },
    "frame16": {
      "x": 0.4229,
      "y": 0.5191
    },
    "frame27": {
      "x": 0.4179,
      "y": 0.5289
    },
    "frame28": {
      "x": 0.4081,
      "y": 0.5394
    },
    "frame29": {
      "x": 0.4072,
      "y": 0.54
    },
    "frame30": {
      "x": 0.4078,
      "y": 0.5384
    },
    "frame4": {
      "x": 0.409,
      "y": 0.5371
    },
    "frame8": {
      "x": 0.4269,
      "y": 0.5129
    },
    "frame9": {
      "x": 0.4241,
      "y": 0.5134
    },
    "frame1": {
      "x": 0.4227,
      "y": 0.5206
    },
    "frame10": {
      "x": 0.4254,
      "y": 0.5156
    },
    "frame11": {
      "x": 0.4262,
      "y": 0.5131
    },
    "frame12": {
      "x": 0.4271,
      "y": 0.5118
    },
    "frame17": {
      "x": 0.4254,
      "y": 0.5175
    },
    "frame18": {
      "x": 0.4247,
      "y": 0.5167
    },
    "frame19": {
      "x": 0.4261,
      "y": 0.517
    },
    "frame2": {
      "x": 0.4173,
      "y": 0.526
    },
    "frame3": {
      "x": 0.4129,
      "y": 0.534
    },
    "frame31": {
      "x": 0.413,
      "y": 0.5322
    },
    "frame32": {
      "x": 0.4193,
      "y": 0.5241
    },
    "frame33": {
      "x": 0.4224,
      "y": 0.5215
    },
    "frame34": {
      "x": 0.4231,
      "y": 0.521
    },
    "frame5": {
      "x": 0.4128,
      "y": 0.5327
    },
    "frame20": {
      "x": 0.4275,
      "y": 0.5183
    },
    "frame6": {
      "x": 0.4212,
      "y": 0.5224
    },
    "frame21": {
      "x": 0.4251,
      "y": 0.5203
    },
    "frame7": {
      "x": 0.4286,
      "y": 0.5161
    },
    "frame22": {
      "x": 0.4242,
      "y": 0.5249
    }
  },
  "p8a4": {
    "frame25": {
      "x": 0.423,
      "y": 0.5319
    },
    "frame23": {
      "x": 0.4232,
      "y": 0.5385
    },
    "frame24": {
      "x": 0.4231,
      "y": 0.5316
    },
    "frame19": {
      "x": 0.4167,
      "y": 0.5445
    },
    "frame21": {
      "x": 0.4198,
      "y": 0.5419
    },
    "frame20": {
      "x": 0.4178,
      "y": 0.5453
    },
    "frame22": {
      "x": 0.4201,
      "y": 0.5404
    },
    "frame18": {
      "x": 0.4144,
      "y": 0.5443
    },
    "frame15": {
      "x": 0.412,
      "y": 0.5436
    },
    "frame16": {
      "x": 0.4119,
      "y": 0.5449
    },
    "frame17": {
      "x": 0.4115,
      "y": 0.5446
    },
    "frame26": {
      "x": 0.4226,
      "y": 0.5289
    },
    "frame10": {
      "x": 0.4088,
      "y": 0.5429
    },
    "frame11": {
      "x": 0.4072,
      "y": 0.5438
    },
    "frame12": {
      "x": 0.4075,
      "y": 0.5446
    },
    "frame13": {
      "x": 0.408,
      "y": 0.5444
    },
    "frame14": {
      "x": 0.4086,
      "y": 0.5434
    },
    "frame27": {
      "x": 0.4264,
      "y": 0.5219
    },
    "frame28": {
      "x": 0.428,
      "y": 0.5194
    },
    "frame8": {
      "x": 0.4106,
      "y": 0.5347
    },
    "frame9": {
      "x": 0.409,
      "y": 0.541
    },
    "frame6": {
      "x": 0.4152,
      "y": 0.531
    },
    "frame7": {
      "x": 0.4137,
      "y": 0.5324
    },
    "frame1": {
      "x": 0.4231,
      "y": 0.521
    },
    "frame38": {
      "x": 0.4231,
      "y": 0.521
    },
    "frame2": {
      "x": 0.4218,
      "y": 0.5222
    },
    "frame29": {
      "x": 0.425,
      "y": 0.5188
    },
    "frame3": {
      "x": 0.4203,
      "y": 0.5236
    },
    "frame30": {
      "x": 0.4228,
      "y": 0.5202
    },
    "frame31": {
      "x": 0.4196,
      "y": 0.5228
    },
    "frame32": {
      "x": 0.4161,
      "y": 0.5276
    },
    "frame33": {
      "x": 0.4154,
      "y": 0.5291
    },
    "frame34": {
      "x": 0.4146,
      "y": 0.5307
    },
    "frame35": {
      "x": 0.4132,
      "y": 0.532
    },
    "frame36": {
      "x": 0.4146,
      "y": 0.5298
    },
    "frame37": {
      "x": 0.4199,
      "y": 0.5238
    },
    "frame4": {
      "x": 0.4176,
      "y": 0.5266
    },
    "frame5": {
      "x": 0.4143,
      "y": 0.5291
    }
  },
  "p8a5": {
    "frame23": {
      "x": 0.5161,
      "y": 0.4745
    },
    "frame13": {
      "x": 0.5269,
      "y": 0.4682
    },
    "frame22": {
      "x": 0.545,
      "y": 0.4988
    },
    "frame10": {
      "x": 0.5052,
      "y": 0.4588
    },
    "frame11": {
      "x": 0.5053,
      "y": 0.4598
    },
    "frame14": {
      "x": 0.558,
      "y": 0.4894
    },
    "frame12": {
      "x": 0.5068,
      "y": 0.4635
    },
    "frame21": {
      "x": 0.5654,
      "y": 0.5079
    },
    "frame6": {
      "x": 0.496,
      "y": 0.4625
    },
    "frame7": {
      "x": 0.5055,
      "y": 0.4615
    },
    "frame20": {
      "x": 0.565,
      "y": 0.5125
    },
    "frame8": {
      "x": 0.5072,
      "y": 0.4585
    },
    "frame9": {
      "x": 0.5077,
      "y": 0.4571
    },
    "frame18": {
      "x": 0.5619,
      "y": 0.5151
    },
    "frame19": {
      "x": 0.5633,
      "y": 0.5143
    },
    "frame16": {
      "x": 0.5629,
      "y": 0.5153
    },
    "frame15": {
      "x": 0.5725,
      "y": 0.5079
    },
    "frame17": {
      "x": 0.56,
      "y": 0.5203
    },
    "frame5": {
      "x": 0.4699,
      "y": 0.4788
    },
    "frame24": {
      "x": 0.4766,
      "y": 0.4756
    },
    "frame3": {
      "x": 0.4132,
      "y": 0.4965
    },
    "frame25": {
      "x": 0.4324,
      "y": 0.4802
    },
    "frame4": {
      "x": 0.4386,
      "y": 0.494
    },
    "frame2": {
      "x": 0.4212,
      "y": 0.5154
    },
    "frame26": {
      "x": 0.4125,
      "y": 0.503
    },
    "frame31": {
      "x": 0.4216,
      "y": 0.5152
    },
    "frame32": {
      "x": 0.4209,
      "y": 0.5141
    },
    "frame33": {
      "x": 0.419,
      "y": 0.5162
    },
    "frame1": {
      "x": 0.4232,
      "y": 0.521
    },
    "frame35": {
      "x": 0.4232,
      "y": 0.521
    },
    "frame30": {
      "x": 0.423,
      "y": 0.5201
    },
    "frame34": {
      "x": 0.4191,
      "y": 0.5209
    },
    "frame27": {
      "x": 0.425,
      "y": 0.5273
    },
    "frame29": {
      "x": 0.4286,
      "y": 0.5314
    },
    "frame28": {
      "x": 0.4318,
      "y": 0.5378
    }
  },
  "p9a1": {
    "frame1": {
      "x": 0.5263,
      "y": 0.5047
    },
    "frame10": {
      "x": 0.5263,
      "y": 0.5047
    },
    "frame11": {
      "x": 0.5263,
      "y": 0.5047
    },
    "frame21": {
      "x": 0.5263,
      "y": 0.5047
    },
    "frame9": {
      "x": 0.5263,
      "y": 0.5047
    },
    "frame12": {
      "x": 0.525,
      "y": 0.5021
    },
    "frame13": {
      "x": 0.5254,
      "y": 0.503
    },
    "frame14": {
      "x": 0.5246,
      "y": 0.5018
    },
    "frame15": {
      "x": 0.5249,
      "y": 0.5025
    },
    "frame16": {
      "x": 0.5247,
      "y": 0.5021
    },
    "frame17": {
      "x": 0.5245,
      "y": 0.5017
    },
    "frame18": {
      "x": 0.5251,
      "y": 0.5029
    },
    "frame19": {
      "x": 0.5255,
      "y": 0.5031
    },
    "frame2": {
      "x": 0.5254,
      "y": 0.5029
    },
    "frame20": {
      "x": 0.5263,
      "y": 0.5049
    },
    "frame3": {
      "x": 0.5253,
      "y": 0.503
    },
    "frame4": {
      "x": 0.525,
      "y": 0.5025
    },
    "frame5": {
      "x": 0.5251,
      "y": 0.5028
    },
    "frame6": {
      "x": 0.5253,
      "y": 0.5032
    },
    "frame7": {
      "x": 0.5253,
      "y": 0.503
    },
    "frame8": {
      "x": 0.5264,
      "y": 0.505
    }
  },
  "p9a2": {
    "frame1": {
      "x": 0.5263,
      "y": 0.5047
    },
    "frame10": {
      "x": 0.5244,
      "y": 0.505
    },
    "frame11": {
      "x": 0.5251,
      "y": 0.5045
    },
    "frame12": {
      "x": 0.5256,
      "y": 0.5044
    },
    "frame13": {
      "x": 0.5274,
      "y": 0.5035
    },
    "frame14": {
      "x": 0.5271,
      "y": 0.5027
    },
    "frame2": {
      "x": 0.5267,
      "y": 0.5047
    },
    "frame3": {
      "x": 0.5238,
      "y": 0.5054
    },
    "frame4": {
      "x": 0.5205,
      "y": 0.5065
    },
    "frame46": {
      "x": 0.5307,
      "y": 0.5031
    },
    "frame47": {
      "x": 0.534,
      "y": 0.5033
    },
    "frame48": {
      "x": 0.5327,
      "y": 0.5038
    },
    "frame49": {
      "x": 0.5323,
      "y": 0.5034
    },
    "frame5": {
      "x": 0.5202,
      "y": 0.507
    },
    "frame50": {
      "x": 0.5327,
      "y": 0.503
    },
    "frame51": {
      "x": 0.5284,
      "y": 0.5035
    },
    "frame52": {
      "x": 0.5293,
      "y": 0.5046
    },
    "frame53": {
      "x": 0.5258,
      "y": 0.5053
    },
    "frame54": {
      "x": 0.5243,
      "y": 0.5062
    },
    "frame55": {
      "x": 0.5252,
      "y": 0.5063
    },
    "frame56": {
      "x": 0.5256,
      "y": 0.5057
    },
    "frame57": {
      "x": 0.5262,
      "y": 0.5053
    },
    "frame58": {
      "x": 0.5279,
      "y": 0.5051
    },
    "frame59": {
      "x": 0.5298,
      "y": 0.5046
    },
    "frame6": {
      "x": 0.5211,
      "y": 0.507
    },
    "frame60": {
      "x": 0.5265,
      "y": 0.5046
    },
    "frame61": {
      "x": 0.5262,
      "y": 0.5044
    },
    "frame62": {
      "x": 0.5255,
      "y": 0.5043
    },
    "frame63": {
      "x": 0.5257,
      "y": 0.5043
    },
    "frame64": {
      "x": 0.5262,
      "y": 0.5047
    },
    "frame65": {
      "x": 0.5261,
      "y": 0.5047
    },
    "frame7": {
      "x": 0.5211,
      "y": 0.5067
    },
    "frame8": {
      "x": 0.5194,
      "y": 0.507
    },
    "frame9": {
      "x": 0.5244,
      "y": 0.5057
    },
    "frame15": {
      "x": 0.5274,
      "y": 0.5053
    },
    "frame16": {
      "x": 0.5275,
      "y": 0.505
    },
    "frame17": {
      "x": 0.5274,
      "y": 0.5051
    },
    "frame18": {
      "x": 0.5274,
      "y": 0.5051
    },
    "frame19": {
      "x": 0.5247,
      "y": 0.5059
    },
    "frame20": {
      "x": 0.5231,
      "y": 0.5067
    },
    "frame21": {
      "x": 0.5232,
      "y": 0.5071
    },
    "frame22": {
      "x": 0.5234,
      "y": 0.5081
    },
    "frame23": {
      "x": 0.5262,
      "y": 0.507
    },
    "frame24": {
      "x": 0.5229,
      "y": 0.5083
    },
    "frame25": {
      "x": 0.5237,
      "y": 0.5072
    },
    "frame26": {
      "x": 0.5262,
      "y": 0.508
    },
    "frame27": {
      "x": 0.5268,
      "y": 0.5081
    },
    "frame28": {
      "x": 0.527,
      "y": 0.5081
    },
    "frame29": {
      "x": 0.5256,
      "y": 0.5084
    },
    "frame30": {
      "x": 0.5252,
      "y": 0.5077
    },
    "frame31": {
      "x": 0.5238,
      "y": 0.5073
    },
    "frame32": {
      "x": 0.5241,
      "y": 0.5076
    },
    "frame33": {
      "x": 0.5228,
      "y": 0.5074
    },
    "frame34": {
      "x": 0.523,
      "y": 0.5074
    },
    "frame35": {
      "x": 0.5222,
      "y": 0.5072
    },
    "frame36": {
      "x": 0.5232,
      "y": 0.507
    },
    "frame37": {
      "x": 0.5224,
      "y": 0.5066
    },
    "frame38": {
      "x": 0.5227,
      "y": 0.5065
    },
    "frame39": {
      "x": 0.5228,
      "y": 0.5071
    },
    "frame40": {
      "x": 0.5218,
      "y": 0.5065
    },
    "frame41": {
      "x": 0.5224,
      "y": 0.5059
    },
    "frame42": {
      "x": 0.5217,
      "y": 0.5065
    },
    "frame43": {
      "x": 0.5224,
      "y": 0.5057
    },
    "frame44": {
      "x": 0.5281,
      "y": 0.5056
    },
    "frame45": {
      "x": 0.5323,
      "y": 0.5049
    }
  },
  "p9a3": {
    "frame1": {
      "x": 0.5263,
      "y": 0.5047
    },
    "frame58": {
      "x": 0.5263,
      "y": 0.5047
    },
    "frame10": {
      "x": 0.5217,
      "y": 0.5065
    },
    "frame11": {
      "x": 0.5194,
      "y": 0.5062
    },
    "frame2": {
      "x": 0.5211,
      "y": 0.5065
    },
    "frame3": {
      "x": 0.5163,
      "y": 0.5085
    },
    "frame4": {
      "x": 0.516,
      "y": 0.5108
    },
    "frame42": {
      "x": 0.5279,
      "y": 0.5009
    },
    "frame43": {
      "x": 0.5302,
      "y": 0.5008
    },
    "frame44": {
      "x": 0.5291,
      "y": 0.5021
    },
    "frame45": {
      "x": 0.5298,
      "y": 0.5026
    },
    "frame46": {
      "x": 0.5305,
      "y": 0.5031
    },
    "frame47": {
      "x": 0.5263,
      "y": 0.5039
    },
    "frame48": {
      "x": 0.5281,
      "y": 0.5055
    },
    "frame49": {
      "x": 0.5306,
      "y": 0.5067
    },
    "frame5": {
      "x": 0.5158,
      "y": 0.5112
    },
    "frame50": {
      "x": 0.5311,
      "y": 0.5078
    },
    "frame51": {
      "x": 0.5301,
      "y": 0.5069
    },
    "frame52": {
      "x": 0.5281,
      "y": 0.5059
    },
    "frame53": {
      "x": 0.5283,
      "y": 0.5057
    },
    "frame54": {
      "x": 0.5279,
      "y": 0.5048
    },
    "frame55": {
      "x": 0.5291,
      "y": 0.5047
    },
    "frame56": {
      "x": 0.5264,
      "y": 0.5047
    },
    "frame57": {
      "x": 0.5264,
      "y": 0.5047
    },
    "frame6": {
      "x": 0.5198,
      "y": 0.5105
    },
    "frame7": {
      "x": 0.5198,
      "y": 0.5104
    },
    "frame8": {
      "x": 0.5185,
      "y": 0.5102
    },
    "frame9": {
      "x": 0.5182,
      "y": 0.5096
    },
    "frame12": {
      "x": 0.519,
      "y": 0.5047
    },
    "frame13": {
      "x": 0.5184,
      "y": 0.5027
    },
    "frame14": {
      "x": 0.5165,
      "y": 0.5015
    },
    "frame15": {
      "x": 0.5175,
      "y": 0.5013
    },
    "frame16": {
      "x": 0.5175,
      "y": 0.5014
    },
    "frame17": {
      "x": 0.5173,
      "y": 0.5003
    },
    "frame18": {
      "x": 0.5173,
      "y": 0.5026
    },
    "frame19": {
      "x": 0.5176,
      "y": 0.5018
    },
    "frame20": {
      "x": 0.5163,
      "y": 0.5018
    },
    "frame21": {
      "x": 0.5194,
      "y": 0.5015
    },
    "frame22": {
      "x": 0.5196,
      "y": 0.5014
    },
    "frame23": {
      "x": 0.5196,
      "y": 0.5013
    },
    "frame24": {
      "x": 0.5187,
      "y": 0.502
    },
    "frame25": {
      "x": 0.5192,
      "y": 0.5018
    },
    "frame26": {
      "x": 0.5189,
      "y": 0.5023
    },
    "frame27": {
      "x": 0.5193,
      "y": 0.5022
    },
    "frame28": {
      "x": 0.5179,
      "y": 0.5028
    },
    "frame31": {
      "x": 0.5222,
      "y": 0.5023
    },
    "frame29": {
      "x": 0.5183,
      "y": 0.5025
    },
    "frame30": {
      "x": 0.5185,
      "y": 0.5024
    },
    "frame32": {
      "x": 0.522,
      "y": 0.5027
    },
    "frame33": {
      "x": 0.5226,
      "y": 0.5028
    },
    "frame34": {
      "x": 0.5217,
      "y": 0.5035
    },
    "frame35": {
      "x": 0.5227,
      "y": 0.503
    },
    "frame36": {
      "x": 0.5188,
      "y": 0.5034
    },
    "frame37": {
      "x": 0.5186,
      "y": 0.5034
    },
    "frame38": {
      "x": 0.5184,
      "y": 0.5037
    },
    "frame39": {
      "x": 0.5186,
      "y": 0.5036
    },
    "frame40": {
      "x": 0.5188,
      "y": 0.5038
    },
    "frame41": {
      "x": 0.5225,
      "y": 0.503
    }
  },
  "p9a4": {
    "frame44": {
      "x": 0.5285,
      "y": 0.515
    },
    "frame45": {
      "x": 0.5267,
      "y": 0.5154
    },
    "frame46": {
      "x": 0.5243,
      "y": 0.5124
    },
    "frame47": {
      "x": 0.5238,
      "y": 0.512
    },
    "frame48": {
      "x": 0.5255,
      "y": 0.5113
    },
    "frame50": {
      "x": 0.5212,
      "y": 0.5078
    },
    "frame43": {
      "x": 0.5337,
      "y": 0.5153
    },
    "frame51": {
      "x": 0.5282,
      "y": 0.5059
    },
    "frame49": {
      "x": 0.5217,
      "y": 0.5078
    },
    "frame52": {
      "x": 0.5293,
      "y": 0.5029
    },
    "frame53": {
      "x": 0.5283,
      "y": 0.5023
    },
    "frame42": {
      "x": 0.5389,
      "y": 0.5121
    },
    "frame54": {
      "x": 0.5279,
      "y": 0.5035
    },
    "frame55": {
      "x": 0.5287,
      "y": 0.5036
    },
    "frame56": {
      "x": 0.5275,
      "y": 0.5039
    },
    "frame57": {
      "x": 0.5285,
      "y": 0.5039
    },
    "frame1": {
      "x": 0.5251,
      "y": 0.5041
    },
    "frame60": {
      "x": 0.5251,
      "y": 0.5041
    },
    "frame10": {
      "x": 0.5194,
      "y": 0.5045
    },
    "frame11": {
      "x": 0.5189,
      "y": 0.5052
    },
    "frame12": {
      "x": 0.519,
      "y": 0.5056
    },
    "frame13": {
      "x": 0.5177,
      "y": 0.5063
    },
    "frame14": {
      "x": 0.5184,
      "y": 0.5075
    },
    "frame15": {
      "x": 0.5184,
      "y": 0.5069
    },
    "frame16": {
      "x": 0.5179,
      "y": 0.505
    },
    "frame17": {
      "x": 0.5188,
      "y": 0.5057
    },
    "frame18": {
      "x": 0.5177,
      "y": 0.5072
    },
    "frame2": {
      "x": 0.524,
      "y": 0.5018
    },
    "frame27": {
      "x": 0.519,
      "y": 0.5006
    },
    "frame3": {
      "x": 0.5244,
      "y": 0.5022
    },
    "frame4": {
      "x": 0.523,
      "y": 0.5024
    },
    "frame40": {
      "x": 0.5336,
      "y": 0.5053
    },
    "frame5": {
      "x": 0.5219,
      "y": 0.5027
    },
    "frame58": {
      "x": 0.5249,
      "y": 0.5042
    },
    "frame59": {
      "x": 0.5252,
      "y": 0.5042
    },
    "frame6": {
      "x": 0.5207,
      "y": 0.5031
    },
    "frame7": {
      "x": 0.5203,
      "y": 0.5033
    },
    "frame8": {
      "x": 0.5206,
      "y": 0.5036
    },
    "frame9": {
      "x": 0.5196,
      "y": 0.5042
    },
    "frame41": {
      "x": 0.5372,
      "y": 0.5099
    },
    "frame19": {
      "x": 0.5175,
      "y": 0.5051
    },
    "frame28": {
      "x": 0.5147,
      "y": 0.5004
    },
    "frame20": {
      "x": 0.5178,
      "y": 0.5042
    },
    "frame22": {
      "x": 0.5178,
      "y": 0.5046
    },
    "frame23": {
      "x": 0.5178,
      "y": 0.5033
    },
    "frame24": {
      "x": 0.5192,
      "y": 0.5011
    },
    "frame25": {
      "x": 0.5183,
      "y": 0.4993
    },
    "frame26": {
      "x": 0.5184,
      "y": 0.4981
    },
    "frame38": {
      "x": 0.5233,
      "y": 0.4981
    },
    "frame21": {
      "x": 0.514,
      "y": 0.5044
    },
    "frame29": {
      "x": 0.5128,
      "y": 0.496
    },
    "frame30": {
      "x": 0.5071,
      "y": 0.4953
    },
    "frame39": {
      "x": 0.5286,
      "y": 0.5031
    },
    "frame37": {
      "x": 0.5132,
      "y": 0.4926
    },
    "frame31": {
      "x": 0.5073,
      "y": 0.4889
    },
    "frame36": {
      "x": 0.5096,
      "y": 0.4889
    },
    "frame32": {
      "x": 0.5063,
      "y": 0.4866
    },
    "frame33": {
      "x": 0.51,
      "y": 0.484
    },
    "frame35": {
      "x": 0.5084,
      "y": 0.4844
    },
    "frame34": {
      "x": 0.5085,
      "y": 0.4816
    }
  },
  "p9a5": {
    "frame1": {
      "x": 0.5266,
      "y": 0.5087
    },
    "frame71": {
      "x": 0.5266,
      "y": 0.5087
    },
    "frame65": {
      "x": 0.5227,
      "y": 0.5083
    },
    "frame66": {
      "x": 0.5281,
      "y": 0.5103
    },
    "frame67": {
      "x": 0.5265,
      "y": 0.5093
    },
    "frame68": {
      "x": 0.5259,
      "y": 0.5086
    },
    "frame69": {
      "x": 0.5269,
      "y": 0.5088
    },
    "frame70": {
      "x": 0.5264,
      "y": 0.5086
    },
    "frame2": {
      "x": 0.5256,
      "y": 0.5127
    },
    "frame64": {
      "x": 0.5215,
      "y": 0.5088
    },
    "frame8": {
      "x": 0.5287,
      "y": 0.518
    },
    "frame9": {
      "x": 0.528,
      "y": 0.5047
    },
    "frame63": {
      "x": 0.5355,
      "y": 0.5068
    },
    "frame3": {
      "x": 0.5287,
      "y": 0.5185
    },
    "frame10": {
      "x": 0.5304,
      "y": 0.4923
    },
    "frame4": {
      "x": 0.5269,
      "y": 0.5233
    },
    "frame5": {
      "x": 0.5271,
      "y": 0.5252
    },
    "frame6": {
      "x": 0.5278,
      "y": 0.5268
    },
    "frame7": {
      "x": 0.53,
      "y": 0.5243
    },
    "frame62": {
      "x": 0.5321,
      "y": 0.505
    },
    "frame61": {
      "x": 0.5319,
      "y": 0.5096
    },
    "frame60": {
      "x": 0.5295,
      "y": 0.5166
    },
    "frame55": {
      "x": 0.6374,
      "y": 0.6372
    },
    "frame54": {
      "x": 0.6291,
      "y": 0.6363
    },
    "frame56": {
      "x": 0.6157,
      "y": 0.6416
    },
    "frame53": {
      "x": 0.608,
      "y": 0.6258
    },
    "frame52": {
      "x": 0.587,
      "y": 0.6201
    },
    "frame51": {
      "x": 0.5777,
      "y": 0.6204
    },
    "frame49": {
      "x": 0.5836,
      "y": 0.6186
    },
    "frame50": {
      "x": 0.5825,
      "y": 0.6193
    },
    "frame33": {
      "x": 0.581,
      "y": 0.6249
    },
    "frame47": {
      "x": 0.579,
      "y": 0.6136
    },
    "frame48": {
      "x": 0.58,
      "y": 0.6163
    },
    "frame32": {
      "x": 0.5697,
      "y": 0.6396
    },
    "frame34": {
      "x": 0.5837,
      "y": 0.6207
    },
    "frame35": {
      "x": 0.579,
      "y": 0.6176
    },
    "frame36": {
      "x": 0.5799,
      "y": 0.6164
    },
    "frame37": {
      "x": 0.5832,
      "y": 0.616
    },
    "frame38": {
      "x": 0.5844,
      "y": 0.6152
    },
    "frame39": {
      "x": 0.5835,
      "y": 0.6157
    },
    "frame40": {
      "x": 0.5832,
      "y": 0.6159
    },
    "frame41": {
      "x": 0.5844,
      "y": 0.6155
    },
    "frame42": {
      "x": 0.5844,
      "y": 0.6153
    },
    "frame43": {
      "x": 0.5827,
      "y": 0.6143
    },
    "frame44": {
      "x": 0.5825,
      "y": 0.6138
    },
    "frame45": {
      "x": 0.5833,
      "y": 0.6139
    },
    "frame46": {
      "x": 0.5794,
      "y": 0.6134
    },
    "frame57": {
      "x": 0.5644,
      "y": 0.6575
    },
    "frame31": {
      "x": 0.5558,
      "y": 0.656
    },
    "frame29": {
      "x": 0.5088,
      "y": 0.6694
    },
    "frame30": {
      "x": 0.5309,
      "y": 0.6659
    },
    "frame24": {
      "x": 0.4929,
      "y": 0.6655
    },
    "frame25": {
      "x": 0.4933,
      "y": 0.6657
    },
    "frame26": {
      "x": 0.4952,
      "y": 0.6664
    },
    "frame28": {
      "x": 0.5007,
      "y": 0.6725
    },
    "frame23": {
      "x": 0.4957,
      "y": 0.6667
    },
    "frame27": {
      "x": 0.5017,
      "y": 0.6723
    },
    "frame22": {
      "x": 0.4974,
      "y": 0.6666
    },
    "frame11": {
      "x": 0.5244,
      "y": 0.5858
    },
    "frame12": {
      "x": 0.5319,
      "y": 0.5955
    },
    "frame13": {
      "x": 0.5291,
      "y": 0.6209
    },
    "frame14": {
      "x": 0.4686,
      "y": 0.6445
    },
    "frame15": {
      "x": 0.5166,
      "y": 0.6234
    },
    "frame16": {
      "x": 0.5289,
      "y": 0.6218
    },
    "frame17": {
      "x": 0.5431,
      "y": 0.6391
    },
    "frame18": {
      "x": 0.5753,
      "y": 0.6572
    },
    "frame19": {
      "x": 0.543,
      "y": 0.6368
    },
    "frame20": {
      "x": 0.533,
      "y": 0.6295
    },
    "frame21": {
      "x": 0.5237,
      "y": 0.6484
    },
    "frame58": {
      "x": 0.5268,
      "y": 0.6094
    },
    "frame59": {
      "x": 0.5241,
      "y": 0.6171
    }
  }
};

export const PUPPY_MAX_DIM: Record<string, number> = {
  "1": 172,
  "2": 177,
  "3": 174,
  "4": 173,
  "5": 177,
  "6": 176,
  "7": 175,
  "8": 175,
  "9": 169,
  "10": 174
};
